import React, { useEffect, useRef, useState, useMemo, useCallback, memo } from 'react';
import { useDispatch } from 'react-redux'
import { Stage, Layer, Shape, Image as KonvaImage, Rect, Line, Circle } from "react-konva";
import Konva from 'konva';
import { exportStageSVG } from 'react-konva-to-svg';
import { flushSync } from 'react-dom';
import { optimize } from 'svgo';
import {
  IconButton,
  Grid,
  TextField,
  Tooltip,
  Box,
  Typography,
  Button,
  makeStyles,
  Drawer,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Menu,
  MenuItem,
  Select,
  TableContainer,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Table,
  Checkbox,
  FormControlLabel
} from '@material-ui/core';
import TreeItem from '@material-ui/lab/TreeItem';
import Draggable from 'react-draggable';
import TimelineIcon from '@material-ui/icons/Timeline';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import GridOnIcon from '@material-ui/icons/GridOn';
import PanToolIcon from '@material-ui/icons/PanTool';
import GestureIcon from '@material-ui/icons/Gesture';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HeightIcon from '@material-ui/icons/Height';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PublishIcon from '@material-ui/icons/Publish';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import UpdateIcon from '@material-ui/icons/Update';
import InfoIcon from '@material-ui/icons/Info';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import SettingsIcon from '@material-ui/icons/Settings';
import GetAppIcon from '@material-ui/icons/GetApp';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ColumnHandler from './ColumnTypes/columnHandler';
import tourActions from '../store/actions/tourActions';
import Mask from './mask.component';
import CanvasGrid from './grid.component';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import RectangleIcon from '@mui/icons-material/Rectangle';
import RefreshIcon from '@material-ui/icons/Refresh';
import LuminCard from '../components/Column/LuminCard';
import { useSelector } from 'react-redux';
import EdgeOrREST from '../EdgeOrREST';
import { API_OBJECTS } from '../API/model/calculation.model';
import * as d3 from 'd3';
import ColumnEditor from './column-editor.component';
import MaskEditor from './mask-editor.component';
import GridEditor from './grid-editor.component';
import TemplateEditor from '../report/templateEditor';
import CustomMask from './custom-mask.component';
import ThreeDView from './3D/ThreeDView';
import Notification from '../components/shared/notification.component';
import planActions from '../store/actions/planActions';
import luminaireActions from '../store/actions/luminaireActions';
import PhotometricInformation from '../photometricManager/photometric-information.component';
import { HexColorPicker } from 'react-colorful';
import { v4 as uuidv4 } from 'uuid';
import notificationActions from '../store/actions/notificationActions';
import { AddPhotoAlternate, Straighten } from '@material-ui/icons';
import Page from '../components/Page';
import ContourMapLayer from './contour-map-layer.component';
import MarkEditor from './markEditor.component';
import Mark from './mark.component';
import PNGConvertIcon from './images/PNGConvert.png';
import CADConvertIcon from './images/CADConvert.png';
import ContourValues from '../components/Settings/Comp_Contour_Values';
import { use } from 'react';
import roadActions from '../store/actions/roadActions';
import DxfParser from 'dxf-parser';
import { DxfViewer } from 'dxf-viewer';
import * as THREE from 'three';
import ReportCapture from './report-capture.component';
import ReportCaptureEditor from './report-capture-editor.component';
import ReportActions from '../report/ReportActions';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { usePrompt } from 'react-router-dom';
import circlerightradius from './images/arrow-circle.png';

function transformAsImage(widthScale, heightScale, angle) {
  var rad = angle * Math.PI / 180;
  var cos = Math.cos(rad);
  var sin = Math.sin(rad);

  return d3.geoTransform({
    point: function (x, y) {
      var xRotated = x * cos - y * sin; var yRotated = x * sin + y * cos;
      this.stream.point((xRotated * widthScale), (yRotated * heightScale));

    }
  });
}

const DEFAULT_DXF_PLACEHOLDER_SIZE_METRES = 250;
const MIN_DXF_DIMENSION_METRES = 1;
const DEFAULT_PLACEHOLDER_DISPLAY_ZOOM = 1.25;
const DEFAULT_COLUMN_COLOR = '#FFA500';

function createDefaultColumnSetting() {
  return {
    dimFactor: 1,
    columnGrid: 0,
    height: 6,
    maintenanceFactor: 1,
    outreach: 1,
    cant: 0,
    tilt: 0,
  };
}

function normalizeColumnSettings(settings, total = 0) {
  const normalizedSettings = Array.isArray(settings)
    ? settings
      .filter(Boolean)
      .map((setting) => ({
        ...createDefaultColumnSetting(),
        ...setting,
      }))
    : [];

  while (normalizedSettings.length < total) {
    normalizedSettings.push(createDefaultColumnSetting());
  }

  return normalizedSettings;
}

function generateBasicBorderDxf(width = DEFAULT_DXF_PLACEHOLDER_SIZE_METRES, height = DEFAULT_DXF_PLACEHOLDER_SIZE_METRES) {
  return [
    '0',
    'SECTION',
    '2',
    'HEADER',
    '9',
    '$INSUNITS',
    '70',
    '6',
    '9',
    '$EXTMIN',
    '10',
    '0',
    '20',
    '0',
    '30',
    '0',
    '9',
    '$EXTMAX',
    '10',
    String(width),
    '20',
    String(height),
    '30',
    '0',
    '0',
    'ENDSEC',
    '0',
    'SECTION',
    '2',
    'TABLES',
    '0',
    'TABLE',
    '2',
    'LAYER',
    '70',
    '1',
    '0',
    'LAYER',
    '2',
    '0',
    '70',
    '0',
    '62',
    '7',
    '6',
    'CONTINUOUS',
    '0',
    'ENDTAB',
    '0',
    'ENDSEC',
    '0',
    'SECTION',
    '2',
    'ENTITIES',
    '0',
    'LINE',
    '8',
    '0',
    '10',
    '0',
    '20',
    '0',
    '11',
    String(width),
    '21',
    '0',
    '0',
    'LINE',
    '8',
    '0',
    '10',
    String(width),
    '20',
    '0',
    '11',
    String(width),
    '21',
    String(height),
    '0',
    'LINE',
    '8',
    '0',
    '10',
    String(width),
    '20',
    String(height),
    '11',
    '0',
    '21',
    String(height),
    '0',
    'LINE',
    '8',
    '0',
    '10',
    '0',
    '20',
    String(height),
    '11',
    '0',
    '21',
    '0',
    '0',
    'ENDSEC',
    '0',
    'EOF',
  ].join('\n');
}

const useStyles = makeStyles((theme) => ({
  drawer: {
    position: 'relative',
    '& .MuiDrawer-paper': {
      top: '64px',
      height: `calc(100% - 64px)`,
      zIndex: 1000
    },
  },
}));

function useThrottle(callback, delay) {
  const lastCall = useRef(0);

  return useCallback((...args) => {
    const now = Date.now();
    if (now - lastCall.current >= delay) {
      lastCall.current = now;
      callback(...args);
    }
  }, [callback, delay]);
}

export default function PlanDashboard() {
  const state = useSelector(state => state);
  const classes = useStyles();
  const dispatch = useDispatch();

  const contourGridLayerRef = React.useRef();
  const gridTrRef = React.useRef();
  const isPanningRef = useRef(false);
  const lastPointerRef = useRef(null);
  const panFramePendingRef = useRef(false);
  const panPointerRef = useRef(null);
  const loadingConfigRef = useRef(false);
  const imageRef = React.useRef();
  const imageLayerRef = React.useRef();
  const stageRef = React.useRef();
  const contourImageRef = React.useRef();
  const contourLayerRef = React.useRef();
  const contourShapeRef = React.useRef();
  const planRef = React.useRef();
  const linesLayerRef = React.useRef();
  const scaleInputRef = React.useRef(null);
  const layerRef = React.useRef();
  const dxfContainerRef = React.useRef();
  const uuidToLayerRef = useRef({});
  const pickableObjectsRef = useRef([]);
  const showTimerRef = useRef(null);
  const [hoveredMeshUuid, setHoveredMeshUuid] = useState(null);
  const originalMaterialRef = useRef(null);
  const raycasterRef = useRef(new THREE.Raycaster());
  const dxfWorldPlaneRef = useRef(new THREE.Plane(new THREE.Vector3(0, 0, 1), 0));
  const placeholderDxfLoadedRef = useRef(false);
  const [hoverLayer, setHoverLayer] = useState(null);
  const [parsedEntities, setParsedEntities] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [annotateMode, setAnnotateMode] = React.useState(false);
  const [showContours, setShowContours] = React.useState(false);
  const [showMark, setShowMark] = React.useState(false);

  const [viewer, setViewer] = useState(null);
  const [dxfCanvas, setDxfCanvas] = useState(null);
  const polarFetchPendingRef = useRef(new Set());
  const [lines, setLines] = React.useState([]);
  const [image, setImage] = React.useState(null);
  const [imagePixelHeight, setImagePixelHeight] = React.useState(0);
  const [imagePixelWidth, setImagePixelWidth] = React.useState(0);

  const [newGridXStart, setNewGridXStart] = React.useState(0);
  const [newGridYStart, setNewGridYStart] = React.useState(0);
  const [newGridHeight, setNewGridHeight] = React.useState(50);
  const [newGridWidth, setNewGridWidth] = React.useState(50);
  const [newGridShowResults, setNewGridShowResults] = React.useState(false);
  const [allLayersVisible, setAllLayersVisible] = React.useState(true);
  const [throttleSceneFunc, setThrottleSceneFunc] = React.useState(true);
  const [realWorldHeight, setRealWorldHeight] = React.useState(500);
  const [realWorldWidth, setRealWorldWidth] = React.useState(800);
  const [gridScaleX, setGridScaleX] = React.useState(1);
  const [gridScaleY, setGridScaleY] = React.useState(1);
  const [gridOffsetX, setGridOffsetX] = React.useState(0);
  const [gridOffsetY, setGridOffsetY] = React.useState(0);
  const [gridResultsMinimum, setGridResultsMinimum] = React.useState(3);
  const [metresPerPixelX, setMetresPerPixelX] = React.useState(1);
  const [metresPerPixelY, setMetresPerPixelY] = React.useState(1);
  const [contourImage, setContourImage] = React.useState(null);
  const [columns, setColumns] = React.useState([]);
  const [maskMode, setMaskMode] = React.useState(false);
  const [masks, setMasks] = React.useState([]);
  const [showAllMasks, setShowAllMasks] = React.useState(true);
  const [stage, setStage] = React.useState({
    scale: 1,
    x: 0,
    y: 0,
  });

  const [polarInfo, setPolarInfo] = useState(null);
  const [areaResults, setAreaResults] = React.useState([]);
  const [areaGridResults, setAreaGridResults] = React.useState([]);
  const [contourGridResults, setContourGridResults] = React.useState([]);
  const [visualGrid, setVisualGrid] = React.useState({
    x: 0,
    y: 0,
    height: 100,
    width: 100
  })
  const [startCalc, setStartCalc] = React.useState(Date.now());
  const areaCalcMessageRef = React.useRef("plan update");
  const [grids, setGrids] = React.useState([{
    selected: false,
    name: "Grid #0",
    angle: 0,
    showResults: false,
    id: 0,
    maskAll: "False",
    maskingLayer: "0",
    obsAngle: 0,
    obsHeight: 1.5,
    xSpacing: 1.5,
    ySpacing: 1.5,
    showValues: true,
    visible: false,
    edgeStart: false,
    opacity: 1,
    origin:
    {
      x: {
        start: 0,
        length: 25
      },
      y: {
        start: 0,
        length: 25
      },
      z: {
        start: 0,
        length: 0
      }
    },
    maxSpacing: 1.5,
    type: "Horizontal",
    verticalGridSide: "False"
  }]);

  const triggerAreaCalc = React.useCallback((message = "plan update") => {
    areaCalcMessageRef.current = message;
    setStartCalc(Date.now());
  }, []);
  const [isDrawing, setIsDrawing] = React.useState(false);
  const [drawings, setDrawings] = React.useState([]);
  const [currentDrawingId, setCurrentDrawingId] = React.useState(null);
  const [layers, setLayers] = React.useState([]);
  const [currentLine, setCurrentLine] = React.useState(null);
  const [previewPoint, setPreviewPoint] = useState(null);
  const [scaleFactor, setScaleFactor] = useState(1);
  const [dxfScale, setDxfScale] = useState(1);
  const [dxfScaleInput, setDxfScaleInput] = useState(dxfScale);
  const [originalScaleFactor, setOriginalScaleFactor] = useState(1);
  const [scaleOverrideInput, setScaleOverrideInput] = useState('');
  const [scaleOverride, setScaleOverride] = useState(null);
  const overlayScale = viewer ? 1 : dxfScale;
  const [isStageYUp, setIsStageYUp] = useState(false);
  const worldHeightValue = (Number.isFinite(realWorldHeight) && realWorldHeight > 0)
    ? realWorldHeight
    : (Number(visualGrid?.height) || Number(grids?.[0]?.origin?.y?.length) || 0);
  const shouldFlipY = Boolean(viewer && !isStageYUp && worldHeightValue > 0);
  const toWorldY = (y) => (shouldFlipY ? (worldHeightValue - y) : y);
  const lastParsedDxfRef = useRef(null);
  const [containerSize, setContainerSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [measureMode, setMeasureMode] = React.useState(false);
  const [measureStartPoint, setMeasureStartPoint] = React.useState(null);
  const [measureDistance, setMeasureDistance] = React.useState(0);
  const [measureLine, setMeasureLine] = React.useState([]);
  const [leftDrawerOpen, setLeftDrawerOpen] = React.useState(true);
  const [rightDrawerOpen, setRightDrawerOpen] = React.useState(true);
  const [uploadAreaOpen, setUploadAreaOpen] = React.useState(false);
  const [contourSettingsOpen, setContourSettingsOpen] = React.useState(false);
  const [markOpen, setMarkOpen] = React.useState(false);
  const [markDetails, setMarkDetails] = React.useState({});
  const [threeDView, set3dView] = React.useState(false);
  const [luminNameList, setLuminNameList] = React.useState([]);
  const [numberOfLuminaires, setNumberOfLuminaires] = React.useState(0);
  const [luminName, setLuminName] = React.useState("");
  const [addLuminOpen, setAddLuminOpen] = React.useState(false);
  const [luminInfoOpen, setLuminInfoOpen] = React.useState(false);
  const [luminSettingOpen, setLuminSettingOpen] = React.useState(false);
  const [infoLumin, setInfoLumin] = React.useState(0);
  const [cursorType, setCursorType] = React.useState('default');
  const [mousePosition, setMousePosition] = React.useState({ x: 0, y: 0 });
  const [mouseCoords, setMouseCoords] = React.useState({ x: 0, y: 0 });
  const [currentLuminId, setCurrentLuminId] = React.useState(0);
  const [settingId, setSettingId] = React.useState(0);
  const [colors, setColors] = React.useState([]);
  const [color, setColor] = React.useState('#FFA500');
  const [settingGridXStart, setSettingGridXStart] = React.useState(0);
  const [settingGridYStart, setSettingGridYStart] = React.useState(0);
  const [settingGridHeight, setSettingGridHeight] = React.useState(0);
  const [settingGridWidth, setSettingGridWidth] = React.useState(0);
  const [multipleSelect, setMultipleSelect] = React.useState(false);
  const [validDrawing, setValidDrawing] = React.useState(false);
  const [maskName, setMaskName] = React.useState(1);
  const [polyMaskIn, setPolyMaskIn] = React.useState(true);
  const [contourColors, setContourColors] = React.useState(state.ProjectConfig.contourColors);
  const [contourValues, setContourValues] = React.useState(state.ProjectConfig.contourValues);
  const [autoContourValues, setAutoContourValues] = React.useState(state.ProjectConfig.autoContourValues);
  const [heatmap, setHeatmap] = React.useState(state.ProjectConfig.heatmap);
  const [greyscale, setGreyscale] = React.useState(state.ProjectConfig.greyscale);

  const [scaleInput, setScaleInput] = React.useState(stage.scale);
  const drawingCenter = useRef({ x: 0, y: 0 });
  const [isEditingScale, setIsEditingScale] = React.useState(false);
  const [columnSearchTerm, setColumnSearchTerm] = React.useState("");
  const [gridSearchTerm, setGridSearchTerm] = React.useState("");
  const [maskSearchTerm, setMaskSearchTerm] = React.useState("");
  const [drawingFileSearchTerm, setDrawingFileSearchTerm] = React.useState("");
  const [layerSearchTerm, setLayerSearchTerm] = React.useState("");
  const [sortState, setSortState] = React.useState(null);
  const [fileSortState, setFileSortState] = React.useState(null);
  const [isInSnapRange, setIsInSnapRange] = React.useState(false);

  const [contextMenu, setContextMenu] = React.useState(false);
  const [contextMenuMaskIndex, setContextMenuMaskIndex] = React.useState(null);
  const [contextMenuPointIndex, setContextMenuPointIndex] = React.useState(null);
  const [contextMenuPosition, setContextMenuPosition] = React.useState({ top: 0, left: 0 });

  const [savedConfigs, setSavedConfigs] = React.useState([]);
  const [configName, setConfigName] = React.useState('Auto-Save');
  const [hasUnsavedChanges, setHasUnsavedChanges] = React.useState(false);
  const [currValueId, setCurrValueId] = React.useState(0);
  const [defaultColumnSettings, setDefaultColumnSettings] = React.useState([]);
  const [defaultColumnSettingValues, setDefaultColumnSettingValues] = React.useState(createDefaultColumnSetting());
  const [reportCaptureAreas, setReportCaptureAreas] = React.useState([]);
  const [columnGroups, setColumnGroups] = React.useState([{
    name: "Default Group",
    id: 0,
    columnIds: [],
    sync: false,
    locked: false,
  }]);
  const [autoSaveConfigId, setAutoSaveConfigId] = React.useState(null);
  //for popup dialog loading latest config
  const [showLoadLatestDialog, setShowLoadLatestDialog] = useState(false);
  const [latestConfig, setLatestConfig] = useState(null);
  const hasRunRef = useRef(false);
  const hasInitializedMaskTrackingRef = useRef(false);
  const hasInitializedGridTrackingRef = useRef(false);
  const hasInitializedColumnTrackingRef = useRef(false);
  const hasInitializedConfigTrackingRef = useRef(false);
  const prevConfigTrackingSnapshotRef = useRef('');
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  // Accordian controls
  const [columnTypeOpen, setColumnTypeOpen] = useState(false);
  const [columnsOpen, setColumnsOpen] = useState(false);
  const [gridsOpen, setGridsOpen] = useState(false);
  const [masksOpen, setMasksOpen] = useState(false);
  const [saveConfigOpen, setSaveConfigOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  useEffect(() => {
    window.openColumnTypeAccordion = (e) => setColumnTypeOpen(e);
    window.openColumnsAccordion = (e) => setColumnsOpen(e);
    window.openGridsAccordion = (e) => setGridsOpen(e);
    window.openMasksAccordion = (e) => setMasksOpen(e);
    window.openSaveConfigAccordion = (e) => setSaveConfigOpen(e);
    window.openReportAccordion = (e) => setReportOpen(e);
  }, []);

  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [confirmResetOpen, setConfirmResetOpen] = React.useState(false);
  const [confirmItem, setConfirmItem] = React.useState(null);
  const [option, setOption] = React.useState('');
  const [filesData, setFilesData] = React.useState([]);
  const [fileDisable, setFileDisable] = React.useState(false);
  const [savingConfig, setSavingConfig] = React.useState(false);
  usePrompt("Are you sure you want to leave this page? Unsaved changes may be lost.", hasUnsavedChanges);
  const [templateEditorOpen, setTemplateEditorOpen] = React.useState(false);
  const [templateElements, setTemplateElements] = React.useState([]);
  const [templates, setTemplates] = React.useState([]);

  const handleConfirmResetClose = () => {
    setConfirmResetOpen(false);
  }

  const handleTemplateChange = (template) => {
    setSelectedTemplate(template);
    EdgeOrREST(null, 'GET_REPORT_ELEMENTS', (response) => { console.log(response); setTemplateElements(response.data); });
  };

  const toggleTemplateEditor = () => {
    if (!selectedTemplate) {
      setSnack({
        open: true,
        message: 'Please select a template first.',
        severity: 'warning',
      });
    }
    else {
      setTemplateEditorOpen(!templateEditorOpen);
    }
  };



  const deleteTemplate = () => {
    if (!selectedTemplate) {
      setSnack({
        open: true,
        message: 'Please select a template first.',
        severity: 'warning',
      });
    }
    else {
      const payload = {
        ...selectedTemplate,
        elements: JSON.stringify(selectedTemplate.elements || [])
      };

      EdgeOrREST(null, 'DELETE_REPORT_TEMPLATE', (response) => {
        if (response && response.status === 200) {
          setSnack({
            open: true,
            message: 'Template deleted successfully.',
            severity: 'success',
          });
        } else {
          setSnack({
            open: true,
            message: 'Failed to delete template.',
            severity: 'error',
          });
        }
        EdgeOrREST(null, 'GET_TEMPLATES', (response) => { setTemplates(response.data); }, null);
      }, payload);
      setSelectedTemplate(null);
    }
  };

  const extractTemplateIdFromResponse = (response) => {
    const candidateIds = [
      response?.data?.id,
      response?.data?.templateId,
      response?.data?.template?.id,
      response?.id,
      response?.templateId,
    ];

    for (const candidate of candidateIds) {
      if (candidate !== undefined && candidate !== null && candidate !== '') {
        return Number(candidate);
      }
    }

    return null;
  };

  const refreshTemplatesAndSelect = (selectedTemplateId = null, options = {}) => {
    const { preferMostRecent = false } = options;

    EdgeOrREST(null, 'GET_TEMPLATES', (response) => {
      const nextTemplates = response?.data || [];
      setTemplates(nextTemplates);

      if (selectedTemplateId === null || selectedTemplateId === undefined) {
        if (preferMostRecent && nextTemplates.length > 0) {
          const mostRecentTemplate = nextTemplates.reduce((prev, current) =>
            Number(current.id) > Number(prev.id) ? current : prev
          );
          setSelectedTemplate(mostRecentTemplate);
          return;
        }

        setSelectedTemplate(null);
        return;
      }

      const matchedTemplate = nextTemplates.find((item) => Number(item.id) === Number(selectedTemplateId));
      setSelectedTemplate(matchedTemplate || null);
    }, null);
  };

  const handleSaveTemplate = (template) => {
    const enabledIds = Object.entries(template.elements || {})
      .filter(([_, enabled]) => enabled)
      .map(([id]) => id.toString());

    let payload = {
      ...template,
      elements: JSON.stringify(enabledIds),
    };

    EdgeOrREST(null, 'SAVE_REPORT_TEMPLATE', (response) => {
      const savedTemplateId = template.isOverwrite
        ? template.id
        : extractTemplateIdFromResponse(response);

      setSnack({
        open: true,
        message:
          template.isOverwrite
            ? 'Template overwritten successfully.'
            : 'Template saved successfully.',
        severity: 'success',
      });
      refreshTemplatesAndSelect(savedTemplateId, { preferMostRecent: !template.isOverwrite });
      setTemplateEditorOpen(false);
    }, payload);
  };

  const handleCreateTemplate = () => {
    const newTemplate = {
      createNewTemplate: true
    };

    console.log("Final payload sent:", JSON.stringify(newTemplate, null, 2));

    EdgeOrREST(
      null,
      'SAVE_REPORT_TEMPLATE',
      (response) => {
        console.log("Template saved:", response);
        setSnack({
          open: true,
          message: 'Template created successfully.',
          severity: 'success',
        });
        const createdTemplateId = extractTemplateIdFromResponse(response);
        refreshTemplatesAndSelect(createdTemplateId, { preferMostRecent: true });
        setTemplateEditorOpen(false);
      },
      newTemplate
    );
  };

  const saveConfig = (e, id) => {
    console.log("called saveConfig", id)
    setSavingConfig(true);
    const config = {
      grids: grids,
      columns: columns,
      masks: masks,
      realWorldHeight: realWorldHeight,
      realWorldWidth: realWorldWidth,
      imagePixelHeight: imagePixelHeight,
      imagePixelWidth: imagePixelWidth,
      // image: image ? image.src : null,
      contourImage: contourImage ? contourImage.src : null,
      contourColors: contourColors,
      contourValues: contourValues,
      autoContourValues: autoContourValues,
      visualGrid: visualGrid,
      stage: stage,
      lines: lines,
      areaResults: areaResults,
      areaGridResults: areaGridResults,
      contourGridResults: contourGridResults,
      showContours: showContours,
      gridScaleX: gridScaleX,
      gridScaleY: gridScaleY,
      metresPerPixelX: metresPerPixelX,
      metresPerPixelY: metresPerPixelY,
      maskMode: maskMode,
      isDrawing: isDrawing,
      currentLine: currentLine,
      luminNameList: luminNameList,
      numberOfLuminaires: numberOfLuminaires,
      luminName: luminName,
      infoLumin: infoLumin,
      currentLuminId: currentLuminId,
      settingId: settingId,
      colors: colors,
      color: color,
      settingGridXStart: settingGridXStart,
      settingGridYStart: settingGridYStart,
      settingGridHeight: settingGridHeight,
      settingGridWidth: settingGridWidth,
      contextMenu: contextMenu,
      contextMenuMaskIndex: contextMenuMaskIndex,
      contextMenuPointIndex: contextMenuPointIndex,
      contextMenuPosition: contextMenuPosition,
      refs: {
        contourGridLayerRef: contourGridLayerRef.current ? contourGridLayerRef.current.attrs : null,
        gridTrRef: gridTrRef.current ? gridTrRef.current.attrs : null,
        imageRef: imageRef.current ? imageRef.current.attrs : null,
        imageLayerRef: imageLayerRef.current ? imageLayerRef.current.attrs : null,
        // stageRef: stageRef.current ? stageRef.current.attrs  : null,
        // contourImageRef: contourImageRef.current ? contourImageRef.current.attrs : null,
        // contourLayerRef: contourLayerRef.current ? contourLayerRef.current.attrs : null,
        contourShapeRef: contourShapeRef.current ? contourShapeRef.current.attrs : null,
        // planRef: planRef.current ? planRef.current: null,
        linesLayerRef: linesLayerRef.current ? linesLayerRef.current.attrs : null,
      },
      defaultColumnSettings: defaultColumnSettings,
      drawingId: currentDrawingId,
      selectedLuminaires: state.Plan?.selectedLuminaires,
      selectedLuminaireNames: state.Plan?.selectedLuminaireNames,
      selectedLuminaireColors: state.Plan?.selectedLuminaireColors,
      selectedLuminaireFolders: state.Plan?.selectedLuminaireFolders,
      reportCaptureAreas: reportCaptureAreas,
      columnGroups: columnGroups,
      dxfScale: dxfScale
    };
    console.log("config save", config);

    if (id == 0 || id == -1) {
      // Check for duplicate configName in savedConfigs
      let finalConfigName = configName == '' ? 'Configuration #' + (savedConfigs.length + 1) : configName;
      let suffix = 1;
      let nameExists = savedConfigs.some(cfg => cfg.description === finalConfigName);
      while (nameExists) {
        finalConfigName = `${configName} (${suffix})`;
        nameExists = savedConfigs.some(cfg => cfg.description === finalConfigName);
        suffix++;
      }
      const postobject = {
        description: finalConfigName,
        config: JSON.stringify(config)
      }
      EdgeOrREST(null, "SET_PLAN_SESSION", (id == -1 ? onAutoSaveConfig : onSaveConfig), postobject);
    } else {
      const postobject = {
        id: id,
        config: JSON.stringify(config),
        userId: state.user.userId
      }
      if (id == autoSaveConfigId) {
        EdgeOrREST(null, "UPDATE_PLAN_SESSION", onAutoSaveConfig, postobject);
      } else {
        EdgeOrREST(null, "UPDATE_PLAN_SESSION", onSaveConfig, postobject);
      }
    }
    setConfigName('');
  };

  const onSaveConfig = (response) => {
    console.log("onSaveConfig", response);
    if (response && response.status == "200") {
      setHasUnsavedChanges(false);
      setSnack({
        open: true,
        message: "Configuration saved successfully.",
        severity: 'success'
      });
      getAllPlanSessions();
    }
    setSavingConfig(false);
  };

  const onAutoSaveConfig = (response) => {
    console.log("onAutoSaveConfig", response);
    console.log("Auto-save config ID:", autoSaveConfigId);
    if (response && response.status == "200") {
      setHasUnsavedChanges(false);
      if (autoSaveConfigId == null) {
        setAutoSaveConfigId(response.data);
      }
      getAllPlanSessions();
    }
    setSavingConfig(false);
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!hasUnsavedChanges) {
        return undefined;
      }
      e.preventDefault();
      e.returnValue = ''; // Chrome requires returnValue to show the dialog
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    EdgeOrREST(null, "LOAD_DRAWINGS", onLoadDrawings, null);
    getAllPlanSessions();
  }, []);

  useEffect(() => {
    if (!hasRunRef.current && savedConfigs && savedConfigs.length > 0) {
      const latest = savedConfigs.reduce((latest, curr) =>
        new Date(curr.timestamp) > new Date(latest.timestamp) ? curr : latest, savedConfigs[0]
      );
      console.log("Latest config found:", latest);
      setLatestConfig(latest);
      setShowLoadLatestDialog(true);
      hasRunRef.current = true;
    }
  }, [savedConfigs]);

  // Handler for dialog actions
  const handleLoadLatestConfig = (action) => {
    if (latestConfig && action) {
      handleLoadConfig({}, latestConfig.id);
    }
    if (latestConfig?.description && latestConfig?.description.toLowerCase().includes('auto-save')) {
      setAutoSaveConfigId(latestConfig.id);
    } else {
      saveConfig({}, -1);
    }

    setShowLoadLatestDialog(false);
    setConfigName('');
  };

  const handleSkipLoadLatestConfig = () => {
    saveConfig({}, -1);
    setShowLoadLatestDialog(false);
    setConfigName('');
  };

  useEffect(() => {
    // Auto-save config every 30 seconds
    const interval = setInterval(() => {
      console.log("Auto running autoSaveConfigId:", autoSaveConfigId);
      if (autoSaveConfigId != null) {
        saveConfig({}, autoSaveConfigId);
        console.log("Auto-save");
      }
    }, 30000);
    return () => clearInterval(interval);
  }, [autoSaveConfigId, masks, grids, columns, contourColors, contourValues,
    autoContourValues, stage, lines, areaResults, areaGridResults, contourGridResults,
    showContours, gridScaleX, gridScaleY, visualGrid, realWorldHeight, realWorldWidth,
    imagePixelHeight, imagePixelWidth, currentDrawingId, dxfScale,
    state.Plan.selectedLuminaires, state.Plan.selectedLuminaireNames, state.Plan.selectedLuminaireColors, state.Plan.selectedLuminaireFolders]);

  const resetStageViewport = useCallback(() => {
    const neutralStage = { scale: 1, x: 0, y: 0 };

    if (stageRef.current) {
      const konvaStage = stageRef.current.getStage?.() ?? stageRef.current;
      konvaStage.scale({ x: neutralStage.scale, y: neutralStage.scale });
      konvaStage.position({ x: neutralStage.x, y: neutralStage.y });
      konvaStage.batchDraw?.();
    }

    if (dxfContainerRef.current && !viewer) {
      dxfContainerRef.current.style.transform = `translate(${neutralStage.x}px, ${neutralStage.y}px) scale(${neutralStage.scale})`;
    }

    setStage(neutralStage);
    setScaleInput('1.00');
  }, [viewer]);

  const handleLoadConfig = (e, id) => {
    console.log("called handleLoadConfig", id);
    EdgeOrREST(null, "GET_PLAN_SESSION_BY_ID", loadConfig, { headers: { 'id': id } });
  };

  const loadConfig = (response) => {
    if (!response || !response.data) {
      setSnack({
        open: true,
        message: "Load failed: Configuration not found",
        severity: 'warning'
      });
      return;
    }
    const tempConfig = JSON.parse(response.data.config);
    loadingConfigRef.current = true;
    setHasUnsavedChanges(false);
    flushSync(() => {
      resetStageViewport();
    });
    applyConfig(tempConfig).then((appliedGrids) => {
      // Ensure React has committed state before using it further
      flushSync(() => { });
      // Pass the just-applied grids explicitly to prevent stale reads
      handleSelectDrawing(tempConfig.drawingId, { baseGrids: appliedGrids });
    });
  };

  function applyConfig(tempConfig) {
    return new Promise((resolve) => {
      console.log("applyConfig", tempConfig);

      if (tempConfig.refs) {
        if (tempConfig.refs.contourGridLayerRef?.current) contourGridLayerRef.current.attrs = tempConfig.refs.contourGridLayerRef;
        // if (tempConfig.refs.gridTrRef?.current) gridTrRef.current.attrs = tempConfig.refs.gridTrRef;
        if (tempConfig.refs.imageRef?.current) imageRef.current.attrs = tempConfig.refs.imageRef;
        if (tempConfig.refs.imageLayerRef?.current) imageLayerRef.current.attrs = tempConfig.refs.imageLayerRef;
        if (tempConfig.refs.contourShapeRef?.current) contourShapeRef.current.attrs = tempConfig.refs.contourShapeRef;
        if (tempConfig.refs.linesLayerRef?.current) linesLayerRef.current.attrs = tempConfig.refs.linesLayerRef;
      }
      setDxfScale(tempConfig.dxfScale);
      setGrids(normalizeGridIds(tempConfig.grids).normalized);
      setVisualGrid(tempConfig.visualGrid);
      let highestNumber = 0;
      const masks = tempConfig.masks || [];
      masks.forEach((mask) => {
        const match = mask.name.match(/^Mask #(\d+)$/);
        if (match) {
          const number = parseInt(match[1], 10);
          if (number > highestNumber) {
            highestNumber = number;
          }
        }
      });

      setMaskName(highestNumber + 1);
      // console.log("Stage before:", stage);
      // setStage(tempConfig.stage);
      // console.log("Stage after:", tempConfig.stage);
      const normalizedLuminNameList = Array.isArray(tempConfig.luminNameList) ? tempConfig.luminNameList : [];
      const normalizedColors = Array.isArray(tempConfig.colors) ? tempConfig.colors : [];
      const normalizedColumnSettings = normalizeColumnSettings(
        tempConfig.defaultColumnSettings,
        normalizedLuminNameList.length
      );
      const normalizedColumns = Array.isArray(tempConfig.columns)
        ? tempConfig.columns.map((column) => ({
          ...column,
          image: circlerightradius,
        }))
        : [];

      setLines(tempConfig.lines);
      setLuminNameList(normalizedLuminNameList);
      setNumberOfLuminaires(Math.max(
        tempConfig.numberOfLuminaires || 0,
        normalizedLuminNameList.length,
        normalizedColumnSettings.length
      ));
      setLuminName(tempConfig.luminName);
      setCurrentLuminId(tempConfig.currentLuminId);
      setSettingId(tempConfig.settingId);
      setColors(normalizedColors);
      setColor(tempConfig.color);
      setSettingGridXStart(tempConfig.settingGridXStart);
      setSettingGridYStart(tempConfig.settingGridYStart);
      setSettingGridHeight(tempConfig.settingGridHeight);
      setSettingGridWidth(tempConfig.settingGridWidth);
      setContextMenu(tempConfig.contextMenu);
      setContextMenuMaskIndex(tempConfig.contextMenuMaskIndex);
      setContextMenuPointIndex(tempConfig.contextMenuPointIndex);
      setContextMenuPosition(tempConfig.contextMenuPosition);
      setDefaultColumnSettings(normalizedColumnSettings);
      setShowContours(tempConfig.showContours);
      setContourColors(tempConfig.contourColors);
      setContourValues(tempConfig.contourValues);
      setAutoContourValues(tempConfig.autoContourValues);
      setHeatmap(tempConfig.heatmap);
      setGreyscale(tempConfig.greyscale);
      setReportCaptureAreas(tempConfig.reportCaptureAreas || []);
      setColumnGroups((tempConfig.columnGroups || [{
        name: "Default Group",
        id: 0,
        columnIds: [],
        sync: false,
        locked: false,
      }]).map(group => ({
        ...group,
        sync: Boolean(group.sync),
        locked: Boolean(group.locked),
      })));

      setColumns(normalizedColumns);
      setMasks(tempConfig.masks);

      console.log(tempConfig)
      let tempSelectedLuminaires = tempConfig.selectedLuminaires || [];
      let tempSelectedLuminaireNames = tempConfig.selectedLuminaireNames || [];
      let tempSelectedLuminaireColors = tempConfig.selectedLuminaireColors || [];
      let tempSelectedLuminaireFolders = tempConfig.selectedLuminaireFolders || [];

      dispatch(roadActions.AddToCurrentState({
        contourColors: tempConfig.contourColors,
        contourValues: tempConfig.contourValues,
        autoContourValues: tempConfig.autoContourValues,
        showContours: tempConfig.showContours,
        heatmap: tempConfig.heatmap,
        greyscale: tempConfig.greyscale
      }));

      dispatch(planActions.UpdatePlanLuminaires({
        selectedLuminaires: tempSelectedLuminaires,
        selectedLuminaireNames: tempSelectedLuminaireNames,
        selectedLuminaireColors: tempSelectedLuminaireColors,
        selectedLuminaireFolders: tempSelectedLuminaireFolders
      }));

      dispatch(luminaireActions.UpdateLuminaireList({
        ...state.LuminaireCfg,
        selectedLuminaireIds: tempSelectedLuminaires,
        selectedFolderIds: tempSelectedLuminaireFolders,
      }));

      // setStartCalc(Date.now());
      resolve(tempConfig.grids);
    });
  };

  const deleteConfig = (id) => {
    EdgeOrREST(null, "DELETE_PLAN_SESSION", onDeleteConfig, { id: id });
    setSavedConfigs(savedConfigs.filter(config => config.id !== id));
  };

  const onDeleteConfig = (response) => {
    if (response && response.status == "200") {
      setSnack({
        open: true,
        message: "Configuration deleted successfully.",
        severity: 'success'
      });
    } else {
      setSnack({
        open: true,
        message: "Configuration delete failed. Please try again.",
        severity: 'error'
      });
    }
  };

  const getAllPlanSessions = () => {
    console.log("called getAllPlanSessions");
    EdgeOrREST(null, "GET_ALL_PLAN_SESSION", onGetAllPlanSessionsDescription, null);
  }

  const onGetAllPlanSessionsDescription = (response) => {
    console.log("onGetAllPlanSessionsDescription", response);
    if (response && response.data) {
      setSavedConfigs(response.data);
    } else if (response && response.status == "204") {
      setSavedConfigs([]);
    } else {
      setSnack({
        open: true,
        message: "Get configurations failed.",
        severity: 'warning'
      });
    }
  };

  // Removed redundant handleWheel. All zoom/scale logic is handled in the unified onWheel handler in useEffect.
  const handleDxfScaleCommit = () => {
    let value = parseFloat(dxfScaleInput);
    if (isNaN(value) || !Number.isFinite(value) || value < 1) {
      value = 1;
      setDxfScaleInput(value);
    }
    else if (value > 4) {
      value = 4;
      setDxfScaleInput(value);
    }
    if (value !== dxfScale) {
      onDxfScaleChange({ target: { value } });
    }
  };
  const handleScaleOverrideCommit = () => {
    let val = parseFloat(scaleOverrideInput);
    if (isNaN(val) || val <= 0) {
      setScaleOverride(null);
      setScaleOverrideInput('');
    } else {
      setScaleOverride(val);
    }
    // reprocess last parsed DXF with new override
    if (lastParsedDxfRef.current) {
      onSetDxfImage(lastParsedDxfRef.current);
    }
  };
  const onDxfScaleChange = e => {
    let target = parseFloat(e.target.value);
    if (!viewer || !Number.isFinite(target) || target <= 0) return;
    if (target > 4) target = 4;
    if (target < 1) target = 1;
    const newWidth = containerSize.width * target;
    const newHeight = containerSize.height * target;

    const container = dxfContainerRef.current;
    container.style.width = `${newWidth}px`;
    container.style.height = `${newHeight}px`;

    if (typeof viewer.Resize === 'function') {
      viewer.Resize();
    } else if (viewer.renderer) {
      viewer.renderer.setSize(newWidth, newHeight, false);
    }

    const cam = viewer.camera;
    cam.zoom = target;
    cam.updateProjectionMatrix();
    viewer.renderer.render(viewer.scene, cam);

    setDxfScale(target);
  };

  const onSetHeight = (e) => {
    console.log("called onSetHeight")
    setRealWorldHeight(e.target.value);
    if (image) {
      setGridScaleY(image.naturalHeight / e.target.value);
      setGridScaleX(image.naturalWidth / realWorldWidth);
      console.log("img.naturalHeight, img.naturalWidth, realWorldHeight, realWorldWidth", image.naturalHeight, image.naturalWidth, realWorldHeight, realWorldWidth);
    }

  }

  const onSetWidth = (e) => {
    console.log("called onSetWidth")
    setRealWorldWidth(e.target.value);

    if (image) {
      setGridScaleY(image.naturalHeight / realWorldHeight);
      setGridScaleX(image.naturalWidth / e.target.value);
      console.log("img.naturalHeight, img.naturalWidth, realWorldHeight, realWorldWidth", image.naturalHeight, image.naturalWidth, realWorldHeight, realWorldWidth);

    }
  }

  const onSetImage = (e) => {
    dispatch(notificationActions.UpdateImageLoad({ imageLoad: true }));
    console.log("called onSetImage")
    const img = new window.Image();
    img.src = URL.createObjectURL(e.target.files[0]);
    img.crossOrigin = "Anonymous";

    img.onload = function () {
      console.log("img.naturalHeight, img.naturalWidth, realWorldHeight, realWorldWidth", img.naturalHeight, img.naturalWidth, realWorldHeight, realWorldWidth);
      setGridScaleY(img.naturalHeight / realWorldHeight);
      setGridScaleX(img.naturalWidth / realWorldWidth);
      setImagePixelHeight(img.height);
      setImagePixelWidth(img.width);
      setImage(img);
      setSnack({
        open: true,
        message: "Drawing loaded successfully.",
        severity: 'success',
        action: 'upload completed'
      });
      dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));


      var tempGridStr = JSON.stringify(grids);
      var tempGrid = JSON.parse(tempGridStr);
      tempGrid[0].origin.x.length = realWorldWidth;
      tempGrid[0].origin.y.length = realWorldHeight;
      setGrids(tempGrid);
      //grid is being set to the same size as the image 
      setVisualGrid({
        x: grids[0].origin.x.start * (img.naturalWidth / realWorldWidth),
        y: grids[0].origin.y.start * (img.naturalHeight / realWorldHeight),
        width: realWorldWidth * (img.naturalWidth / realWorldWidth),
        height: realWorldHeight * (img.naturalHeight / realWorldHeight)
      });
    }
  }

  const svgToUrl = useCallback((svgStr) => {
    const blob = new Blob([svgStr], { type: 'image/svg+xml' });
    return URL.createObjectURL(blob);
  }, []);

  const onSetSvgImage = (svgImage, scaleFactor, moveCamera = true) => {
    const optimizedResult = optimize(svgImage, {
      multipass: true,
      plugins: [
        {
          name: 'preset-default',
          params: {
            overrides: {
              // precision overrides (you already have)
              cleanupNumericValues: { floatPrecision: 1 },
              convertPathData: { floatPrecision: 1, transformPrecision: 1 },
              convertTransform: { floatPrecision: 1, transformPrecision: 1 },
              mergePaths: { floatPrecision: 1 },

              cleanupNumericValues: { floatPrecision: 1 },
              convertPathData: { floatPrecision: 1, transformPrecision: 1 },
              convertTransform: { floatPrecision: 1, transformPrecision: 1 },
              mergePaths: { floatPrecision: 1 },

              // structural / size‑saving plugins
              removeXMLProcInst: true,
              removeDoctype: true,
              removeComments: true,
              removeMetadata: true,
              removeTitle: true,
              removeDesc: true,
              removeUselessDefs: true,
              cleanupAttrs: true,
              cleanupIDs: true,
              removeUnknownsAndDefaults: true,
              collapseGroups: true,
              removeEmptyContainers: true,
              removeEmptyText: true,
              removeEmptyAttrs: true,
              convertColors: true,
              sortDefsChildren: true,
              sortAttrs: true,
              removeDimensions: true,
              removeXMLProcInst: true,
              removeDoctype: true,
              removeComments: true,
              removeMetadata: true,
              removeTitle: true,
              removeDesc: true,
              removeUselessDefs: true,
              cleanupAttrs: true,
              cleanupIDs: true,
              removeUnknownsAndDefaults: true,
              collapseGroups: true,
              removeEmptyContainers: true,
              removeEmptyText: true,
              removeEmptyAttrs: true,
              convertColors: true,
              sortDefsChildren: true,
              sortAttrs: true,
              removeDimensions: true,
            },
          },
        },
      ],
    });
    const optimizedSvg = optimizedResult.data;
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(optimizedSvg, "image/svg+xml");
    const svgElement = svgDoc.documentElement;  // This should be the <svg> element

    // Extract the width and height from the SVG's attributes
    let pixelHeight = parseFloat(svgElement.getAttribute("height"));
    let pixelWidth = parseFloat(svgElement.getAttribute("width"));
    // Compute real-world dimensions from the pixel dimensions and scale factor
    const realHeight = pixelHeight * scaleFactor;  // Height in meters
    const realWidth = pixelWidth * scaleFactor;    // Width in meters

    setRealWorldHeight(realHeight);
    setRealWorldWidth(realWidth);

    // Create a new Image object for the SVG
    const img = new window.Image();
    img.src = 'data:image/svg+xml;base64,' + btoa(optimizedSvg); // Encode the SVG data to base64 and set as src
    img.crossOrigin = "Anonymous";

    img.onload = function () {
      // Image dimensions can be used if needed but we already have pixelHeight/pixelWidth from the API
      const svgPixelHeight = img.naturalHeight;
      const svgPixelWidth = img.naturalWidth;

      // Set grid scaling based on real-world dimensions
      setGridScaleY(svgPixelHeight / realHeight);
      setGridScaleX(svgPixelWidth / realWidth);

      // Set the image's pixel height and width
      setImagePixelHeight(svgPixelHeight);
      setImagePixelWidth(svgPixelWidth);
      setImage(img);  // Set the image object for further use if necessary

      // Handle grid scaling and set the grid dimensions
      var tempGridStr = JSON.stringify(grids);
      // Set the grid lengths to match the real-world dimensions
      setGrids(prevGrids => {
        const updatedGrids = [...prevGrids];
        updatedGrids[0] = {
          ...updatedGrids[0],
          origin: {
            ...updatedGrids[0].origin,
            x: {
              ...updatedGrids[0].origin.x,
              length: realWidth,
            },
            y: {
              ...updatedGrids[0].origin.y,
              length: realHeight,
            },
          },
        };
        return updatedGrids;
      });


      // Set visual grid based on scaling factors
      setVisualGrid({
        x: grids[0].origin.x.start * (svgPixelWidth / realWidth),
        y: grids[0].origin.y.start * (svgPixelHeight / realHeight),
        width: realWidth * (svgPixelWidth / realWidth),
        height: realHeight * (svgPixelHeight / realHeight)
      });

      if (moveCamera) {
        const stage = stageRef.current;
        const scale = stage.scaleX();
        const stageWidth = stage.width();
        const stageHeight = stage.height();

        const imageCenterX = svgPixelWidth / 2;
        const imageCenterY = svgPixelHeight / 2;

        const newX = -imageCenterX * scale + stageWidth / 2;
        const newY = -imageCenterY * scale + stageHeight / 2;

        stage.position({ x: newX, y: newY });
        stage.batchDraw();
      }

    }
  }

  const onSetPNGImage = (pngImage, scaleFactor) => {
    const img = new window.Image();
    img.src = 'data:image/png;base64,' + pngImage;
    img.crossOrigin = "Anonymous";
    img.onload = function () {
      const pixelHeight = img.height;
      const pixelWidth = img.width;
      const realHeight = pixelHeight * scaleFactor;
      const realWidth = pixelWidth * scaleFactor;

      setRealWorldHeight(realHeight);

      setRealWorldWidth(realWidth);

      setGridScaleY(pixelHeight / realHeight);
      setGridScaleX(pixelWidth / realWidth);
      setImagePixelHeight(pixelHeight);
      setImagePixelWidth(pixelWidth);
      setImage(img);

      var tempGridStr = JSON.stringify(grids);
      var tempGrid = JSON.parse(tempGridStr);
      tempGrid[0].origin.x.length = realWidth;
      tempGrid[0].origin.y.length = realHeight;
      setGrids(tempGrid);

      setVisualGrid({
        x: grids[0].origin.x.start * (pixelWidth / realWidth),
        y: grids[0].origin.y.start * (pixelHeight / realHeight),
        width: realWidth * (pixelWidth / realWidth),
        height: realHeight * (pixelHeight / realHeight)
      });
    }
  }

  const onSetDxfImage = (parsed, baseGrids) => {
    if (!parsed || !parsed.entities || !parsed.entities.length) return;
    lastParsedDxfRef.current = parsed;
    let realHeight = 0, realWidth = 0;
    const points = [];
    const sourceGrids = baseGrids || grids;
    const insUnitsCode = parsed.header?.['$INSUNITS'];
    const UNITS_TO_METRES = {
      0: 1,
      1: 0.0254,
      2: 0.3048,
      4: 0.001,
      5: 0.01,
      6: 1,
      7: 1000,
    };
    const fileFactor = UNITS_TO_METRES[insUnitsCode] ?? 1;
    setOriginalScaleFactor(fileFactor);
    setScaleOverride(fileFactor);
    setScaleOverrideInput(fileFactor.toString());

    const factor = fileFactor;
    setScaleFactor(factor);
    parsed.entities.forEach(ent => {
      switch (ent.type) {
        case 'LINE':
          if (ent.start && ent.end) {
            points.push(ent.start, ent.end);
          }
          break;

        case 'LWPOLYLINE':
        case 'POLYLINE':
          if (Array.isArray(ent.vertices)) {
            ent.vertices.forEach(v => v.x != null && v.y != null && points.push(v));
          }
          break;

        case 'CIRCLE':
          if (ent.center && typeof ent.radius === 'number') {
            points.push(
              { x: ent.center.x - ent.radius, y: ent.center.y - ent.radius },
              { x: ent.center.x + ent.radius, y: ent.center.y + ent.radius }
            );
          }
          break;

        case 'ARC':
          if (ent.center && typeof ent.radius === 'number'
            && typeof ent.startAngle === 'number'
            && typeof ent.endAngle === 'number') {
            // Only sample the two arc endpoints
            const toRad = deg => deg * Math.PI / 180;
            const p1 = {
              x: ent.center.x + ent.radius * Math.cos(toRad(ent.startAngle)),
              y: ent.center.y + ent.radius * Math.sin(toRad(ent.startAngle))
            };
            const p2 = {
              x: ent.center.x + ent.radius * Math.cos(toRad(ent.endAngle)),
              y: ent.center.y + ent.radius * Math.sin(toRad(ent.endAngle))
            };
            points.push(p1, p2);
          }
          break;

        case 'ELLIPSE':
          if (ent.center && typeof ent.rx === 'number' && typeof ent.ry === 'number') {
            points.push(
              { x: ent.center.x - ent.rx, y: ent.center.y - ent.ry },
              { x: ent.center.x + ent.rx, y: ent.center.y + ent.ry }
            );
          }
          break;

        // skip TEXT, INSERT, DIMENSION, etc.
        default:
          break;
      }
    });

    const scaledEntities = parsed.entities.map(ent => {
      const clone = { ...ent };
      switch (ent.type) {
        case 'LINE':
          if (Array.isArray(ent.vertices) && ent.vertices.length >= 2) {
            clone.vertices = ent.vertices.map(v => ({
              x: v.x * factor,
              y: v.y * factor,
              z: v.z * factor
            }));
          }
          break;
        case 'LWPOLYLINE':
        case 'POLYLINE':
          if (Array.isArray(ent.vertices)) {
            clone.vertices = ent.vertices.map(v => ({
              x: v.x * factor,
              y: v.y * factor,
              z: v.z * factor
            }));
          }
          break;
        case 'CIRCLE':
          if (ent.center && typeof ent.radius === 'number') {
            clone.center = {
              x: ent.center.x * factor,
              y: ent.center.y * factor,
              z: ent.center.z * factor
            };
            clone.radius = ent.radius * factor;
          }
          break;
        case 'ARC':
          if (ent.center && typeof ent.radius === 'number') {
            clone.center = {
              x: ent.center.x * factor,
              y: ent.center.y * factor,
              z: ent.center.z * factor
            };
            clone.radius = ent.radius * factor;
          }
          break;
        case 'ELLIPSE':
          if (ent.center && typeof ent.rx === 'number' && typeof ent.ry === 'number') {
            clone.center = {
              x: ent.center.x * factor,
              y: ent.center.y * factor,
              z: ent.center.z * factor
            };
            clone.rx = ent.rx * factor;
            clone.ry = ent.ry * factor;
          }
          break;
        default:
          break;
      }
      return clone;
    });

    setParsedEntities(scaledEntities);



    const bounds = viewer.GetBounds && viewer.GetBounds();
    const extMin = parsed.header?.['$EXTMIN'];   // { x:…, y:…, z:… }
    const extMax = parsed.header?.['$EXTMAX'];   // { x:…, y:…, z:… }

    // 3) Pull the actual DXF‐viewer canvas size
    const canvas = dxfContainerRef.current?.querySelector('canvas');
    let svgPixelWidth = 0;
    let svgPixelHeight = 0;
    if (canvas) {
      // Device pixel ratio logic for high-DPI screens
      svgPixelWidth = dxfContainerRef.current.clientWidth;
      svgPixelHeight = dxfContainerRef.current.clientHeight;
      const dpr = window.devicePixelRatio || 1;

      // Set canvas pixel size to CSS size * devicePixelRatio
      canvas.width = svgPixelWidth * dpr;
      canvas.height = svgPixelHeight * dpr;

      // Set canvas style size to CSS size
      canvas.style.width = `${svgPixelWidth}px`;
      canvas.style.height = `${svgPixelHeight}px`;

      // Scale the context so drawing operations are DPI-aware
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      setImagePixelWidth(canvas.width);
      setImagePixelHeight(canvas.height);
    }
    const sourceMinX = (bounds && Number.isFinite(bounds.minX)) ? bounds.minX : extMin?.x;
    const sourceMinY = (bounds && Number.isFinite(bounds.minY)) ? bounds.minY : extMin?.y;
    const sourceMaxX = (bounds && Number.isFinite(bounds.maxX)) ? bounds.maxX : extMax?.x;
    const sourceMaxY = (bounds && Number.isFinite(bounds.maxY)) ? bounds.maxY : extMax?.y;
    const minX = (sourceMinX ?? 0) * factor;
    const minY = (sourceMinY ?? 0) * factor;
    const maxX = (sourceMaxX ?? 0) * factor;
    const maxY = (sourceMaxY ?? 0) * factor;
    const rawRealWidth = maxX - minX;
    const rawRealHeight = maxY - minY;
    realWidth = Number.isFinite(rawRealWidth) && rawRealWidth > 0 ? rawRealWidth : DEFAULT_DXF_PLACEHOLDER_SIZE_METRES;
    realHeight = Number.isFinite(rawRealHeight) && rawRealHeight > 0 ? rawRealHeight : DEFAULT_DXF_PLACEHOLDER_SIZE_METRES;

    const bufferRatio = 0.05; //magic buffer ratio

    const modelBufferX = realWidth * bufferRatio;
    const modelBufferY = realHeight * bufferRatio;

    const modelMinX = minX - modelBufferX;
    const modelMaxX = maxX + modelBufferX;
    const modelMinY = minY - modelBufferY;
    const modelMaxY = maxY + modelBufferY;
    const viewerOrigin = viewer.GetOrigin && viewer.GetOrigin();
    const originX = (viewerOrigin && Number.isFinite(viewerOrigin.x)) ? viewerOrigin.x * factor : 0;
    const originY = (viewerOrigin && Number.isFinite(viewerOrigin.y)) ? viewerOrigin.y * factor : 0;
    const contentMinX = minX - originX;
    const contentMinY = minY - originY;
    const rawFinalWidth = modelMaxX - modelMinX;
    const rawFinalHeight = modelMaxY - modelMinY;
    const finalWidth = Number.isFinite(rawFinalWidth) && rawFinalWidth > MIN_DXF_DIMENSION_METRES
      ? rawFinalWidth
      : Math.max(realWidth, DEFAULT_DXF_PLACEHOLDER_SIZE_METRES);
    const finalHeight = Number.isFinite(rawFinalHeight) && rawFinalHeight > MIN_DXF_DIMENSION_METRES
      ? rawFinalHeight
      : Math.max(realHeight, DEFAULT_DXF_PLACEHOLDER_SIZE_METRES);
    let scale = Math.min(svgPixelWidth / finalWidth, svgPixelHeight / finalHeight);
    if (!Number.isFinite(scale) || scale <= 0) {
      scale = 1;
    }

    const spatialExtent = Math.max(Math.abs(finalWidth), Math.abs(finalHeight), 1);
    const toFiniteNumber = (value) => {
      const numeric = Number(value);
      return Number.isFinite(numeric) ? numeric : null;
    };
    const scaleNumberIfFinite = (value, factorToApply) => {
      const numeric = Number(value);
      if (!Number.isFinite(numeric)) return value;
      const scaled = numeric * factorToApply;
      return typeof value === 'string' ? String(scaled) : scaled;
    };
    const shouldNormalizeByFactor = (values, factorToApply) => {
      if (!(Number.isFinite(factorToApply) && factorToApply > 0 && factorToApply < 1)) return false;
      const finite = values.filter(Number.isFinite).map(v => Math.abs(v));
      if (finite.length === 0) return false;
      const sorted = [...finite].sort((a, b) => a - b);
      const p75 = sorted[Math.floor(sorted.length * 0.75)] ?? sorted[sorted.length - 1];
      const rawThreshold = Math.max(spatialExtent * 3, 50);
      return p75 > rawThreshold && (p75 * factorToApply) <= rawThreshold;
    };
    const collectGridNumbers = (gridList) => (Array.isArray(gridList) ? gridList : []).flatMap((grid) => [
      toFiniteNumber(grid?.origin?.x?.start),
      toFiniteNumber(grid?.origin?.x?.length),
      toFiniteNumber(grid?.origin?.y?.start),
      toFiniteNumber(grid?.origin?.y?.length),
      toFiniteNumber(grid?.origin?.z?.start),
      toFiniteNumber(grid?.origin?.z?.length),
      toFiniteNumber(grid?.xSpacing),
      toFiniteNumber(grid?.ySpacing),
      toFiniteNumber(grid?.maxSpacing),
    ]).filter(Number.isFinite);
    const collectColumnNumbers = (columnList) => (Array.isArray(columnList) ? columnList : []).flatMap((column) => {
      const lanternValues = (Array.isArray(column?.values?.lanterns) ? column.values.lanterns : []).flatMap((lantern) => [
        toFiniteNumber(lantern?.beamAimingInfo?.beamOrigin?.x),
        toFiniteNumber(lantern?.beamAimingInfo?.beamOrigin?.y),
        toFiniteNumber(lantern?.beamAimingInfo?.beamEndPoint?.x),
        toFiniteNumber(lantern?.beamAimingInfo?.beamEndPoint?.y),
      ]);
      return [
        toFiniteNumber(column?.values?.point?.x),
        toFiniteNumber(column?.values?.point?.y),
        ...lanternValues,
      ];
    }).filter(Number.isFinite);
    const collectMaskNumbers = (maskList) => (Array.isArray(maskList) ? maskList : []).flatMap((mask) => {
      const pointValues = (Array.isArray(mask?.points) ? mask.points : []).flatMap((point) => [
        toFiniteNumber(point?.x),
        toFiniteNumber(point?.y),
      ]);
      return [
        toFiniteNumber(mask?.x),
        toFiniteNumber(mask?.y),
        toFiniteNumber(mask?.width),
        toFiniteNumber(mask?.height),
        toFiniteNumber(mask?.radius),
        ...pointValues,
      ];
    }).filter(Number.isFinite);

    let normalizedSourceGrids = sourceGrids;
    if (shouldNormalizeByFactor(collectGridNumbers(sourceGrids), factor)) {
      normalizedSourceGrids = (Array.isArray(sourceGrids) ? sourceGrids : []).map((grid) => ({
        ...grid,
        xSpacing: scaleNumberIfFinite(grid?.xSpacing, factor),
        ySpacing: scaleNumberIfFinite(grid?.ySpacing, factor),
        maxSpacing: scaleNumberIfFinite(grid?.maxSpacing, factor),
        origin: {
          ...(grid?.origin || {}),
          x: {
            ...(grid?.origin?.x || {}),
            start: scaleNumberIfFinite(grid?.origin?.x?.start, factor),
            length: scaleNumberIfFinite(grid?.origin?.x?.length, factor),
          },
          y: {
            ...(grid?.origin?.y || {}),
            start: scaleNumberIfFinite(grid?.origin?.y?.start, factor),
            length: scaleNumberIfFinite(grid?.origin?.y?.length, factor),
          },
          z: {
            ...(grid?.origin?.z || {}),
            start: scaleNumberIfFinite(grid?.origin?.z?.start, factor),
            length: scaleNumberIfFinite(grid?.origin?.z?.length, factor),
          },
        },
      }));
    }

    if (shouldNormalizeByFactor(collectColumnNumbers(columns), factor)) {
      const normalizedColumns = (Array.isArray(columns) ? columns : []).map((column) => {
        const currentLanterns = Array.isArray(column?.values?.lanterns) ? column.values.lanterns : [];
        const lanterns = currentLanterns.map((lantern) => ({
          ...lantern,
          beamAimingInfo: {
            ...(lantern?.beamAimingInfo || {}),
            beamOrigin: lantern?.beamAimingInfo?.beamOrigin
              ? {
                ...lantern.beamAimingInfo.beamOrigin,
                x: scaleNumberIfFinite(lantern.beamAimingInfo.beamOrigin.x, factor),
                y: scaleNumberIfFinite(lantern.beamAimingInfo.beamOrigin.y, factor),
              }
              : lantern?.beamAimingInfo?.beamOrigin,
            beamEndPoint: lantern?.beamAimingInfo?.beamEndPoint
              ? {
                ...lantern.beamAimingInfo.beamEndPoint,
                x: scaleNumberIfFinite(lantern.beamAimingInfo.beamEndPoint.x, factor),
                y: scaleNumberIfFinite(lantern.beamAimingInfo.beamEndPoint.y, factor),
              }
              : lantern?.beamAimingInfo?.beamEndPoint,
          },
        }));
        return {
          ...column,
          values: {
            ...(column?.values || {}),
            point: {
              ...(column?.values?.point || {}),
              x: scaleNumberIfFinite(column?.values?.point?.x, factor),
              y: scaleNumberIfFinite(column?.values?.point?.y, factor),
            },
            lanterns,
          },
        };
      });
      setColumns(normalizedColumns);
    }

    if (shouldNormalizeByFactor(collectMaskNumbers(masks), factor)) {
      const normalizedMasks = (Array.isArray(masks) ? masks : []).map((mask) => ({
        ...mask,
        x: scaleNumberIfFinite(mask?.x, factor),
        y: scaleNumberIfFinite(mask?.y, factor),
        width: scaleNumberIfFinite(mask?.width, factor),
        height: scaleNumberIfFinite(mask?.height, factor),
        radius: scaleNumberIfFinite(mask?.radius, factor),
        points: Array.isArray(mask?.points)
          ? mask.points.map((point) => ({
            ...point,
            x: scaleNumberIfFinite(point?.x, factor),
            y: scaleNumberIfFinite(point?.y, factor),
          }))
          : mask?.points,
      }));
      setMasks(normalizedMasks);
    }

    // 5) Update the grids state

    const widthScale = svgPixelWidth / finalWidth;
    const heightScale = svgPixelHeight / finalHeight;
    const useWidthScale = widthScale < heightScale;
    const useViewerScale = Boolean(viewer);

    setGrids(prev => {
      // If we are in a config load and have a supplied sourceGrids, start from that snapshot
      const hasNormalizedSource = normalizedSourceGrids !== sourceGrids;
      const working = (baseGrids || hasNormalizedSource)
        ? JSON.parse(JSON.stringify(normalizedSourceGrids))
        : JSON.parse(JSON.stringify(prev));

      if (working.length > 0) {
        const g0 = working[0];
        if (useViewerScale) {
          g0.origin.x.length = finalWidth;
          g0.origin.y.length = finalHeight;
          g0.origin.x.start = 0;
          g0.origin.y.start = 0;
          setGridOffsetX(contentMinX);
          setGridOffsetY(contentMinY);
          setVisualGrid({
            x: 0,
            y: 0,
            width: finalWidth,
            height: finalHeight,
          });
        } else {
          setGridOffsetX(0);
          setGridOffsetY(0);
          // Decide branch as in your original logic (useWidthScale etc.)
          // (We assume variables: useWidthScale, finalWidth, finalHeight, scale, svgPixelWidth, svgPixelHeight already computed.)
          if (useWidthScale) {
            g0.origin.x.length = finalWidth;
            g0.origin.y.length = svgPixelHeight / scale;
            setVisualGrid({
              x: 0,
              y: 0,
              width: finalWidth,
              height: finalHeight * scale,
            });
          } else {
            g0.origin.x.length = svgPixelWidth / scale;
            g0.origin.y.length = finalHeight;
            setVisualGrid({
              x: 0,
              y: 0,
              width: finalWidth * scale,
              height: finalHeight,
            });
          }
        }
      }
      return working;
    });

    // Only adjust scaling after deciding grids
    setGridScaleX(useViewerScale ? 1 : scale);
    setGridScaleY(useViewerScale ? 1 : scale);
    setRealWorldWidth(finalWidth);
    setRealWorldHeight(finalHeight);

  };

  const exportToDWG = async (e) => {
    const file = e.target.files[0];
    const svg = await exportStageSVG(stageRef.current, false);
    if (file) {
      EdgeOrREST(null, 'EXPORT_TO_DWG', onExportToDWG, { file, svg });
    }
  }

  const onExportToDWG = (response) => {
    const blob = new Blob([response.data], { type: 'application/octet-stream' });

    // Attempt to extract the filename from the Content-Disposition header
    let fileName = 'download.dwg'; // Default filename
    const contentDisposition = response.headers['content-disposition'];

    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
      const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (fileNameMatch && fileNameMatch.length > 1) {
        fileName = fileNameMatch[1];
      }
    }

    // Create a link element, set the href to the blob URL, and trigger a click
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName); // Set the filename for the download
    document.body.appendChild(link);
    link.click();

    // Clean up and revoke the object URL after the download
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  const UploadDWGToPNG = (e) => {
    const file = e.target.files[0];
    dispatch(notificationActions.UpdateImageLoad({ imageLoad: true }));
    if (file) {
      EdgeOrREST(null, 'CONVERT_TO_PNG', onConvertToPNG, file);
    }
  }
  const onConvertToPNG = (response) => {
    if (response) {
      const { img, pixelsToMetersX, pixelsToMetersY } = response;
      onSetPNGImage(img, 1);
      setSnack({
        open: true,
        message: "Drawing converted to png successfully.",
        severity: 'success',
        action: 'upload completed'
      });
      dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));
    }
  };



  const handleUploadClick = async (e) => {

    setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50)
    const file = e.target.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    if (fileName.endsWith('.dxf')) {
      // If DXF, proceed directly
      onUpload(file);
      EdgeOrREST(null, 'CONVERT_TO_DXF', (response) => { }, file);
    } else {
      // Otherwise, convert to DXF first
      dispatch(notificationActions.UpdateImageLoad({ imageLoad: true }));
      EdgeOrREST(
        null,
        'CONVERT_TO_DXF',
        (response) => {
          dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));
          if (response && response.dxf) {
            // Create a new File object from the returned DXF data
            const dxfBlob = new Blob([response.dxf], { type: 'application/dxf' });
            const dxfFile = new File([dxfBlob], file.name.replace(/\.[^/.]+$/, ".dxf"), { type: 'application/dxf' });

            onUpload(response.dxf);
          } else {
            setSnack({
              open: true,
              message: "Conversion to DXF failed.",
              severity: 'error'
            });
          }
        },
        file
      );
    }
    if (threeDView) handle3dView();
  };

  const handleUpdateClick = async () => {
    try {
      const [fileHandle] = await window.showOpenFilePicker({
        types: [
          {
            description: 'Drawing Files',
            accept: {
              'application/octet-stream': ['.dwg', '.dxf'],
            },
          },
        ],
        excludeAcceptAllOption: true,
        multiple: false,
      });

      const file = await fileHandle.getFile();
      onUpload(file);
    } catch (err) {
      console.error(err);
    }
  };

  const onUpload = async (file, baseGrids) => {
    if (!file || !viewer) return;
    let text;
    let fileObj = file;

    // If file is a string (DXF content), convert to Blob/File
    if (typeof file === "string") {
      text = file;
      fileObj = new Blob([file], { type: 'application/dxf' });
    } else if (typeof file.text === "function") {
      text = await file.text();
    } else {
      text = file;
    }

    let parsed;
    try {
      parsed = new DxfParser().parseSync(text);
    } catch (err) {
      console.error(err);
      return;
    }
    lastParsedDxfRef.current = parsed;
    // 1) Load into viewer
    const url = URL.createObjectURL(fileObj);
    await viewer.Load({
      modelId: "uploaded-dxf",
      name: file.name || "uploaded.dxf",
      url,
    });
    URL.revokeObjectURL(url);

    // 2) Build your layers array, but only mark 'visible' for ones that actually got objects
    const layerEntries = Object.entries(parsed.tables.layer.layers);
    const newLayers = layerEntries.map(([name, rec]) => {
      const hasObjects = viewer.layers.has(name);            // do we have a group for it?
      return {
        name,
        visible: hasObjects ? rec.visible : false,           // only “visible” if it has objects
        hasObjects                                         // remember for the UI
      };
    });
    const uuidMap = {};
    const pickableMeshes = [];

    const scene = viewer.GetScene(); // Three.js Scene

    viewer.layers.forEach((layerInfo, layerName) => {
      layerInfo.objects.forEach(o => {
        const meshUuid = o.uuid;
        uuidMap[meshUuid] = layerName;
        // find the actual Three.js object in the scene by its UUID
        const mesh = scene.getObjectByProperty('uuid', meshUuid);
        if (mesh) {
          pickableMeshes.push(mesh);
        }
      });
    });
    uuidToLayerRef.current = uuidMap;
    pickableObjectsRef.current = pickableMeshes;
    setLayers(newLayers);
    onSetDxfImage(parsed, baseGrids);
    syncStageFromViewer();
    setSnack({
      open: true,
      message: "Drawing loaded successfully.",
      severity: 'success',
      action: 'upload completed'
    });
  };

  const onConvertToSVG = (response) => {
    if (response) {
      const { svg, pixelsToMetersX, pixelsToMetersY, drawingFiles } = response;
      onSetSvgImage(svg, 1);
      if (drawingFiles != null || drawingFiles != undefined) setDrawings(drawingFiles);
      setSnack({
        open: true,
        message: "Drawing converted to svg successfully.",
        severity: 'success',
        action: 'upload completed'
      });
      dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));
    }
  };

  const findSceneObjectByUuid = uuid => {
    const scene = viewer.GetScene();
    return scene.getObjectByProperty('uuid', uuid);
  }

  const toggleLayer = (layerName, checked) => {
    if (layerName === "all" && typeof checked === "boolean") {
      // Toggle all layers to 'checked'
      setLayers(prev =>
        prev.map(l => ({ ...l, visible: checked }))
      );
      // Show/hide all objects in all layers
      [...viewer.layers.values()].forEach(layerInfo => {
        layerInfo.objects.forEach(o => {
          const mesh = findSceneObjectByUuid(o.uuid);
          if (mesh) mesh.visible = checked;
        });
      });
    } else {
      // Flip just one layer
      setLayers(prev =>
        prev.map(l =>
          l.name === layerName ? { ...l, visible: !l.visible } : l
        )
      );
      const newVisible = !layers.find(l => l.name === layerName)?.visible;
      const layerInfo = viewer.layers.get(layerName);
      if (!layerInfo) return;
      layerInfo.objects.forEach(o => {
        const mesh = findSceneObjectByUuid(o.uuid);
        if (mesh) mesh.visible = newVisible;
      });
    }

    // Always re-render
    viewer.renderer.render(viewer.scene, viewer.camera);
  };


  const highlightLayer = layerName => {
    const layerInfo = viewer.layers.get(layerName);
    if (!layerInfo) return;

    layerInfo.objects.forEach(o => {
      const mesh = findSceneObjectByUuid(o.uuid);
      if (mesh && mesh.material && !mesh.userData._origMaterial) {
        mesh.userData._origMaterial = mesh.material;
        const matClone = mesh.material.clone();
        if (matClone.uniforms?.color) {
          matClone.uniforms.color.value.setHex(0x0000ff);
        } else if (matClone.color) {
          matClone.color.setHex(0x0000ff);
        }
        mesh.material = matClone;
      }
    });

    viewer.renderer.render(viewer.scene, viewer.camera);
  };

  const resetHighlight = layerName => {
    const layerInfo = viewer.layers.get(layerName);
    if (!layerInfo) return;

    layerInfo.objects.forEach(o => {
      const mesh = findSceneObjectByUuid(o.uuid);
      if (mesh && mesh.userData._origMaterial) {
        mesh.material.dispose();
        mesh.material = mesh.userData._origMaterial;
        delete mesh.userData._origMaterial;
      }
    });

    viewer.renderer.render(viewer.scene, viewer.camera);
  };

  const normalizeAngle360 = (angle) => {
    const numeric = Number(angle);
    if (!Number.isFinite(numeric)) return 0;
    return ((numeric % 360) + 360) % 360;
  };

  // UI angle convention: 0=N, 90=E, 180=S, 270=W.
  // Area calc expects mathematical orientation: 0=E, 90=N, 180=W, 270=S.
  const uiAngleToStoredAngle = (uiAngle) => normalizeAngle360(360 - normalizeAngle360(uiAngle));
  const uiAngleToAreaCalcAngle = (uiAngle) => normalizeAngle360(90 + normalizeAngle360(uiAngle));

  const doAreaCalc = (e) => {
    if (columns.length > 0 && (image != null || viewer != null) && state.LuminaireCfg.selectedLuminaireIds != null && state.LuminaireCfg.selectedLuminaireIds.length > 0) {
      var strGrids = JSON.stringify(grids);
      var tempGrids = JSON.parse(strGrids)
      for (var i = 0; i < tempGrids.length; i++) {
        var grid = tempGrids[i];
        if (i == 0) grid.contourGrid = true;
        var xSpacing = grid.xSpacing;
        var ySpacing = grid.ySpacing;
        var xPoints = Math.ceil(grid.origin.x.length / xSpacing);
        var yPoints = Math.ceil(grid.origin.y.length / ySpacing);

        while (xPoints * yPoints > 60000) {
          if (xPoints * yPoints > 60000) {
            xSpacing += 0.5;
            ySpacing += 0.5;
          }
          xPoints = Math.ceil(grid.origin.x.length / xSpacing);
          yPoints = Math.ceil(grid.origin.y.length / ySpacing);
        }

        grid.xSpacing = xSpacing;
        grid.ySpacing = ySpacing;
        grid.maxSpacing = Math.max(xSpacing, ySpacing);
        if (grid.type.toLowerCase() == "vertical") {
          const hasZ = grid.origin?.z && Number.isFinite(Number(grid.origin.z.length));
          const zStart = hasZ ? Number(grid.origin.z.start || 0) : 0;
          const zLength = hasZ && Number(grid.origin.z.length) > 0
            ? Number(grid.origin.z.length)
            : Number(grid.origin.y.length || 0);

          grid.origin.z = { start: zStart, length: zLength };
          grid.origin.y.length = 1;
        }
      }
      var calculationObject = API_OBJECTS.getCalculationObject(state, null, null);
      console.log("calculationObject", calculationObject);
      calculationObject["areaGrids"] = tempGrids;
      var lampPosts = [];
      for (i = 0; i < columns.length; i++) {
        var jsontemp = JSON.stringify(columns[i].values);
        var tempValues = JSON.parse(jsontemp);
        // console.log("columns[i + 1].values.point.x", columns[i].values.point.x);
        // console.log("columns[i + 1].values.point.y", columns[i].values.point.y);

        if (columns[i].isMast === true) {
          const lanterns = columns[i]?.values?.lanterns;
          tempValues.lanterns = Array.isArray(lanterns) ? [...lanterns] : [];
        } else {
          tempValues.lanterns = null;
        }

        const storedAreaAngle = Number(columns[i]?.values?.areaCalcPositionAngle);
        const uiAngle = normalizeAngle360(columns[i].values.positionAngle);
        const correctedUiAngle = uiAngleToStoredAngle(uiAngle);
        const calcAngleFromUi = uiAngleToAreaCalcAngle(correctedUiAngle);
        const normalizedStoredCalcAngle = normalizeAngle360(storedAreaAngle);
        const useStoredCalcAngle = Number.isFinite(storedAreaAngle)
          && Math.abs(normalizedStoredCalcAngle - calcAngleFromUi) < 0.01;
        tempValues.positionAngle = useStoredCalcAngle
          ? normalizedStoredCalcAngle
          : calcAngleFromUi;
        delete tempValues.areaCalcPositionAngle;

        console.log("tempValues", tempValues, columns);

        tempValues.luminaireId = columns[i].values.luminaireId;
        tempValues.point.x = columns[i].values.point.x / gridScaleX;
        tempValues.point.y = columns[i].values.point.y / gridScaleY;
        lampPosts.push(tempValues);
      }
      calculationObject["areaColumns"] = lampPosts;
      //masks only contain polygon square and circles 
      var maskConversions = [];
      for (i = 0; i < masks.length; i++) {
        var currMask = {};
        currMask.points = [];
        currMask.mode = masks[i].maskIn;
        currMask.layer = 0;
        currMask.rotation = masks[i].rotation;
        for (var j = 0; j < masks[i].points.length; j++) {
          // console.log("mask i points", masks[i].points);
          // console.log("j", j);
          // console.log("i", i);
          // console.log("masks[i].points[j].x", masks[i].points[j].x);
          currMask.points.push({ x: masks[i].points[j].x / gridScaleX, y: masks[i].points[j].y / gridScaleY });
        }
        if (masks[i].type == "circle") {
          currMask.type = "circle";
          currMask.radius = masks[i].radius / gridScaleX;
          currMask.scaleX = masks[i].scaleX;
          currMask.scaleY = masks[i].scaleY;
        } else if (masks[i].type == "polygon") {
          currMask.type = "polygon";
          if (overlayScale > 1) {
            currMask.points = currMask.points.map(pt => ({
              x: pt.x / overlayScale,
              y: pt.y / overlayScale
            }));
          }
        }
        if (masks[i].type == "rectangle") currMask.type = "polygon";
        maskConversions.push(currMask);
      }
      calculationObject["masks"] = maskConversions;
      console.log("onGetAreacalculationObject", calculationObject);
      calculationObject["luminaireIds"] = state.Plan.selectedLuminaires;
      calculationObject["customMsg"] = areaCalcMessageRef.current || "plan update";

      if (grids.length > 1) {
        calculationObject.roadGrids[0].calcGridClassValue = grids[1].gridClass;
        calculationObject.roadGrids[0].standard = grids[1].gridStandard;
        calculationObject.roadGrids[0].calcGridFile = grids[1].gridStandard;
      }

      console.log("calcObj", calculationObject)
      console.log("DXF grid debug", {
        grid0: tempGrids?.[0]?.origin,
        xSpacing: tempGrids?.[0]?.xSpacing,
        ySpacing: tempGrids?.[0]?.ySpacing,
        isStageYUp,
        contourLen: contourGridResults?.length,
        sampleColumnY: columns?.[0]?.values?.point?.y,
      });

      EdgeOrREST(null, "GET_AREA", onGetAreaCalc, calculationObject);
    } else {
      console.log("columns.length", columns.length, "image != null", image != null, "state.LuminaireCfg.selectedLuminaireIds != null", state.LuminaireCfg.selectedLuminaireIds != null, "state.LuminaireCfg.selectedLuminaireIds.length > 0", state.LuminaireCfg.selectedLuminaireIds.length > 0);
      setContourGridResults([]);
      setAreaResults([]);
      setAreaGridResults([]);
    }
  }

  useEffect(() => {
    doAreaCalc();
  }, [startCalc]);

  const onGetAreaCalc = ((response) => {
    console.log("onGetAreaCalc", response);
    if (response && response.data) {

      for (var i = 0; i < response.data.length; i++) {

        var item = response.data[i];
        if (item.calcResults?.outdoorResults[0]?.gridId == 0) {
          setContourGridResults(item.calcResults?.outdoorResults[0].contourResults);
        }
        break;
      }
      setAreaResults(response.data);
    }
  });

  const onLoadDrawings = (response) => {
    if (response) {
      setDrawings(response.drawingFiles);
    }
  }

  useEffect(() => {
    if (showTimerRef.current) {
      clearTimeout(showTimerRef.current);
      showTimerRef.current = null;
    }
    setShowTooltip(false);

    if (hoverLayer) {
      showTimerRef.current = setTimeout(() => {
        setShowTooltip(true);
        showTimerRef.current = null;
      }, 1000);
    }

    return () => {
      if (showTimerRef.current) {
        clearTimeout(showTimerRef.current);
        showTimerRef.current = null;
      }
    };
  }, [hoverLayer]);

  useEffect(() => {
    if (!dxfContainerRef.current) return;

    const observer = new ResizeObserver(entries => {
      window.requestAnimationFrame(() => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setContainerSize({ width, height });
        }
      });
    });

    observer.observe(dxfContainerRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const dxfCanvas = dxfContainerRef.current?.querySelector("canvas");
    if (dxfCanvas) {
      // Get CSS size
      const cssWidth = dxfContainerRef.current.clientWidth;
      const cssHeight = dxfContainerRef.current.clientHeight;
      const dpr = window.devicePixelRatio || 1;

      // Set canvas pixel size to CSS size * devicePixelRatio
      dxfCanvas.width = cssWidth * dpr;
      dxfCanvas.height = cssHeight * dpr;

      // Set canvas style size to CSS size
      dxfCanvas.style.width = `${cssWidth}px`;
      dxfCanvas.style.height = `${cssHeight}px`;

      // Scale the context so drawing operations are DPI-aware
      const ctx = dxfCanvas.getContext('2d');
      ctx?.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
  }, [containerSize, /* dxf loaded trigger */]);

  // ...existing code...

  useEffect(() => {
    setThrottleSceneFunc(false);
  }, [contourGridResults]);

  useEffect(() => {
    if (!dxfContainerRef.current) return;
    if (viewer) return;

    const options = {
      clearColor: new THREE.Color("#ffffff"),
      autoResize: true,
      colorCorrection: true,
    };

    const v = new DxfViewer(dxfContainerRef.current, options);

    setViewer(v);
    const controls = v.GetControls && v.GetControls();
    if (controls) {
      controls.enabled = false;      // key line: stops controls overriding camera
    }
  }, [viewer]);

  const syncStageFromViewer = useCallback((factorOverride) => {
    if (!viewer || !stageRef.current || !dxfContainerRef.current) return;
    if (!viewer.GetCamera || !viewer.GetCanvas) return;

    const stage = stageRef.current.getStage();
    const camera = viewer.GetCamera();
    const canvas = viewer.GetCanvas();
    if (!camera || !canvas) return;

    const rect = canvas.getBoundingClientRect();
    const factor = factorOverride ?? scaleFactor ?? 1; // metres per DXF unit

    // 1. Project DXF basis points to screen
    const dxfOriginX = (gridOffsetX || 0) / factor;
    const dxfOriginY = (gridOffsetY || 0) / factor;
    const world0 = new THREE.Vector3(dxfOriginX, dxfOriginY, 0);
    const world1x = new THREE.Vector3(dxfOriginX + 1, dxfOriginY, 0);
    const world1y = new THREE.Vector3(dxfOriginX, dxfOriginY + 1, 0);

    world0.project(camera);
    world1x.project(camera);
    world1y.project(camera);

    const ndcToScreen = (v) => ({
      x: ((v.x + 1) / 2) * rect.width,
      y: ((-v.y + 1) / 2) * rect.height,
    });

    const p0 = ndcToScreen(world0);
    const pxX = ndcToScreen(world1x);
    const pxY = ndcToScreen(world1y);

    const pxPerDxfX = pxX.x - p0.x;
    const pxPerDxfY = pxY.y - p0.y; // may be negative if Y is flipped

    // 2. Convert DXF → metres: 1 DXF unit = factor metres
    const pxPerMetreX = pxPerDxfX / factor;
    const pxPerMetreY = pxPerDxfY / factor;
    const minValidScale = 1e-5;
    if (
      !Number.isFinite(pxPerMetreX) ||
      !Number.isFinite(pxPerMetreY) ||
      Math.abs(pxPerMetreX) < minValidScale ||
      Math.abs(pxPerMetreY) < minValidScale
    ) {
      return;
    }

    // 3. Apply to Stage
    stage.scale({
      x: pxPerMetreX,
      y: pxPerMetreY,
    });
    setIsStageYUp(pxPerMetreY < 0);

    // world (0m,0m) == DXF (0,0) should land where p0 is on screen
    stage.position({
      x: p0.x,
      y: p0.y,
    });

    stage.batchDraw();
  }, [viewer, scaleFactor, gridOffsetX, gridOffsetY]);

  useEffect(() => {
    // Keep Konva stage mapping in lockstep with detected DXF unit scale (e.g. mm -> m).
    syncStageFromViewer();
  }, [syncStageFromViewer]);

  useEffect(() => {
    if (!viewer) return;
    const raf = requestAnimationFrame(() => syncStageFromViewer());
    return () => cancelAnimationFrame(raf);
  }, [viewer, containerSize.width, containerSize.height, syncStageFromViewer]);



  const handleWheel = (e) => {
    if (!viewer || !stageRef.current) return;
    if (!viewer.GetCamera || !viewer.GetCanvas || !viewer.SetView) return;

    e.evt.preventDefault();

    const stage = stageRef.current.getStage();
    const pointer = stage.getPointerPosition();
    if (!pointer) return;

    const camera = viewer.GetCamera();
    const canvas = viewer.GetCanvas();
    if (!camera || !canvas) return;

    const rect = canvas.getBoundingClientRect();
    const controls = viewer.GetControls && viewer.GetControls();

    // Use OrbitControls target as the real "center"
    const center = controls?.target
      ? controls.target.clone()
      : new THREE.Vector3(camera.position.x, camera.position.y, 0);

    const oldWidth = camera.right - camera.left;

    const scaleBy = 1.12;
    const zoomIn = e.evt.deltaY < 0;
    const factorZoom = zoomIn ? 1 / scaleBy : scaleBy;

    const newWidth = oldWidth * factorZoom;
    const ratio = newWidth / oldWidth;

    // Convert mouse position to world coords under cursor (DXF units)
    const ndc = new THREE.Vector3(
      (pointer.x / rect.width) * 2 - 1,
      -(pointer.y / rect.height) * 2 + 1,
      0
    );
    ndc.unproject(camera);
    const pointerWorld = ndc;


    // Zoom around pointer: keep pointerWorld under cursor
    const newCenter = new THREE.Vector3(
      pointerWorld.x + (center.x - pointerWorld.x) * ratio,
      pointerWorld.y + (center.y - pointerWorld.y) * ratio,
      0
    );

    viewer.SetView(newCenter, newWidth);

    // Keep controls consistent so it doesn't snap back
    if (controls) {
      controls.target.set(newCenter.x, newCenter.y, 0);
      controls.update();
    }

    if (viewer.Render) viewer.Render();

    // Update Konva Stage from viewer camera
    syncStageFromViewer();
    requestAnimationFrame(() => {
      const appliedScale = stageRef.current?.scaleX?.();
      if (Number.isFinite(appliedScale)) {
        setScaleInput((appliedScale / 1.5).toFixed(2));
      }
    });
  };


  const handleMouseDown = (e) => {
    const stage = stageRef.current?.getStage();
    if (!stage || !viewer) return;

    // left button only

    if (e.evt.button !== 2) return;
    e.evt.preventDefault();

    const pointer = stage.getPointerPosition();
    if (!pointer) return;

    isPanningRef.current = true;
    lastPointerRef.current = { x: pointer.x, y: pointer.y };
  };


  const handleMouseMove = (e) => {
    if (!isPanningRef.current) return;
    if (!viewer || !stageRef.current) return;

    const stage = stageRef.current.getStage();
    const pointer = stage.getPointerPosition();
    if (!pointer) return;

    panPointerRef.current = pointer;
    if (panFramePendingRef.current) return;
    panFramePendingRef.current = true;

    requestAnimationFrame(() => {
      panFramePendingRef.current = false;
      const latestPointer = panPointerRef.current;
      const last = lastPointerRef.current;
      if (!latestPointer || !last) return;

      const dx = latestPointer.x - last.x;
      const dy = latestPointer.y - last.y;
      if (dx === 0 && dy === 0) return;

      if (!viewer.GetCamera || !viewer.GetCanvas || !viewer.SetView) return;

      const { rect, worldWidth, worldHeight, center, controls } = getViewState();

      // screen delta -> world delta
      const worldDx = (dx * worldWidth) / rect.width;
      const worldDy = (-dy * worldHeight) / rect.height;

      // Move center opposite to drag so content follows pointer
      const newCenter = new THREE.Vector3(
        center.x - worldDx,
        center.y - worldDy,
        0
      );

      viewer.SetView(newCenter, worldWidth);

      // Keep OrbitControls from snapping back
      if (controls) {
        controls.target.set(newCenter.x, newCenter.y, 0);
        controls.update();
      }

      if (viewer.Render) viewer.Render();
      syncStageFromViewer();
      lastPointerRef.current = { x: latestPointer.x, y: latestPointer.y };
    });
  };
  const getViewState = () => {
    const camera = viewer.GetCamera();
    const canvas = viewer.GetCanvas();
    const controls = viewer.GetControls && viewer.GetControls();

    const rect = canvas.getBoundingClientRect();
    const worldWidth = camera.right - camera.left;
    const worldHeight = camera.top - camera.bottom;

    // OrbitControls center (world space)
    const center = controls?.target
      ? controls.target.clone()
      : new THREE.Vector3(
        camera.position.x,
        camera.position.y,
        0
      );

    return { camera, rect, worldWidth, worldHeight, center, controls };
  };

  const setViewerDisplayZoom = useCallback((displayZoom) => {
    if (!viewer || !stageRef.current || !viewer.GetCamera || !viewer.SetView) return false;

    const targetDisplayZoom = Number(displayZoom);
    if (!Number.isFinite(targetDisplayZoom) || targetDisplayZoom <= 0) return false;

    const currentScale = Math.max(0.0001, stageRef.current.scaleX?.() || stage.scale || 1);
    const targetActualScale = targetDisplayZoom * 1.5;
    const widthFactor = currentScale / targetActualScale;
    const { worldWidth, center, controls } = getViewState();

    if (!Number.isFinite(worldWidth) || worldWidth <= 0) return false;

    viewer.SetView(center, worldWidth * widthFactor);
    if (controls) {
      controls.target.set(center.x, center.y, 0);
      controls.update();
    }
    if (viewer.Render) viewer.Render();
    syncStageFromViewer();
    setScaleInput(targetDisplayZoom.toFixed(2));
    return true;
  }, [viewer, stage.scale, syncStageFromViewer]);

  useEffect(() => {
    if (!viewer || currentDrawingId != null || loadingConfigRef.current) return;
    if (placeholderDxfLoadedRef.current || lastParsedDxfRef.current) return;

    placeholderDxfLoadedRef.current = true;
    onUpload(generateBasicBorderDxf()).then(() => {
      setValidDrawing(true);
      triggerAreaCalc("loaded default drawing");
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setViewerDisplayZoom(DEFAULT_PLACEHOLDER_DISPLAY_ZOOM);
        });
      });
    }).catch((error) => {
      placeholderDxfLoadedRef.current = false;
      console.error("Failed to load placeholder DXF", error);
    });
  }, [viewer, currentDrawingId, triggerAreaCalc, setViewerDisplayZoom]);


  const endPan = () => {
    isPanningRef.current = false;
    panFramePendingRef.current = false;
    panPointerRef.current = null;
    lastPointerRef.current = null;
  };

  const handleMouseUp = () => endPan();
  const handleMouseLeave = () => endPan();

  useEffect(() => {
    const stage = stageRef.current?.getStage();
    if (!stage) return;

    const container = stage.container();
    const prevent = (evt) => evt.preventDefault();

    container.addEventListener("contextmenu", prevent);

    return () => {
      container.removeEventListener("contextmenu", prevent);
    };
  }, []);

  const updateGrid = (e, i, isTransform, newWidth, newHeight, newRotation, overrideWorldStart) => {
    console.log("updateGrid", e, i, isTransform, newWidth, newHeight, newRotation);

    const tempGrids = JSON.parse(JSON.stringify(grids));
    const gridIndexById = tempGrids.findIndex((g) => g.id === i);
    const gridIndex = gridIndexById !== -1 ? gridIndexById : i;
    if (!Number.isInteger(gridIndex) || gridIndex < 0 || gridIndex >= tempGrids.length) {
      console.warn("updateGrid: invalid grid reference", { i, gridIndex, gridsLength: tempGrids.length });
      return;
    }
    const tempGrid = JSON.parse(JSON.stringify(tempGrids[gridIndex]));
    const isVerticalGrid = String(tempGrid?.type || "").toLowerCase() === "vertical";
    console.log("tempGrid", tempGrid);
    const hasOverrideStart = !!overrideWorldStart
      && Number.isFinite(overrideWorldStart.x)
      && Number.isFinite(overrideWorldStart.y);
    if (isTransform) {
      const widthWorld = (newWidth / gridScaleX) / overlayScale;
      const heightWorld = (newHeight / gridScaleY) / overlayScale;
      const rawX = (e?.target?.attrs?.x / gridScaleX) / overlayScale;
      const rawY = toWorldY((e?.target?.attrs?.y / gridScaleY) / overlayScale);
      const xWorld = hasOverrideStart ? overrideWorldStart.x : rawX;
      const yWorld = hasOverrideStart ? overrideWorldStart.y : rawY;
      tempGrid.origin.x.start = parseFloat(xWorld).toFixed(2);
      tempGrid.origin.x.length = parseFloat(widthWorld).toFixed(2);

      tempGrid.origin.y.start = parseFloat(yWorld).toFixed(2);
      tempGrid.origin.y.length = isVerticalGrid ? 1 : parseFloat(heightWorld).toFixed(2);

      tempGrid.angle = parseFloat(newRotation.toFixed(2));
    } else {
      const rawX = (e?.currentTarget?.attrs?.x / gridScaleX) / overlayScale;
      const rawY = toWorldY((e?.currentTarget?.attrs?.y / gridScaleY) / overlayScale);
      const xWorld = hasOverrideStart ? overrideWorldStart.x : rawX;
      const yWorld = hasOverrideStart ? overrideWorldStart.y : rawY;
      tempGrid.origin.x.start = parseFloat(xWorld).toFixed(2);
      tempGrid.origin.y.start = parseFloat(yWorld).toFixed(2);
      if (isVerticalGrid) {
        tempGrid.origin.y.length = 1;
      }
    }
    console.log("updated tempGrid", tempGrid);
    tempGrids[gridIndex] = tempGrid;
    setGrids(tempGrids);
    triggerAreaCalc("moved grid");
  };

  // const updateVerticalGrid = (e, gridId, visualWidth, newRotation) => {
  //   const tempGrids = JSON.parse(JSON.stringify(grids));
  //   const gridIndex = tempGrids.findIndex(g => g.id === gridId);
  //   if (gridIndex === -1) return;

  //   const tempGrid = tempGrids[gridIndex];
  //   const node = e.target;

  //   if (visualWidth !== undefined || newRotation !== undefined) {
  //     // Transform: only update length/rotation, keep start position unchanged
  //     if (visualWidth !== undefined) {
  //       tempGrid.origin.x.length = visualWidth / gridScaleX / dxfScale;
  //     }
  //     if (newRotation !== undefined) {
  //       tempGrid.angle = newRotation;
  //     }
  //     // Reset node position and scale
  //     node.x(0);
  //     node.y(0);
  //     node.scaleX(1);
  //     node.scaleY(1);
  //   } else {
  //     // Drag: update start position only
  //     const points = node.attrs.points;
  //     const nodeX = node.x();
  //     const nodeY = node.y();
  //     let xStart, yStart;
  //     if (Array.isArray(points) && points.length >= 4) {
  //       xStart = nodeX + points[0];
  //       yStart = nodeY + points[1];
  //     } else {
  //       xStart = Number(tempGrid.origin.x.start) * gridScaleX * dxfScale;
  //       yStart = Number(tempGrid.origin.y.start) * gridScaleY * dxfScale;
  //     }
  //     tempGrid.origin.x.start = xStart / gridScaleX / dxfScale;
  //     tempGrid.origin.y.start = yStart / gridScaleY / dxfScale;
  //     node.x(0);
  //     node.y(0);
  //   }

  //   tempGrid.origin.y.length = 1; // vertical grid always has height 1

  //   tempGrids[gridIndex] = tempGrid;
  //   setGrids(tempGrids);
  //   setStartCalc(Date.now());
  // }

  const updateGridOnSave = (i, newName, newColor, gridStandard, gridClass, xSpacing, ySpacing, nameVisibility, edgeStart, showValues, opacity, tempGrids) => {
    if (!tempGrids?.[i]) return;

    const nextGrids = JSON.parse(JSON.stringify(tempGrids));

    nextGrids[i].name = newName;
    nextGrids[i].color = newColor;
    nextGrids[i].visible = nameVisibility;
    nextGrids[i].edgeStart = edgeStart;
    nextGrids[i].showValues = showValues;
    nextGrids[i].opacity = opacity;

    if (xSpacing != nextGrids[i].xSpacing || ySpacing != nextGrids[i].ySpacing) {
      nextGrids[i].xSpacing = xSpacing;
      nextGrids[i].ySpacing = ySpacing;
    }

    if (gridStandard != nextGrids[i].gridStandard || gridClass != nextGrids[i].gridClass) {
      nextGrids[i].gridStandard = gridStandard;
      nextGrids[i].gridClass = gridClass
    }

    setGrids(nextGrids);
    triggerAreaCalc("updated grid");
  };

  const updateGridResults = (i, checked) => {
    if (!grids[i]) return;

    let tempGrids = JSON.parse(JSON.stringify(grids));
    tempGrids[i].showResults = checked;
    tempGrids[i].locked = checked == true ? true : tempGrids[i].locked;
    tempGrids[i].selected = false;

    setGrids(tempGrids);
  };


  const deleteGrid = (id) => {
    setGrids(grids.filter((item) => item.id !== id));
    if (grids.length > 1) {
      triggerAreaCalc("deleted grid");
    }
  };

  const getNextGridId = (gridList = []) => {
    const numericIds = gridList
      .map(grid => Number(grid?.id))
      .filter(id => Number.isFinite(id));

    if (numericIds.length === 0) return 0;
    return Math.max(...numericIds) + 1;
  };

  const normalizeGridIds = (gridList = []) => {
    const seenIds = new Set();
    let nextId = getNextGridId(gridList);
    let changed = false;

    const normalized = gridList.map((grid, index) => {
      const numericId = Number(grid?.id);
      const preferredId = Number.isFinite(numericId) ? numericId : nextId++;

      if (!seenIds.has(preferredId)) {
        seenIds.add(preferredId);
        if (preferredId !== grid.id) {
          changed = true;
          return { ...grid, id: preferredId };
        }
        return grid;
      }

      while (seenIds.has(nextId)) {
        nextId += 1;
      }

      const reassignedId = nextId;
      nextId += 1;
      seenIds.add(reassignedId);
      changed = true;
      return { ...grid, id: reassignedId };
    });

    return { normalized, changed };
  };


  const selectGrid = (id) => {
    if (isCanvasSelectionBlocked()) {
      return;
    }
    let tempGrids = [...grids];
    if (!multipleSelect) {
      unselectOther('grid');
      const gridIndex = tempGrids.findIndex(grid => grid.id === id);
      if (gridIndex !== -1) {
        if (tempGrids[gridIndex].selected === false) {
          tempGrids = tempGrids.map((grid) => ({
            ...grid,
            selected: grid.id === id ? !grid.selected : false,
          }));
        } else {
          const selectedCount = tempGrids.filter(grid => grid.selected).length;
          if (selectedCount > 1) {
            tempGrids[gridIndex].selected = true;
            tempGrids = tempGrids.map((grid) => ({
              ...grid,
              selected: grid.id === id ? true : false,
            }));
          } else {
            tempGrids[gridIndex].selected = !tempGrids[gridIndex].selected;
          }
        }
      }
    } else {
      const gridIndex = tempGrids.findIndex(grid => grid.id === id);
      if (gridIndex !== -1) {
        tempGrids[gridIndex].selected = !tempGrids[gridIndex].selected;
      }
    }

    const updatedGrid = tempGrids.find(grid => grid.id === id);
    if (updatedGrid) updatedGrid.locked = false;

    setGrids(tempGrids);
  };

  const unselectOther = (type) => {
    if (type === 'column') {
      setGrids(grids.map(grid => ({ ...grid, selected: false })));
      setMasks(masks.map(mask => ({ ...mask, selected: false })));
    } else if (type === 'grid') {
      setColumns(columns.map(column => ({ ...column, selected: false })));
      setMasks(masks.map(mask => ({ ...mask, selected: false })));
    } else if (type === 'mask') {
      setColumns(columns.map(column => ({ ...column, selected: false })));
      setGrids(grids.map(grid => ({ ...grid, selected: false })));
    }
  }

  const deleteColumn = (id) => {
    setColumns(columns.filter((column) => column.id !== id));
    triggerAreaCalc("deleted column");
  };

  const isColumnGroupLocked = (columnId) => {
    const group = columnGroups.find(currGroup => currGroup.columnIds?.includes(columnId));
    return Boolean(group?.locked);
  };

  const isCanvasSelectionBlocked = () => {
    return cursorType === 'crosshair' || maskMode || isDrawing || measureMode;
  };


  const selectColumn = (id) => {
    if (isCanvasSelectionBlocked()) {
      return;
    }
    let tempColumns = [...columns];
    const targetColumn = tempColumns.find(column => column.id === id);
    if (!targetColumn || isColumnGroupLocked(id)) {
      return;
    }
    if (!multipleSelect) {
      unselectOther('column');
      const columnIndex = tempColumns.findIndex(columns => columns.id === id);
      if (columnIndex !== -1) {
        if (tempColumns[columnIndex].selected === false) {
          tempColumns = tempColumns.map((column) => ({
            ...column,
            selected: column.id === id ? !column.selected : false,
          }));
        } else {
          const selectedCount = tempColumns.filter(column => column.selected).length;
          if (selectedCount > 1) {
            tempColumns[columnIndex].selected = true;
            tempColumns = tempColumns.map((column) => ({
              ...column,
              selected: column.id === id ? true : false,
            }));
          } else {
            tempColumns[columnIndex].selected = !tempColumns[columnIndex].selected;
          }
        }
      }
    } else {
      const columnIndex = tempColumns.findIndex(column => column.id === id);
      if (columnIndex !== -1) {
        tempColumns[columnIndex].selected = !tempColumns[columnIndex].selected;
      }
    }

    setColumns(tempColumns);
  };


  const updateColumn = (e, i) => {
    console.log("updateColumn", e, i);
    const tempColumns = [...columns];
    const col = tempColumns[i];
    if (!col || isColumnGroupLocked(col.id)) return;

    // Calculate the difference between the new and original position
    const originalX = col.values.point.x;
    const originalY = col.values.point.y;
    const newX = e.currentTarget.attrs.x;
    const newY = e.currentTarget.attrs.y;
    const newWorldX = newX / overlayScale;
    const newWorldY = toWorldY(newY / overlayScale);
    const dx = newWorldX - originalX;
    const dy = newWorldY - originalY;

    // Update the selected column's position
    col.values.point.x = newWorldX;
    col.values.point.y = newWorldY;

    // Apply the same position difference to all other columns within the same columnGroup and sync is true
    // Find the group this column belongs to
    const group = columnGroups.find(g => g.columnIds.includes(col.id) && g.sync);
    if (group) {
      group.columnIds.forEach(colId => {
        if (colId !== col.id) {
          const idx = tempColumns.findIndex(c => c.id === colId);
          if (idx !== -1 && !isColumnGroupLocked(tempColumns[idx].id)) {
            tempColumns[idx].values.point.x += dx;
            tempColumns[idx].values.point.y += dy;
          }
        }
      });
    }

    setColumns(tempColumns);
    triggerAreaCalc("moved column");
  }

  const handleScaleChange = (event) => {
    setScaleInput(event.target.value);
  };

  useEffect(() => {
    if (isEditingScale && scaleInputRef.current) {
      scaleInputRef.current.select();
    }
  }, [isEditingScale]);

  const handleTextClick = () => {
    const liveScale = stageRef.current?.scaleX?.() ?? stage.scale ?? 1;
    const displayScale = liveScale / 1.5;
    setIsEditingScale(true);
    setScaleInput(Number(displayScale).toFixed(2));
  };

  const handleScaleBlur = () => {
    let newScale = parseFloat(scaleInput);

    const MIN_SCALE = 0.01;
    const MAX_SCALE = 25;

    if (newScale < MIN_SCALE) {
      newScale = MIN_SCALE;
    } else if (newScale > MAX_SCALE) {
      newScale = MAX_SCALE;
    }

    const targetActualScale = newScale * 1.5;

    if (!isNaN(newScale)) {
      if (viewer && stageRef.current && viewer.GetCamera && viewer.SetView) {
        const currentScale = Math.max(0.0001, stageRef.current.scaleX() || stage.scale || 1);
        // Stage scale is inversely proportional to camera world width.
        // To go from currentScale -> newScale, width must be scaled by current/new.
        const widthFactor = currentScale / targetActualScale;
        const { worldWidth, center, controls } = getViewState();
        const startWidth = worldWidth;
        const endWidth = worldWidth * widthFactor;
        const start = performance.now();
        const duration = 320;
        const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

        const animate = (now) => {
          const t = Math.min(1, (now - start) / duration);
          const eased = easeInOut(t);
          const currentWidth = startWidth + (endWidth - startWidth) * eased;

          viewer.SetView(center, currentWidth);
          if (controls) {
            controls.target.set(center.x, center.y, 0);
            controls.update();
          }
          if (viewer.Render) viewer.Render();
          syncStageFromViewer();

          if (t < 1) {
            requestAnimationFrame(animate);
          } else {
            const appliedScale = stageRef.current?.scaleX?.() ?? targetActualScale;
            setScaleInput((appliedScale / 1.5).toFixed(2));
          }
        };

        requestAnimationFrame(animate);
      } else if (stageRef.current) {
        const stageWidth = stageRef.current.width();
        const stageHeight = stageRef.current.height();

        const currentPosition = stageRef.current.position();
        const currentScale = stageRef.current.scaleX();

        const scaleFactor = targetActualScale / currentScale;

        const newX = currentPosition.x * scaleFactor + (stageWidth / 2) * (1 - scaleFactor);
        const newY = currentPosition.y * scaleFactor + (stageHeight / 2) * (1 - scaleFactor);

        new Konva.Tween({
          node: stageRef.current,
          duration: 0.5,
          easing: Konva.Easings.EaseInOut,
          scaleX: targetActualScale,
          scaleY: targetActualScale,
          x: newX,
          y: newY,
          onUpdate: () => {
            if (dxfContainerRef.current && stageRef.current) {
              const sx = stageRef.current.x();
              const sy = stageRef.current.y();
              const s = stageRef.current.scaleX();
              dxfContainerRef.current.style.transform = `translate(${sx}px, ${sy}px) scale(${s})`;
            }
          },
          onFinish: () => {
            if (layerRef.current) {
              layerRef.current.batchDraw();
            }
            // Ensure DXF container is exactly in sync at the end
            if (dxfContainerRef.current) {
              dxfContainerRef.current.style.transform = `translate(${newX}px, ${newY}px) scale(${targetActualScale})`;
            }
            setStage({ scale: targetActualScale, x: newX, y: newY });
            setScaleInput((targetActualScale / 1.5).toFixed(2));
          },
        }).play();
      }
    }

    if (stageRef.current) {
      const appliedScale = stageRef.current.scaleX();
      setScaleInput((appliedScale / 1.5).toFixed(2));
    }

    setIsEditingScale(false);
  };

  const handleColumnSearchChange = (event) => {
    setColumnSearchTerm(event.target.value);
  };


  const handleGridSearchChange = (event) => {
    setGridSearchTerm(event.target.value.toLowerCase());
  };

  const handleMaskSearchChange = (event) => {
    setMaskSearchTerm(event.target.value.toLowerCase());
  };

  const handleDrawingFileSearchChange = (event) => {
    setDrawingFileSearchTerm(event.target.value.toLowerCase());
  };
  const handleLayerSearchChange = (event) => {
    setLayerSearchTerm(event.target.value.toLowerCase());
  };
  const filteredColumns = columns.filter((column) =>
    column.name.toLowerCase().includes(columnSearchTerm)
  );

  const filteredGrids = grids.filter((grid) =>
    grid.name.toLowerCase().includes(gridSearchTerm)
  );

  const filteredMasks = masks.filter((mask) =>
    mask.name.toLowerCase().includes(maskSearchTerm)
  );

  const filteredDrawingFiles = drawings.filter((drawing) =>
    drawing.name.toLowerCase().includes(drawingFileSearchTerm)
  );

  const handleFileSort = () => {
    const sortOrderCycle = [null, "nameAsc", "nameDesc", "dateAsc", "dateDesc"];
    const nextIndex = (sortOrderCycle.indexOf(fileSortState) + 1) % sortOrderCycle.length;
    setFileSortState(sortOrderCycle[nextIndex]);
  };

  const handleSort = () => {
    const sortOrderCycle = [null, "nameAsc", "nameDesc", "selectedAsc", "selectedDesc"];
    const nextIndex = (sortOrderCycle.indexOf(sortState) + 1) % sortOrderCycle.length;
    setSortState(sortOrderCycle[nextIndex]);
  };

  const getFileSortLabel = () => {
    switch (fileSortState) {
      case "nameAsc": return "Name ▲";
      case "nameDesc": return "Name ▼";
      case "dateAsc": return "Date ▲";
      case "dateDesc": return "Date ▼";
      default: return "None";
    }
  };

  const getSortLabel = () => {
    switch (sortState) {
      case "nameAsc": return "Name ▲";
      case "nameDesc": return "Name ▼";
      case "selectedAsc": return "Selected ▲";
      case "selectedDesc": return "Selected ▼";
      default: return "None";
    }
  };

  const sortedDrawingFiles = [...(filteredDrawingFiles || [])].sort((a, b) => {
    if (!fileSortState) return 0;
    let comparison = 0;

    if (fileSortState === "nameAsc" || fileSortState === "nameDesc") {
      comparison = a.name.localeCompare(b.name);
    } else if (fileSortState === "dateAsc" || fileSortState === "dateDesc") {
      comparison = new Date(a.createDate) - new Date(b.createDate);
    }

    return (fileSortState === "nameDesc" || fileSortState === "dateDesc") ? -comparison : comparison;
  });


  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleScaleBlur();
    }
  };

  const updateRotate = (newAngle, index) => {
    const tempColumns = [...columns];
    const col = tempColumns[index];
    if (!col || isColumnGroupLocked(col.id)) return;

    const normalizedAngle = normalizeAngle360(newAngle);

    // Calculate the difference between the new and original angle
    const originalAngle = parseFloat(col.values.positionAngle) || 0;
    const angleDiff = normalizedAngle - originalAngle;

    // Update the selected column
    col.values.positionAngle = normalizedAngle.toFixed(2);
    col.values.areaCalcPositionAngle = uiAngleToAreaCalcAngle(normalizedAngle);

    // Apply the same angle difference to all other columns within the same columnGroup and sync is true
    // Find the group this column belongs to
    const group = columnGroups.find(g => g.columnIds.includes(col.id) && g.sync);
    if (group) {
      group.columnIds.forEach(colId => {
        if (colId !== col.id) {
          const idx = tempColumns.findIndex(c => c.id === colId);
          if (idx !== -1 && !isColumnGroupLocked(tempColumns[idx].id)) {
            let origAngle = parseFloat(tempColumns[idx].values.positionAngle) || 0;
            let newGroupAngle = origAngle + angleDiff;
            tempColumns[idx].values.positionAngle = newGroupAngle.toFixed(2);
            tempColumns[idx].values.areaCalcPositionAngle = uiAngleToAreaCalcAngle(newGroupAngle);
          }
        }
      });
    }

    tempColumns[index] = col;
    setColumns(tempColumns);
    triggerAreaCalc("updated column rotation");
  };

  const getTiltFromBeamLength = (beamLength, height = 6) => {
    const radians = Math.atan(height / beamLength);
    const tilt = 90 - (radians * (180 / Math.PI));
    return +tilt.toFixed(2);
  };



  const updateLanternRotation = (newAngle, newLength, index, lanternIndex) => {
    const tempColumns = [...columns];
    const col = tempColumns[index];
    const lanterns = [...col.values.lanterns];

    if (lanterns && lanterns[lanternIndex]) {
      const updatedLantern = {
        ...lanterns[lanternIndex],
        positionAngle: newAngle,
      };

      if (newLength != null && !isNaN(newLength)) {
        updatedLantern.beamAimingInfo.beamLength = newLength;
        updatedLantern.beamAimingInfo.tilt = getTiltFromBeamLength(newLength, col.values.height);
      }

      lanterns[lanternIndex] = updatedLantern;
    }

    tempColumns[index] = {
      ...col,
      values: {
        ...col.values,
        lanterns,
      },
    };

    console.log("tempColumns", tempColumns);

    setColumns(tempColumns);
    triggerAreaCalc("updated lantern aiming");
  };

  const updateLanternBeamEndpoint = ({
    beamEndPoint,
    beamLength,
    positionAngle,
    lanternIndex,
    columnIndex,
  }) => {
    const updatedColumns = [...columns];
    const column = updatedColumns[columnIndex];
    const lanterns = [...column.values.lanterns];
    const lantern = { ...lanterns[lanternIndex] };

    lantern.beamAimingInfo = {
      ...lantern.beamAimingInfo,
      beamEndPoint: {
        x: parseFloat(beamEndPoint.x.toFixed(2)),
        y: parseFloat(beamEndPoint.y.toFixed(2)),
      },
      beamLength: parseFloat(beamLength),
      tilt: getTiltFromBeamLength(beamLength, column.values.height),
    };

    lantern.positionAngle = parseFloat(Number(positionAngle).toFixed(2));

    lanterns[lanternIndex] = lantern;

    updatedColumns[columnIndex] = {
      ...column,
      values: {
        ...column.values,
        lanterns,
      },
    };

    setColumns(updatedColumns);
  };

  const fetchPolarInfo = (lanterns) => {
    if (!Array.isArray(lanterns) || lanterns.length === 0) return;

    const requestedIds = Array.from(
      new Set(
        lanterns
          .map((lantern) => lantern?.luminaireId)
          .filter(Boolean)
      )
    );
    if (requestedIds.length === 0) return;

    const loadedIds = new Set((polarInfo || []).map((item) => item?.luminaireId).filter(Boolean));
    const idsToFetch = requestedIds.filter(
      (id) => !loadedIds.has(id) && !polarFetchPendingRef.current.has(id)
    );

    if (idsToFetch.length === 0) return;

    idsToFetch.forEach((newId) => {
      polarFetchPendingRef.current.add(newId);

      const calcObj = API_OBJECTS.getCalculationObject(
        {
          ...state,
          LuminaireCfg: {
            ...state.LuminaireCfg,
            selectedResultLuminId: newId,
            selectedLuminaireIds: [newId],
          },
        },
        null,
        null
      );

      EdgeOrREST(null, "GET_POLAR", (response) => {
        polarFetchPendingRef.current.delete(newId);

        if (!(response?.data && response.status === 200)) return;

        const cleanedPolarData = { ...response.data };
        delete cleanedPolarData[0];
        delete cleanedPolarData[90];

        setPolarInfo((prev) => {
          const prevList = Array.isArray(prev) ? prev : [];
          const withoutCurrent = prevList.filter((item) => item?.luminaireId !== newId);
          return [
            ...withoutCurrent,
            { luminaireId: newId, polarData: cleanedPolarData },
          ];
        });
      }, calcObj);
    });
  };

  const updateLanterns = (newLanterns, columnIndex) => {
    setColumns((prevColumns) => {
      return prevColumns.map((col, idx) =>
        idx === columnIndex
          ? {
            ...col,
            values: {
              ...col.values,
              lanterns: newLanterns,
            },
          }
          : col
      );
    });
  };


  useEffect(() => {
    console.log("GridValues reference changed:", contourGridResults);
  }, [contourGridResults]);

  useEffect(() => {
    console.log("grids reference changed:", grids);
  }, [grids]);

  const focusColumn = (id) => {
    if (!validDrawing) {
      setSnack({
        open: true,
        message: "Please load a drawing first.",
        severity: 'warning'
      });
      return;
    };

    const column = columns.find(col => col.id === id);

    if (!isColumnGroupLocked(id) && !column.selected) selectColumn(id);

    if (!column || !stageRef.current) return;

    // Match the exact coordinate transform used by column rendering.
    const displayX = Number(column.values?.point?.x || 0) * overlayScale;
    const worldY = Number(column.values?.point?.y || 0);
    const renderY = shouldFlipY ? (worldHeightValue - worldY) : worldY;
    const displayY = renderY * overlayScale;

    // In DXF viewer mode, pan the viewer camera (not just Konva overlay), then resync stage.
    if (viewer && viewer.GetCamera && viewer.GetCanvas && viewer.SetView) {
      const camera = viewer.GetCamera();
      const canvas = viewer.GetCanvas();
      const controls = viewer.GetControls && viewer.GetControls();
      if (!camera || !canvas) return;

      const rect = canvas.getBoundingClientRect();
      const worldWidth = camera.right - camera.left;
      const worldHeight = camera.top - camera.bottom;
      const center = controls?.target
        ? controls.target.clone()
        : new THREE.Vector3(camera.position.x, camera.position.y, 0);

      const currentScaleX = stageRef.current.scaleX();
      const currentScaleY = stageRef.current.scaleY();
      const currentStagePos = stageRef.current.position();
      const columnScreenX = currentStagePos.x + displayX * currentScaleX;
      const columnScreenY = currentStagePos.y + displayY * currentScaleY;

      // Center to the visible plan viewport (excluding overlapping left/right drawers).
      const planRect = planRef.current?.getBoundingClientRect?.() || rect;
      const stageWidth = stageRef.current.width();
      const stageHeight = stageRef.current.height();
      const leftToolbarRect = document.querySelector('.planStep-left-toolbar')?.getBoundingClientRect?.();
      const rightToolbarRect = document.querySelector('.planStep-right-toolbar')?.getBoundingClientRect?.();
      const overlapWidth = (overlayRect) => {
        if (!overlayRect) return 0;
        const overlap = Math.max(0, Math.min(planRect.right, overlayRect.right) - Math.max(planRect.left, overlayRect.left));
        return overlap;
      };
      const leftObstruction = overlapWidth(leftToolbarRect);
      const rightObstruction = overlapWidth(rightToolbarRect);

      const targetScreenX = (leftObstruction + (stageWidth - rightObstruction)) / 2;
      const targetScreenY = stageHeight / 2;

      const dx = targetScreenX - columnScreenX;
      const dy = targetScreenY - columnScreenY;

      const worldDx = (dx * worldWidth) / rect.width;
      const worldDy = (-dy * worldHeight) / rect.height;
      const endCenter = new THREE.Vector3(
        center.x - worldDx,
        center.y - worldDy,
        0
      );

      const startCenter = center.clone();
      const duration = 450;
      const startTime = performance.now();
      const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

      const animate = (now) => {
        const t = Math.min(1, (now - startTime) / duration);
        const eased = easeInOut(t);
        const interpCenter = new THREE.Vector3(
          startCenter.x + (endCenter.x - startCenter.x) * eased,
          startCenter.y + (endCenter.y - startCenter.y) * eased,
          0
        );

        viewer.SetView(interpCenter, worldWidth);
        if (controls) {
          controls.target.set(interpCenter.x, interpCenter.y, 0);
          controls.update();
        }
        if (viewer.Render) viewer.Render();
        syncStageFromViewer();

        if (t < 1) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
      return;
    }

    // Non-viewer mode (image/PNG): pan Konva stage directly.
    const viewportWidth = planRef.current?.clientWidth || stageRef.current.width();
    const viewportHeight = planRef.current?.clientHeight || stageRef.current.height();
    const currentScale = stageRef.current.scaleX();
    const targetX = -displayX * currentScale + viewportWidth / 2;
    const targetY = -displayY * currentScale + viewportHeight / 2;

    new Konva.Tween({
      node: stageRef.current,
      duration: 0.6,
      easing: Konva.Easings.EaseInOut,
      x: targetX,
      y: targetY,
      onFinish: () => {
        setStage((prev) => ({ ...prev, x: targetX, y: targetY }));
        if (layerRef.current) {
          layerRef.current.batchDraw();
        }
      }
    }).play();
  };

  const handleSetColumns = (columns) => {
    setColumns(columns);
    triggerAreaCalc("updated columns");
  };

  useEffect(() => {
    setContourColors(state.ProjectConfig.contourColors);
  }, [state.ProjectConfig.contourColors]);

  useEffect(() => {
    setContourValues(state.ProjectConfig.contourValues);
  }, [state.ProjectConfig.contourValues]);

  useEffect(() => {
    setAutoContourValues(state.ProjectConfig.autoContourValues);
  }, [state.ProjectConfig.autoContourValues]);

  useEffect(() => {
    setHeatmap(state.ProjectConfig.heatmap);
  }, [state.ProjectConfig.heatmap]);

  useEffect(() => {
    setGreyscale(state.ProjectConfig.greyscale);
  }, [state.ProjectConfig.greyscale]);



  useEffect(() => {
    const downHandler = (e) => {
      if (e.key === 'Control' || e.key === 'Shift') {
        setMultipleSelect(true);
      }
    }
    const upHandler = (e) => {
      if (e.key === 'Control' || e.key === 'Shift') {
        setMultipleSelect(false);
      }
    }
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);

  // Delete selected items on delete key press
  useEffect(() => {
    const handleKeyDown = (e) => {
      const activeElement = document.activeElement;
      const isTyping = activeElement.tagName === "INPUT" ||
        activeElement.tagName === "TEXTAREA" ||
        activeElement.isContentEditable;

      if (!isTyping && (e.key === "Delete" || e.key === "Backspace")) {

        const anyGridSelected = grids.some(grid => grid.selected);
        const anyColumnSelected = columns.some(column => column.selected);
        const anyMaskSelected = masks.some(mask => mask.selected);

        if (anyGridSelected || anyColumnSelected || anyMaskSelected) {
          setGrids((prevGrids) => {
            const newGrids = prevGrids.filter(grid => !grid.selected);
            return newGrids;
          });

          setColumns((prevColumns) => {
            const newColumns = prevColumns.filter(column => !column.selected);
            return newColumns;
          });

          setMasks((prevMasks) => {
            const newMasks = prevMasks.filter(mask => !mask.selected);
            return newMasks;
          });

          triggerAreaCalc("deleted selection");
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [grids, columns, masks, shouldFlipY]);

  // Move selected items on arrow key
  useEffect(() => {
    const handleKeyDown = (e) => {
      const activeElement = document.activeElement;
      const isTyping = activeElement.tagName === "INPUT" ||
        activeElement.tagName === "TEXTAREA" ||
        activeElement.isContentEditable;

      // Delete selected items
      if (!isTyping && (e.key === "Delete" || e.key === "Backspace")) {
        const anyGridSelected = grids.some(grid => grid.selected);
        const anyColumnSelected = columns.some(column => column.selected);
        const anyMaskSelected = masks.some(mask => mask.selected);

        if (anyGridSelected || anyColumnSelected || anyMaskSelected) {
          setGrids((prevGrids) => prevGrids.filter(grid => !grid.selected));
          setColumns((prevColumns) => prevColumns.filter(column => !column.selected));
          setMasks((prevMasks) => prevMasks.filter(mask => !mask.selected));
          triggerAreaCalc("deleted selection");
        }
      }

      // Move selected items with arrow keys
      if (!isTyping && ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
        // Amount to move (in "drawing units")
        let moveAmount = 1;
        if (e.shiftKey) moveAmount = 10;
        if (e.altKey) moveAmount = 0.1;

        let dx = 0, dy = 0;
        if (e.key === "ArrowLeft") dx = -moveAmount;
        if (e.key === "ArrowRight") dx = moveAmount;
        if (e.key === "ArrowUp") dy = shouldFlipY ? moveAmount : -moveAmount;
        if (e.key === "ArrowDown") dy = shouldFlipY ? -moveAmount : moveAmount;

        // Move selected grids
        setGrids(prevGrids =>
          prevGrids.map(grid =>
            grid.selected
              ? {
                ...grid,
                origin: {
                  ...grid.origin,
                  x: {
                    ...grid.origin.x,
                    start: parseFloat(grid.origin.x.start) + dx,
                  },
                  y: {
                    ...grid.origin.y,
                    start: parseFloat(grid.origin.y.start) + dy,
                  },
                },
              }
              : grid
          )
        );

        // Move selected columns
        setColumns(prevColumns =>
          prevColumns.map(column =>
            column.selected
              ? {
                ...column,
                values: {
                  ...column.values,
                  point: {
                    x: parseFloat(column.values.point.x) + dx,
                    y: parseFloat(column.values.point.y) + dy,
                  },
                },
              }
              : column
          )
        );

        // Move selected masks (polygon, rectangle, circle)
        setMasks(prevMasks =>
          prevMasks.map(mask => {
            if (!mask.selected) return mask;
            if (mask.type === "polygon" && Array.isArray(mask.points)) {
              return {
                ...mask,
                points: mask.points.map(pt => ({
                  x: pt.x + dx,
                  y: pt.y + dy,
                })),
              };
            } else if (mask.type === "rectangle" || mask.type === "circle") {
              return {
                ...mask,
                x: (mask.x ?? 0) + dx,
                y: (mask.y ?? 0) + dy,
                points: mask.points
                  ? mask.points.map(pt => ({
                    x: pt.x + dx,
                    y: pt.y + dy,
                  }))
                  : mask.points,
              };
            }
            return mask;
          })
        );

        triggerAreaCalc("moved selection");
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [grids, columns, masks]);


  // ~~~~~~~~~~~~~~~~~~~~~~~~~
  // Undo/Redo Logic
  // ~~~~~~~~~~~~~~~~~~~~~~~~~

  const [history, setHistory] = React.useState([{ grids, columns, masks }]);
  const [currentStep, setCurrentStep] = React.useState(0);
  const isUndoRedoRef = React.useRef(false);

  const prevMaskDataRef = React.useRef({});
  const prevGridDataRef = React.useRef({});
  const prevColumnDataRef = React.useRef({});




  useEffect(() => {
    if (isUndoRedoRef.current) return;

    let newMasks = [...masks];

    const prevMaskIds = new Set(Object.keys(prevMaskDataRef.current));
    const currentMaskIds = new Set(newMasks.map(mask => mask.id));

    const maskChanged = newMasks.some((mask) => {
      const prevMaskData = prevMaskDataRef.current[mask.id];
      return (
        !prevMaskData ||
        prevMaskData.points !== JSON.stringify(mask.points) ||
        prevMaskData.rotation !== mask.rotation ||
        prevMaskData.scaleX !== mask.scaleX ||
        prevMaskData.scaleY !== mask.scaleY ||
        prevMaskData.x !== mask.x ||
        prevMaskData.y !== mask.y
      );
    });

    const maskAdded = newMasks.length > prevMaskIds.size;
    const maskDeleted = [...prevMaskIds].some(prevId => !currentMaskIds.has(prevId));

    if (!hasInitializedMaskTrackingRef.current || loadingConfigRef.current) {
      hasInitializedMaskTrackingRef.current = true;
      prevMaskDataRef.current = newMasks.reduce((acc, mask) => {
        acc[mask.id] = {
          points: JSON.stringify(mask.points ?? []),
          rotation: mask.rotation ?? 0,
          scaleX: mask.scaleX ?? 1,
          scaleY: mask.scaleY ?? 1,
          x: mask.x ?? 0,
          y: mask.y ?? 0,
        };
        return acc;
      }, {});
      return;
    }

    if ((maskChanged || maskAdded || maskDeleted) && !isUndoRedoRef.current) {
      setHasUnsavedChanges(true);
      saveHistory();
    }

    prevMaskDataRef.current = newMasks.reduce((acc, mask) => {
      acc[mask.id] = {
        points: JSON.stringify(mask.points ?? []),
        rotation: mask.rotation ?? 0,
        scaleX: mask.scaleX ?? 1,
        scaleY: mask.scaleY ?? 1,
        x: mask.x ?? 0,
        y: mask.y ?? 0,
      };
      return acc;
    }, {});
  }, [masks]);

  useEffect(() => {
    if (isUndoRedoRef.current) return;

    let newGrids = [...grids];

    const prevGridIds = new Set(Object.keys(prevGridDataRef.current));
    const currentGridIds = new Set(newGrids.map(grid => grid.id));

    const gridChanged = newGrids.some((grid) => {
      const prevGridData = prevGridDataRef.current[grid.id];
      return (
        !prevGridData ||
        prevGridData.origin.x.start !== grid.origin.x.start ||
        prevGridData.origin.y.start !== grid.origin.y.start ||
        prevGridData.origin.x.length !== grid.origin.x.length ||
        prevGridData.origin.y.length !== grid.origin.y.length ||
        prevGridData.origin.z.start !== (grid.origin.z?.start ?? 0) ||
        prevGridData.origin.z.length !== (grid.origin.z?.length ?? 0) ||
        prevGridData.angle !== grid.angle ||
        prevGridData.xSpacing !== grid.xSpacing ||
        prevGridData.ySpacing !== grid.ySpacing ||
        prevGridData.edgeStart !== grid.edgeStart ||
        prevGridData.maskAll !== grid.maskAll ||
        prevGridData.maxSpacing !== grid.maxSpacing ||
        prevGridData.name !== grid.name ||
        prevGridData.obsAngle !== grid.obsAngle ||
        prevGridData.obsHeight !== grid.obsHeight ||
        prevGridData.selected !== grid.selected ||
        prevGridData.showResults !== grid.showResults ||
        prevGridData.type !== grid.type
      );
    });

    const gridAdded = newGrids.length > prevGridIds.size;
    const gridDeleted = [...prevGridIds].some(prevId => !currentGridIds.has(prevId));

    if (!hasInitializedGridTrackingRef.current || loadingConfigRef.current) {
      hasInitializedGridTrackingRef.current = true;
      prevGridDataRef.current = newGrids.reduce((acc, grid) => {
        acc[grid.id] = {
          origin: {
            x: { start: grid.origin.x.start, length: grid.origin.x.length },
            y: { start: grid.origin.y.start, length: grid.origin.y.length },
            z: {
              start: grid.origin.z?.start ?? 0,
              length: grid.origin.z?.length ?? 0
            },
          },
          angle: grid.angle ?? 0,
          xSpacing: grid.xSpacing ?? 1,
          ySpacing: grid.ySpacing ?? 1,
          gridStandard: grid.gridStandard ?? '',
        };
        return acc;
      }, {});
      return;
    }

    if ((gridChanged || gridAdded || gridDeleted) && !isUndoRedoRef.current) {
      setHasUnsavedChanges(true);
      saveHistory();
    }

    prevGridDataRef.current = newGrids.reduce((acc, grid) => {
      acc[grid.id] = {
        origin: {
          x: { start: grid.origin.x.start, length: grid.origin.x.length },
          y: { start: grid.origin.y.start, length: grid.origin.y.length },
          z: {
            start: grid.origin.z?.start ?? 0,
            length: grid.origin.z?.length ?? 0
          },
        },
        angle: grid.angle ?? 0,
        xSpacing: grid.xSpacing ?? 1,
        ySpacing: grid.ySpacing ?? 1,
        gridStandard: grid.gridStandard ?? '',
      };
      return acc;
    }, {});
  }, [grids]);

  useEffect(() => {
    const { normalized, changed } = normalizeGridIds(grids);
    if (changed) {
      setGrids(normalized);
    }
  }, [grids]);

  const configTrackingSnapshot = JSON.stringify({
    autoContourValues,
    color,
    colors,
    columnGroups,
    contourColors,
    contourValues,
    currentDrawingId,
    defaultColumnSettings,
    dxfScale,
    gridScaleX,
    gridScaleY,
    imagePixelHeight,
    imagePixelWidth,
    luminName,
    luminNameList,
    maskMode,
    numberOfLuminaires,
    realWorldHeight,
    realWorldWidth,
    reportCaptureAreas,
    selectedLuminaireColors: state.Plan?.selectedLuminaireColors ?? [],
    selectedLuminaireFolders: state.Plan?.selectedLuminaireFolders ?? [],
    selectedLuminaireNames: state.Plan?.selectedLuminaireNames ?? [],
    selectedLuminaires: state.Plan?.selectedLuminaires ?? [],
    settingGridHeight,
    settingGridWidth,
    settingGridXStart,
    settingGridYStart,
    settingId,
    showContours,
    visualGrid,
  });

  useEffect(() => {
    if (!hasInitializedConfigTrackingRef.current || loadingConfigRef.current) {
      hasInitializedConfigTrackingRef.current = true;
      prevConfigTrackingSnapshotRef.current = configTrackingSnapshot;
      return;
    }

    if (prevConfigTrackingSnapshotRef.current !== configTrackingSnapshot) {
      setHasUnsavedChanges(true);
    }

    prevConfigTrackingSnapshotRef.current = configTrackingSnapshot;
  }, [configTrackingSnapshot]);

  useEffect(() => {
    if (isUndoRedoRef.current) return;

    let newColumns = [...columns];

    const prevColumnIds = new Set(Object.keys(prevColumnDataRef.current));
    const currentColumnIds = new Set(newColumns.map(column => column.id));

    const columnChanged = newColumns.some((column) => {
      const prevColumnData = prevColumnDataRef.current[column.id];
      return (
        !prevColumnData ||
        prevColumnData.values.point.x !== column.values.point.x ||
        prevColumnData.values.point.y !== column.values.point.y ||
        prevColumnData.values.positionAngle !== column.values.positionAngle ||
        prevColumnData.values.cant !== column.values.cant ||
        prevColumnData.values.columnGrid !== column.values.columnGrid ||
        prevColumnData.values.dimFactor !== column.values.dimFactor ||
        prevColumnData.values.height !== column.values.height ||
        prevColumnData.values.outreach !== column.values.outreach ||
        prevColumnData.values.tilt !== column.values.tilt ||
        prevColumnData.values.maintenanceFactor !== column.values.maintenanceFactor ||
        prevColumnData.values.lanterns !== column.values.lanterns ||
        prevColumnData.isMast !== column.isMast ||
        prevColumnData.color !== column.color ||
        prevColumnData.name !== column.name ||
        prevColumnData.selected !== column.selected ||
        prevColumnData.id !== column.id
      );
    });

    const columnAdded = newColumns.length > prevColumnIds.size;
    const columnDeleted = [...prevColumnIds].some(prevId => !currentColumnIds.has(prevId));

    if (!hasInitializedColumnTrackingRef.current || loadingConfigRef.current) {
      hasInitializedColumnTrackingRef.current = true;
      prevColumnDataRef.current = newColumns.reduce((acc, column) => {
        acc[column.id] = {
          color: column.color ?? '#000000',
          name: column.name ?? '',
          selected: column.selected ?? false,
          id: column.id ?? null,
          isMast: column.isMast ?? false,
          values: {
            point: {
              x: column.values.point.x ?? 0,
              y: column.values.point.y ?? 0,
            },
            positionAngle: column.values.positionAngle ?? 0,
            cant: column.values.cant ?? 0,
            columnGrid: column.values.columnGrid ?? 0,
            dimFactor: column.values.dimFactor ?? 1,
            height: column.values.height ?? 0,
            outreach: column.values.outreach ?? 0,
            tilt: column.values.tilt ?? 0,
            maintenanceFactor: column.values.maintenanceFactor ?? 1,
            lanterns: column.values.lanterns ?? [],
          },
        };
        return acc;
      }, {});
      return;
    }

    if ((columnChanged || columnAdded || columnDeleted) && !isUndoRedoRef.current) {
      setHasUnsavedChanges(true);
      saveHistory();
    }

    prevColumnDataRef.current = newColumns.reduce((acc, column) => {
      acc[column.id] = {
        color: column.color ?? '#000000',
        name: column.name ?? '',
        selected: column.selected ?? false,
        id: column.id ?? null,
        isMast: column.isMast ?? false,
        values: {
          point: {
            x: column.values.point.x ?? 0,
            y: column.values.point.y ?? 0,
          },
          positionAngle: column.values.positionAngle ?? 0,
          cant: column.values.cant ?? 0,
          columnGrid: column.values.columnGrid ?? 0,
          dimFactor: column.values.dimFactor ?? 1,
          height: column.values.height ?? 0,
          outreach: column.values.outreach ?? 0,
          tilt: column.values.tilt ?? 0,
          maintenanceFactor: column.values.maintenanceFactor ?? 1,
          lanterns: column.values.lanterns ?? [],
        },
      };
      return acc;
    }, {});
  }, [columns]);

  const saveHistory = () => {

    const state = {
      grids: JSON.parse(JSON.stringify(grids)),
      columns: JSON.parse(JSON.stringify(columns)),
      masks: JSON.parse(JSON.stringify(masks)),
    };

    setHistory((prevHistory) => {
      const newHistory = isUndoRedoRef.current
        ? [...prevHistory]
        : prevHistory.slice(0, currentStep + 1);

      newHistory.push(state);

      const maxHistory = 15;
      if (newHistory.length > maxHistory) newHistory.shift();

      setCurrentStep(newHistory.length - 1);

      return newHistory;
    });
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey || event.metaKey) {
        if (event.key === 'z') {
          undoAction();
        } else if (event.key === 'y') {
          redoAction();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [history, currentStep]);


  const undoAction = () => {
    console.log("Undoing action...", currentStep);

    if (currentStep > 0) {
      isUndoRedoRef.current = true;

      const prevState = history[currentStep - 1];

      const deselectAll = (items) =>
        items.map((item) => ({ ...item, selected: false }));

      setMasks(deselectAll(prevState.masks));
      setGrids(deselectAll(prevState.grids));
      setColumns(deselectAll(prevState.columns));

      setCurrentStep((prevStep) => prevStep - 1);

      requestAnimationFrame(() => {
        isUndoRedoRef.current = false;
      });

      triggerAreaCalc("undo");
    }
  };

  const redoAction = () => {
    console.log("Redoing action...", currentStep);
    if (currentStep < history.length - 1) {
      isUndoRedoRef.current = true;

      const nextState = history[currentStep + 1];
      setMasks(nextState.masks);
      setGrids(nextState.grids);
      setColumns(nextState.columns);

      setCurrentStep((prevStep) => {
        const newStep = prevStep + 1;
        return newStep;
      });

      requestAnimationFrame(() => {
        isUndoRedoRef.current = false;
      });

      triggerAreaCalc("redo");
    }
  };

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // End of undo redo
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  const selectMask = (id) => {
    if (isCanvasSelectionBlocked()) {
      return;
    }
    let tempMasks = [...masks];
    if (!multipleSelect) {
      unselectOther('mask');
      const maskIndex = tempMasks.findIndex(mask => mask.id === id);
      if (maskIndex !== -1) {
        if (tempMasks[maskIndex].selected === false) {
          tempMasks = tempMasks.map((mask) => ({
            ...mask,
            selected: mask.id === id ? !mask.selected : false,
          }));
        } else {
          const selectedCount = tempMasks.filter(mask => mask.selected).length;
          if (selectedCount > 1) {
            tempMasks[maskIndex].selected = true;
            tempMasks = tempMasks.map((mask) => ({
              ...mask,
              selected: mask.id === id ? true : false,
            }));
          } else {
            tempMasks[maskIndex].selected = !tempMasks[maskIndex].selected;
          }
        }
      }
    } else {
      const maskIndex = tempMasks.findIndex(mask => mask.id === id);
      if (maskIndex !== -1) {
        tempMasks[maskIndex].selected = !tempMasks[maskIndex].selected;
      }
    }

    const updatedMask = tempMasks.find(mask => mask.id === id);
    if (updatedMask) updatedMask.locked = false;

    setMasks(tempMasks);
  };


  const deleteMask = (id) => {
    const updatedMasks = masks.filter(mask => mask.id !== id);
    setMasks(updatedMasks);
    triggerAreaCalc("deleted mask");
  };



  const lockMask = (id) => {
    const tempMasks = [...masks];
    const maskIndex = tempMasks.findIndex(mask => mask.id === id);
    if (maskIndex !== -1) {
      if (!tempMasks[maskIndex].locked) {
        tempMasks[maskIndex].selected = false;
      }
      tempMasks[maskIndex].locked = !tempMasks[maskIndex].locked;
    }
    setMasks(tempMasks);
  };


  const lockGrid = (id) => {
    const tempGrids = [...grids];
    const gridIndex = tempGrids.findIndex(grid => grid.id === id);
    if (gridIndex !== -1) {
      if (!tempGrids[gridIndex].locked) {
        tempGrids[gridIndex].selected = false;
      }
      tempGrids[gridIndex].locked = !tempGrids[gridIndex].locked;
    }
    setGrids(tempGrids);
  };

  const updateMaskFields = (updatedMask) => {
    let shouldTriggerCalc = false;
    const geometryKeys = new Set([
      "maskIn",
      "x",
      "y",
      "width",
      "height",
      "scaleX",
      "scaleY",
      "rotation",
      "radius",
      "points",
    ]);

    const toFinite = (value, fallback = 0) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    setMasks((prevMasks) =>
      prevMasks.map((mask) => {
        if (mask.id !== updatedMask.id) return mask;

        const hasGeometryUpdate = Object.keys(updatedMask || {}).some((key) => geometryKeys.has(key));
        if (hasGeometryUpdate) {
          shouldTriggerCalc = true;
        }

        const mergedMask = {
          ...mask,
          ...updatedMask,
        };

        if (mergedMask.type === "rectangle") {
          const x = toFinite(mergedMask.x, toFinite(mask.x, 0));
          const y = toFinite(mergedMask.y, toFinite(mask.y, 0));
          const width = toFinite(mergedMask.width, toFinite(mask.width, 0));
          const height = toFinite(mergedMask.height, toFinite(mask.height, 0));
          const scaleX = toFinite(mergedMask.scaleX, toFinite(mask.scaleX, 1));
          const scaleY = toFinite(mergedMask.scaleY, toFinite(mask.scaleY, 1));
          const rotation = toFinite(mergedMask.rotation, toFinite(mask.rotation, 0));
          const rotationRadians = rotation * (Math.PI / 180);

          const originalPoints = [
            { x, y },
            { x: x + width * scaleX, y },
            { x: x + width * scaleX, y: y + height * scaleY },
            { x, y: y + height * scaleY }
          ];

          const rotatedPoints = originalPoints.map(point => {
            const translatedX = point.x - x;
            const translatedY = point.y - y;

            const rotatedX = translatedX * Math.cos(rotationRadians) - translatedY * Math.sin(rotationRadians);
            const rotatedY = translatedX * Math.sin(rotationRadians) + translatedY * Math.cos(rotationRadians);

            return { x: rotatedX + x, y: rotatedY + y };
          });

          return {
            ...mergedMask,
            x,
            y,
            width,
            height,
            scaleX,
            scaleY,
            rotation,
            points: rotatedPoints,
          };
        }

        if (mergedMask.type === "circle") {
          const x = toFinite(mergedMask.x, toFinite(mask.x, 0));
          const y = toFinite(mergedMask.y, toFinite(mask.y, 0));
          return {
            ...mergedMask,
            x,
            y,
            points: [{ x, y }],
          };
        }

        return mergedMask;
      })
    );

    if (shouldTriggerCalc) {
      triggerAreaCalc("updated mask selection");
    }
  };


  const updateMaskOrder = (newOrder) => {
    console.log("Mask old order", masks);
    console.log("Mask new order", newOrder);
    setMasks(newOrder);
    triggerAreaCalc("reordered masks");
  };


  const updateMask = (e, i, type, customPoints) => {
    var tempMasks = [...masks];
    var points = [];

    if (type !== "polygon") {
      var x = e.target.attrs.x / overlayScale;
      var y = e.target.attrs.y / overlayScale;
    }

    if (type === "rectangle") {
      const width = e.target.attrs.width / overlayScale;
      const height = e.target.attrs.height / overlayScale;
      const scaleX = e.target.attrs.scaleX;
      const scaleY = e.target.attrs.scaleY;
      const rotation = e.target.attrs.rotation;
      const opacity = e.target.attrs.opacity || 0.5;
      const x = e.target.attrs.x / overlayScale;
      const y = toWorldY(e.target.attrs.y / overlayScale);

      const rotationRadians = rotation * (Math.PI / 180);

      const originalPoints = [
        { x: x, y: y },
        { x: x + width * scaleX, y: y },
        { x: x + width * scaleX, y: y + height * scaleY },
        { x: x, y: y + height * scaleY }
      ];

      const rotatedPoints = originalPoints.map(point => {
        const translatedX = point.x - x;
        const translatedY = point.y - y;

        const rotatedX = translatedX * Math.cos(rotationRadians) - translatedY * Math.sin(rotationRadians);
        const rotatedY = translatedX * Math.sin(rotationRadians) + translatedY * Math.cos(rotationRadians);

        return { x: rotatedX + x, y: rotatedY + y };
      });

      tempMasks[i] = {
        ...tempMasks[i],
        points: rotatedPoints,
        x,
        y,
        width,
        height,
        scaleX,
        scaleY,
        rotation,
        opacity
      };
    } else if (type === "circle") {
      const radius = e.target.attrs.radius / overlayScale;
      const scaleX = e.target.attrs.scaleX;
      const scaleY = e.target.attrs.scaleY;
      const opacity = e.target.attrs.opacity;
      const rotation = e.target.attrs.rotation || 0;
      const yWorld = toWorldY(y);

      console.log("circle", e.target.attrs);
      points.push({ x: x, y: yWorld });

      tempMasks[i] = {
        ...tempMasks[i],
        x,
        y: yWorld,
        radius,
        scaleX,
        scaleY,
        points,
        opacity,
        rotation,
      };
    } else {
      tempMasks[i] = {
        ...tempMasks[i],
        points: customPoints,
      };
    }

    setMasks(tempMasks);
    triggerAreaCalc("updated mask");
  };


  const addCustomMask = (customPoints, poly) => {
    var tempMasks = [...masks];
    var points = [];
    for (let k = 0; k < customPoints.length; k += 2) {
      points.push({ x: customPoints[k], y: toWorldY(customPoints[k + 1]) });
    }
    points.push({ x: points[0].x, y: points[0].y });
    tempMasks.push({
      id: poly.id,
      type: "polygon",
      points,
      layer: tempMasks.length,
      name: "Mask #" + maskName,
      visible: true,
      color: null,
      selected: false,
      opacity: polyMaskIn ? 0.5 : 1,
      maskIn: polyMaskIn ? true : false,
      locked: false,
      polyClosed: poly.closed,
      polyFill: poly.fill,
      polyStroke: poly.stroke,
    });
    setMaskName(maskName + 1);
    setMasks(tempMasks);
    setPolyMaskIn(false)
    triggerAreaCalc("added polygon mask");
  }


  const handleAddGrid = (e) => {
    e.preventDefault();
    if (viewer) {
      syncStageFromViewer();
    }
    var gridWidth = newGridWidth ?? 50;
    var gridHeight = newGridHeight ?? 50;
    var gridXStart = newGridXStart ?? 0;
    var gridYStart = newGridYStart ?? 0;

    const stage = stageRef.current;
    const scaleX = stage.scaleX();
    const scaleY = stage.scaleY();
    const stageX = stage.x();
    const stageY = stage.y();

    const canvasWidth = stage.width();
    const canvasHeight = stage.height();

    const centerX = canvasWidth / 2;
    const centerY = canvasHeight / 2;

    const adjustedCenterX = (((centerX - stageX) / scaleX) / gridScaleX) / overlayScale;
    const adjustedCenterY = (((centerY - stageY) / scaleY) / gridScaleY) / overlayScale;

    gridXStart = (adjustedCenterX - gridWidth / 2) / overlayScale;
    gridYStart = (adjustedCenterY - gridHeight / 2) / overlayScale;


    console.log("Grid values:", gridWidth, gridHeight, gridXStart, gridYStart);


    console.log("called handleAddGrid", newGridWidth, newGridHeight, newGridXStart, newGridYStart);
    if (gridWidth > 0 && gridHeight > 0) {
      var newGrid = {
        selected: false,
        angle: 0,
        showResults: newGridShowResults,
        id: getNextGridId(grids),
        locked: false,
        maskAll: "False",
        maskingLayer: "0",
        obsAngle: 0,
        obsHeight: 1.5,
        xSpacing: 1.5,
        ySpacing: 1.5,
        name: "Grid #" + (grids.length),
        color: "#00008B",
        gridStandard: selectedStandard,
        gridClass: selectedClass,
        visible: false,
        edgeStart: false,
        origin:
        {
          x: {
            start: gridXStart,
            length: gridWidth
          },
          y: {
            start: gridYStart,
            length: gridHeight
          },
          z: {
            start: 0,
            length: 0
          }
        },
        maxSpacing: 1.5,
        type: "Horizontal",
        verticalGridSide: "False"
      };
      var tempGrids = JSON.parse(JSON.stringify(grids));
      tempGrids.push(newGrid);
      setNewGridXStart(0);
      setNewGridYStart(0);
      setNewGridShowResults(false);
      setGrids(tempGrids);
      triggerAreaCalc("added grid");
    }
  }

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Grid Standard

  const dropbox = [
    'EN13201:2015 Illuminance',
    // 'EN13201:2015 Luminance',
    'BS5489:2020 Illuminance',
    // 'IES RP-8-18',
    'CIE140 Illuminance',
    // 'CIE140 Luminance',
    // 'NZS1158:2005 Cat P Illuminance',
    //'NZS1158:2005 Cat V Luminance',
    // 'AUS Illuminance',
    // 'AUS Luminance',
  ]

  const [selectedStandard, setSelectedStandard] = useState(dropbox[0]);
  const [selectedClass, setSelectedClass] = useState("P1");

  const onStandardChange = (event) => {
    const standardId = event.target.value;
    setSelectedStandard(standardId);

    let illumTypeId = "Luminance";
    if (standardId.includes("Illuminance")) {
      illumTypeId = "Horizontal";
    }

    EdgeOrREST(null, 'SET_ROAD_CONFIG', (response) => onGetStandard(response, standardId), {
      postObject: { standardId, illumTypeId },
    });
  };

  const onGetStandard = (response, standardId) => {
    setSelectedClass(response.data.standard.CalcGridClass[0]);

    const updatedGrids = grids.map((grid) => ({
      ...grid,
      gridStandard: standardId,
      gridClass: response.data.standard.CalcGridClass[0],
    }));

    setGrids(updatedGrids);
  };

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


  const handleAddColumnWithXY = (event, x, y, currColor) => {
    event.preventDefault();
    if (viewer) {
      syncStageFromViewer();
    }
    const columnSetting = normalizeColumnSettings(defaultColumnSettings, currValueId + 1)[currValueId];
    var newColumn = {};
    // const stageWidth = stageRef.current?.attrs.width || 0;
    // const stageHeight = stageRef.current?.attrs.height || 0;

    // const stageScaleX = stageRef.current?.attrs.scaleX || 1;
    // const stageScaleY = stageRef.current?.attrs.scaleY || 1;
    // const stageX = stageRef.current?.attrs.x || 0;
    // const stageY = stageRef.current?.attrs.y || 0;

    var values = {
      point: {
        // x : Math.round((stageWidth / 2 - stageX) / stageScaleX * 100) / 100,  Add column to centre stage - uncomment code
        // y : Math.round((stageHeight / 2 - stageY) / stageScaleY * 100) / 100
        x: x / overlayScale,
        y: toWorldY(y / overlayScale)
      },
      positionAngle: 0,
      columnConfiguration: "Single Sided Left",
      configuration: "None", // this is for the mast settings
      dimFactor: columnSetting.dimFactor,
      columnGrid: columnSetting.columnGrid,
      height: columnSetting.height,
      maintenanceFactor: columnSetting.maintenanceFactor,
      outreach: columnSetting.outreach,
      cant: columnSetting.cant,
      tilt: columnSetting.tilt,
      luminaireId: currentLuminId != null
        ? currentLuminId
        : state.Plan?.selectedLuminaires?.[currValueId] ?? state.Plan?.selectedLuminaires?.[0],
    }

    newColumn.selected = false;
    newColumn.locked = false;
    newColumn.values = values;
    newColumn.name = "Column #" + (columns.length + 1);
    newColumn.color = currColor;
    newColumn.id = uuidv4();
    // newColumn.group = "";
    if (columns.length > 0) {
      let arr = [...columns];
      arr.push(newColumn);
      setColumns(arr);
    } else {
      var arr = [];
      arr.push(newColumn);
      setColumns(arr);
    }
    let tempColumnGroups = [...columnGroups];
    tempColumnGroups[0].columnIds.push(newColumn.id);
    setColumnGroups(tempColumnGroups);
    console.log("tempColumnGroups", tempColumnGroups);
    triggerAreaCalc("added column");
  }


  const handleAddMask = (event, maskType, maskIn) => {
    event.preventDefault();
    var newMask = {};
    newMask.id = uuidv4();
    newMask.type = maskType;
    newMask.points = [];
    newMask.layer = masks.length;
    newMask.name = "Mask #" + maskName;
    setMaskName(maskName + 1);
    newMask.visible = true; // For the name to be visible
    newMask.color = null;
    newMask.selected = false;
    newMask.opacity = maskIn ? 0.5 : 0.9;
    newMask.maskIn = maskIn;
    newMask.locked = false;
    newMask.scaleX = 1;
    newMask.scaleY = 1;
    newMask.rotation = 0;

    const stageWidth = stageRef.current?.attrs.width || 0;
    const stageHeight = stageRef.current?.attrs.height || 0;

    const stageScaleX = stageRef.current?.attrs.scaleX || 1;
    const stageScaleY = stageRef.current?.attrs.scaleY || 1;
    const stageX = stageRef.current?.attrs.x || 0;
    const stageY = stageRef.current?.attrs.y || 0;

    newMask.width = 50;
    newMask.height = 50;

    const centerCanvasX = ((Math.round((stageWidth / 2 - stageX) / stageScaleX * 100) / 100)) / overlayScale;
    const centerCanvasY = ((Math.round((stageHeight / 2 - stageY) / stageScaleY * 100) / 100)) / overlayScale;

    newMask.x = centerCanvasX;
    newMask.y = centerCanvasY;

    newMask.x -= newMask.width / 2;
    newMask.y -= newMask.height / 2;
    newMask.y = toWorldY(newMask.y);

    if (maskType === "circle") {
      newMask.radius = 25;
      newMask.x += newMask.radius;
      newMask.y = toWorldY(centerCanvasY);
      newMask.points = [
        { x: newMask.x, y: newMask.y }
      ];
    }
    else {
      newMask.points = [
        { x: newMask.x, y: newMask.y },
        { x: newMask.x + newMask.width, y: newMask.y },
        { x: newMask.x + newMask.width, y: newMask.y + newMask.height },
        { x: newMask.x, y: newMask.y + newMask.height },
      ];
    }

    let arr = [...masks];
    arr.push(newMask);
    setMasks(arr);
    triggerAreaCalc("added mask");
  };

  const getPolygonCloseThreshold = React.useCallback(() => {
    const currentScale = Math.max(0.1, Number(stageRef.current?.attrs?.scaleX) || Number(stage.scale) || 1);
    return Math.max(0.35, 2.5 / currentScale);
  }, [stage.scale]);


  const handleDrawLineMouseDown = (e) => {
    if (maskMode) {
      if (e.evt.button !== 0) return;
      const pointX = (stageRef.current._changedPointerPositions[0].x - stageRef.current.attrs.x) / stageRef.current.attrs.scaleX;
      const pointY = (stageRef.current._changedPointerPositions[0].y - stageRef.current.attrs.y) / stageRef.current.attrs.scaleY;
      if (isDrawing && lines.length > 0) {
        console.log("lines", lines);
        let lastLine = lines[lines.length - 1];
        // Check if current mouse position is close to starting point
        const [startX, startY] = lastLine.points;
        const closeThreshold = getPolygonCloseThreshold();
        if (Math.hypot(pointX - startX, pointY - startY) <= closeThreshold) {
          // Close shape by adding starting point to end of points array
          // lastLine.points = lastLine.points.concat([startX, startY]);
          // lines.splice(lines.length - 1, 1, lastLine);
          setIsDrawing(false);
          setMaskMode(false);
          setCursorType('default');
          var poly = {
            id: uuidv4(),
            points: lines.concat()[0].points,
            fill: 'rgba(0, 210, 255, 0.5)',
            stroke: 'black',
            closed: true,
          };
          setLines([]);
          addCustomMask(lines.concat()[0].points, poly);
        } else {
          lastLine.points = lastLine.points.concat([pointX, pointY]);
          lines.splice(lines.length - 1, 1, lastLine);
          setLines(lines.concat());
        }
      } else {
        setLines([...lines, { points: [pointX, pointY] }]);
        setIsDrawing(true);
      }
    }
  };

  const handleMeasureMouseDown = (e) => {
    if (measureMode) {
      if (e.evt.button !== 0) return;
      const pointX = (stageRef.current._changedPointerPositions[0].x - stageRef.current.attrs.x) / stageRef.current.attrs.scaleX;
      const pointY = (stageRef.current._changedPointerPositions[0].y - stageRef.current.attrs.y) / stageRef.current.attrs.scaleY;
      setMeasureStartPoint({ x: pointX, y: pointY });
    }
  };

  const handleMeasureMouseMove = (e) => {
    if (measureMode && measureStartPoint) {
      const stage = e.target.getStage();
      const pointerPosition = stage.getPointerPosition();
      if (pointerPosition) {
        const pointX = (pointerPosition.x - stage.attrs.x) / stage.attrs.scaleX;
        const pointY = (pointerPosition.y - stage.attrs.y) / stage.attrs.scaleY;
        // Measure in real-world units; overlayScale is visual-only and should not affect distance.
        const startX = measureStartPoint.x / gridScaleX;
        const startY = toWorldY(measureStartPoint.y / gridScaleY);
        const currX = pointX / gridScaleX;
        const currY = toWorldY(pointY / gridScaleY);
        const distance = Math.sqrt(Math.pow(currX - startX, 2) + Math.pow(currY - startY, 2));
        setMeasureDistance(distance);
        setMeasureLine([measureStartPoint.x, measureStartPoint.y, pointX, pointY]);
      }
    }
  };

  const [snack, setSnack] = React.useState({
    open: false
  });

  // Warn about hardware acceleration if not enabled
  const [hardwareAccelWarned, setHardwareAccelWarned] = React.useState(false);
  useEffect(() => {
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (!gl && !hardwareAccelWarned) {
        setSnack({
          open: true,
          severity: 'warning',
          message: 'Warning: Browser hardware acceleration is disabled. Please enable it for best performance.'
        });
        setHardwareAccelWarned(true);
      } else if (gl && !hardwareAccelWarned) {
        // Try to get the renderer string
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        let renderer = '';
        if (debugInfo) {
          renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
        }
        if (renderer && (renderer.toLowerCase().includes('swiftshader') || renderer.toLowerCase().includes('software'))) {
          setSnack({
            open: true,
            severity: 'warning',
            message: 'Warning: WebGL is running in software mode. Please enable hardware acceleration in your browser for best performance.'
          });
          setHardwareAccelWarned(true);
        }
      }
    } catch (e) {
      if (!hardwareAccelWarned) {
        setSnack({
          open: true,
          severity: 'warning',
          message: 'Warning: Unable to detect hardware acceleration. Please ensure it is enabled in your browser.'
        });
        setHardwareAccelWarned(true);
      }
    }
  }, []);

  const handleSnackClose = () => {
    setSnack({
      ...snack,
      open: false
    });
  };

  const toggleLeftDrawer = () => {
    setLeftDrawerOpen(!leftDrawerOpen);
  };

  const toggleRightDrawer = () => {
    setRightDrawerOpen(!rightDrawerOpen);
  };

  const toggleLuminOpen = () => {
    setAddLuminOpen(!addLuminOpen);
    setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50);
  };

  const toggleLuminInfoOpen = () => {
    setLuminInfoOpen(!luminInfoOpen)
  }

  const toggleLuminSettingOpen = () => {
    setLuminSettingOpen(!luminSettingOpen)
  }

  const handleGetInfo = (event, id) => {
    setInfoLumin(state.Plan.selectedLuminaires[id]);
    dispatch(luminaireActions.UpdateLuminaireList({
      ...state.LuminaireCfg,
      selectedLuminaireIds: state?.Plan?.selectedLuminaires,
      selectedResultName: state?.Plan?.selectedLuminaireNames,
      selectedResultLuminId: state?.Plan?.selectedLuminaires[id],
    }));

    toggleLuminInfoOpen();
  }

  const handleAddLumin = (event) => {
    if (state?.Plan?.selectedLuminaires[numberOfLuminaires]) {
      setNumberOfLuminaires(numberOfLuminaires + 1);
      var tempName = luminName == "" ? state?.Plan?.selectedLuminaireNames ? state.Plan.selectedLuminaireNames[state.Plan.selectedLuminaireNames.length - 1] : "#" + numberOfLuminaires : luminName;
      setLuminNameList([...luminNameList, tempName]);
      setColors([...colors, DEFAULT_COLUMN_COLOR]);
      var temp = normalizeColumnSettings(defaultColumnSettings);
      temp.push(createDefaultColumnSetting());
      setDefaultColumnSettings(temp);
      toggleLuminOpen();
      setLuminName("");
    } else {
      setSnack({
        open: true,
        message: "Please select a luminaire first",
        severity: 'warning'
      });
    }
  }

  const handleAddLuminClose = (event) => {
    setLuminName("");
    toggleLuminOpen();
  }

  const handleDeleteLumin = (event, id) => {
    if (!luminNameList || !colors || id < 0 || id >= luminNameList.length) {
      console.error("Invalid delete operation: List is empty or index is out of bounds.");
      return;
    }

    var temp = numberOfLuminaires - 1;

    // Remove item from luminNameList and colors
    var tempLuminNameList = [...luminNameList];
    var tempColors = [...colors];

    tempLuminNameList.splice(id, 1);
    tempColors.splice(id, 1);

    setLuminNameList(tempLuminNameList);
    setColors(tempColors);
    setNumberOfLuminaires(temp);

    // Ensure Redux state updates correctly
    var tempLumin = [...(state.Plan.selectedLuminaires || [])];
    var tempLuminColors = [...(state.Plan.selectedLuminaireColors || [])];
    var tempLuminNames = [...(state.Plan.selectedLuminaireNames || [])]; // ✅ Include names
    var tempLuminFolders = [...(state.Plan.selectedLuminaireFolders || [])]; // ✅ Include folders

    if (id < tempLumin.length) tempLumin.splice(id, 1);
    if (id < tempLuminColors.length) tempLuminColors.splice(id, 1);
    if (id < tempLuminNames.length) tempLuminNames.splice(id, 1); // ✅ Remove name
    if (id < tempLuminFolders.length) tempLuminFolders.splice(id, 1); // ✅ Remove folder

    dispatch(planActions.UpdatePlanLuminaires({
      selectedLuminaires: [...tempLumin],
      selectedLuminaireColors: [...tempLuminColors],
      selectedLuminaireNames: [...tempLuminNames],  // ✅ Include in update
      selectedLuminaireFolders: [...tempLuminFolders]  // ✅ Include in update
    }));

    console.log("Updated Redux State:", {
      selectedLuminaires: tempLumin,
      selectedLuminaireColors: tempLuminColors,
      selectedLuminaireNames: tempLuminNames,  // ✅ Corrected log output
      selectedLuminaireFolders: tempLuminFolders  // ✅ Corrected log output
    });
  };





  const toggleAddMode = (event) => {
    if (cursorType !== 'crosshair') {
      setCursorType('crosshair');
    } else {
      setCursorType('default');
    }
  }

  const handleAddColumnModeClick = (event) => {
    if (cursorType === 'crosshair' && event.button === 0 && !isDrawing) {
      const pointX = (stageRef.current._changedPointerPositions[0].x - stageRef.current.attrs.x) / stageRef.current.attrs.scaleX;
      const pointY = (stageRef.current._changedPointerPositions[0].y - stageRef.current.attrs.y) / stageRef.current.attrs.scaleY;

      if (showMark && markDetails.show && markDetails.snap && Array.isArray(markDetails.points) && isInSnapRange) {
        const closest = findClosestMarkPoint(markDetails.points, pointX / (gridScaleX * overlayScale), pointY / (gridScaleY * overlayScale));
        console.log("closestPointPlacement", closest, pointX / gridScaleX, pointY / gridScaleY);
        handleAddColumnWithXY(event, closest.x * gridScaleX * overlayScale, closest.y * gridScaleY * overlayScale, color);
      } else {
        handleAddColumnWithXY(event, pointX, pointY, color);
      }
    }
  }

  const findClosestMarkPoint = (points, targetX, targetY) => {
    if (!Array.isArray(points) || points.length === 0) return null;

    let closestPoint = points[0];

    let minDistance = Math.hypot(points[0].x - targetX, points[0].y - targetY);

    for (let i = 1; i < points.length; i++) {
      const point = points[i];
      const dist = Math.hypot(point.x - targetX, point.y - targetY);

      if (dist < minDistance) {
        minDistance = dist;
        closestPoint = { x: point.x, y: point.y };
      }
    }

    return closestPoint;
  };


  const handleAddColumnClick = (event, id) => {
    if (cursorType === 'default') {
      setCursorType('crosshair');
    }
    setCurrentLuminId(state?.Plan?.selectedLuminaires[id]);
    setColor(colors[id]);
    setCurrValueId(id);
  }

  const handleLuminSettingOpen = (event, id) => {
    const columnSetting = normalizeColumnSettings(defaultColumnSettings, id + 1)[id];
    setSettingId(id);
    setLuminName(luminNameList[id]);
    setColor(colors[id]);
    setDefaultColumnSettingValues({
      ...createDefaultColumnSetting(),
      ...columnSetting,
    });
    toggleLuminSettingOpen();
  }

  const handleAddSettingClose = (event) => {
    setLuminName("");
    toggleLuminSettingOpen();
    setDefaultColumnSettingValues(createDefaultColumnSetting());
  }

  const handleSaveLuminSetting = (event) => {
    var temp = normalizeColumnSettings(defaultColumnSettings, settingId + 1);
    temp[settingId] = {
      ...createDefaultColumnSetting(),
      ...defaultColumnSettingValues,
    };
    setDefaultColumnSettings(temp);

    var newColors = [...colors];
    newColors[settingId] = color;
    setColors(newColors);

    columns.filter((item, index) => {
      if (item.values.luminaireId == state.Plan.selectedLuminaires[settingId]) {
        item.color = color;
      }
    });

    const newLuminNameList = [...luminNameList];
    newLuminNameList[settingId] = luminName;
    setLuminNameList(newLuminNameList);
    console.log(newLuminNameList, newColors, settingId);

    dispatch(planActions.UpdatePlanLuminaires({ selectedLuminaireColors: newColors }));

    setLuminName("");
    setDefaultColumnSettingValues(createDefaultColumnSetting());
    toggleLuminSettingOpen();
  }

  // Distance from point (px,py) to line segment ((x1,y1) → (x2,y2))
  // Distance from point (px,py) to line segment ((x1,y1) → (x2,y2))
  function distancePointToSegment(px, py, x1, y1, x2, y2) {
    const vx = x2 - x1;
    const vy = y2 - y1;
    const wx = px - x1;
    const wy = py - y1;
    const len2 = vx * vx + vy * vy;
    if (len2 === 0) {
      return Math.hypot(px - x1, py - y1);
    }
    let t = (vx * wx + vy * wy) / len2;
    if (t < 0) t = 0;
    else if (t > 1) t = 1;
    const projX = x1 + t * vx;
    const projY = y1 + t * vy;
    return Math.hypot(px - projX, py - projY);
  }

  // Distance from point (px,py) to circle ((cx,cy), radius r)
  function distancePointToCircle(px, py, cx, cy, r) {
    const d = Math.hypot(px - cx, py - cy);
    return Math.abs(d - r);
  }

  // Distance from point (px,py) to a polyline defined by vertices[]
  function distancePointToPolyline(px, py, vertices) {
    let minD = Infinity;
    for (let i = 0; i < vertices.length - 1; i++) {
      const { x: x1, y: y1 } = vertices[i];
      const { x: x2, y: y2 } = vertices[i + 1];
      const d = distancePointToSegment(px, py, x1, y1, x2, y2);
      if (d < minD) minD = d;
    }
    return minD;
  }

  /**
   * Returns the layer name of the DXF entity closest to (px,py),
   * regardless of actual distance.
   */
  function findClosestLayer(px, py, entities) {
    let minDist = Infinity;
    let hitLayer = null;

    for (const ent of entities) {
      let d = Infinity;
      switch (ent.type) {
        case 'LINE':
          // LINE entities now come as ent.vertices = [{x,y,z}, {x,y,z}]
          if (Array.isArray(ent.vertices) && ent.vertices.length >= 2) {
            const v0 = ent.vertices[0];
            const v1 = ent.vertices[1];
            d = distancePointToSegment(
              px, py,
              v0.x, v0.y,
              v1.x, v1.y
            );
          }
          break;

        case 'LWPOLYLINE':
        case 'POLYLINE':
          if (Array.isArray(ent.vertices) && ent.vertices.length >= 2) {
            d = distancePointToPolyline(px, py, ent.vertices);
          }
          break;

        case 'CIRCLE':
          if (ent.center && typeof ent.radius === 'number') {
            d = distancePointToCircle(
              px, py,
              ent.center.x, ent.center.y,
              ent.radius
            );
          }
          break;

        case 'ARC':
          if (
            ent.center &&
            typeof ent.radius === 'number' &&
            typeof ent.startAngle === 'number' &&
            typeof ent.endAngle === 'number'
          ) {
            const dCircle = distancePointToCircle(
              px, py,
              ent.center.x, ent.center.y,
              ent.radius
            );

            // Check if point’s projection angle lies between start/end
            const angleToPoint = Math.atan2(py - ent.center.y, px - ent.center.x) * (180 / Math.PI);
            const normalize = a => ((a % 360) + 360) % 360;
            const aPt = normalize(angleToPoint);
            const aStart = normalize(ent.startAngle);
            const aEnd = normalize(ent.endAngle);

            let onArc = false;
            if (aStart < aEnd) {
              onArc = aPt >= aStart && aPt <= aEnd;
            } else {
              onArc = aPt >= aStart || aPt <= aEnd;
            }

            if (onArc) {
              d = dCircle;
            } else {
              const toRad = deg => (deg * Math.PI) / 180;
              const x1 = ent.center.x + ent.radius * Math.cos(toRad(ent.startAngle));
              const y1 = ent.center.y + ent.radius * Math.sin(toRad(ent.startAngle));
              const x2 = ent.center.x + ent.radius * Math.cos(toRad(ent.endAngle));
              const y2 = ent.center.y + ent.radius * Math.sin(toRad(ent.endAngle));
              const d1 = Math.hypot(px - x1, py - y1);
              const d2 = Math.hypot(px - x2, py - y2);
              d = Math.min(d1, d2);
            }
          }
          break;

        // Add other entity types as needed...

        default:
          continue;
      }

      if (d < minDist) {
        minDist = d;
        hitLayer = ent.layer || null;
      }
    }

    return hitLayer;
  }

  function resetHoveredMesh() {
    if (!hoveredMeshUuid) return;
    const mesh = viewer.GetScene().getObjectByProperty('uuid', hoveredMeshUuid);
    if (mesh && originalMaterialRef.current) {
      mesh.material.dispose();
      mesh.material = originalMaterialRef.current;
      originalMaterialRef.current = null;
    }
    setHoveredMeshUuid(null);
    viewer.renderer.render(viewer.scene, viewer.camera);
  }
  function highlightMesh(mesh) {
    if (!mesh || !mesh.material) return;
    // Save its original material once
    if (!originalMaterialRef.current) {
      originalMaterialRef.current = mesh.material;
    }
    const clone = mesh.material.clone();
    // If it’s a RawShaderMaterial with a color uniform:
    if (clone.uniforms?.color) {
      clone.uniforms.color.value.setHex(0x0000ff);
    }
    // Otherwise, if it’s a basic/standard material:
    else if (clone.color) {
      clone.color.setHex(0x0000ff);
    }
    mesh.material = clone;
    setHoveredMeshUuid(mesh.uuid);
    viewer.renderer.render(viewer.scene, viewer.camera);
  }


  // 3) Updated handleMouseMove, integrating your existing logic
  const handleDXFMouseMove = (e) => {
    const stage = e.target.getStage();
    const ptr = stage.getPointerPosition();
    const viewerCanvas = viewer?.GetCanvas ? viewer.GetCanvas() : null;
    if (!ptr || !viewer || !viewerCanvas) {
      resetHoveredMesh();
      return;
    }

    setMousePosition({ x: ptr.x, y: ptr.y });

    const scaleX = stage.scaleX();
    const scaleY = stage.scaleY();
    const stageX = stage.x();
    const stageY = stage.y();

    const adjustedX = ((ptr.x - stageX) / scaleX) / (gridScaleX * overlayScale);
    const adjustedY = ((ptr.y - stageY) / scaleY) / (gridScaleY * overlayScale);
    // Fallback conversion: pointer in stage space to world space.
    setMouseCoords({ x: adjustedX, y: toWorldY(adjustedY) });

    if (isPanningRef.current) {
      setPreviewPoint(null);
      setIsInSnapRange(false);
      return;
    }

    const snapEnabled = Boolean(
      showMark &&
      markDetails?.show &&
      markDetails?.snap &&
      Array.isArray(markDetails?.points) &&
      Number.isFinite(markDetails?.step) &&
      Number.isFinite(markDetails?.rings)
    );
    if (snapEnabled) {
      const furthestRadius = (markDetails.step * markDetails.rings);
      const snapRadius = furthestRadius + (50 / Math.max(0.0001, gridScaleX * overlayScale));
      const distance = Math.sqrt(
        Math.pow(adjustedX - (markDetails.x / (gridScaleX * overlayScale)), 2) + Math.pow(adjustedY - (markDetails.y / (gridScaleY * overlayScale)), 2)
      );

      if (distance < snapRadius) {
        const closest = findClosestMarkPoint(markDetails.points, adjustedX, adjustedY);
        setPreviewPoint(closest);
        setIsInSnapRange(true);
      } else {
        setPreviewPoint(null);
        setIsInSnapRange(false);
      }
    } else {
      setPreviewPoint(null);
      setIsInSnapRange(false);
    }


    const rect = viewerCanvas.getBoundingClientRect();
    const xOnCanvas = e.evt.clientX - rect.left;
    const yOnCanvas = e.evt.clientY - rect.top;

    if (
      xOnCanvas < 0 || yOnCanvas < 0 ||
      xOnCanvas > rect.width || yOnCanvas > rect.height
    ) {
      resetHoveredMesh();
      return;
    }

    const ndcX = (xOnCanvas / rect.width) * 2 - 1;
    const ndcY = -((yOnCanvas / rect.height) * 2 - 1);

    const camera = viewer.camera;
    camera.updateMatrixWorld();

    const raycaster = raycasterRef.current;
    raycaster.setFromCamera({ x: ndcX, y: ndcY }, camera);

    // Preferred conversion: intersect viewer ray with DXF world plane (z=0).
    const pointerWorld = new THREE.Vector3();
    if (raycaster.ray.intersectPlane(dxfWorldPlaneRef.current, pointerWorld)) {
      // ray/world coords are in raw DXF units; convert to metres to match app/world grid coords
      const worldX = (pointerWorld.x * (scaleFactor || 1)) - gridOffsetX;
      const worldY = (pointerWorld.y * (scaleFactor || 1)) - gridOffsetY;
      setMouseCoords({ x: worldX, y: toWorldY(worldY) });
    }

    const pickables = viewer.GetScene().children;
    const hits = raycaster.intersectObjects(pickables, true);

    if (hits.length > 0) {
      const hitMesh = hits[0].object;
      if (hitMesh.uuid !== hoveredMeshUuid) {
        resetHoveredMesh();
        highlightMesh(hitMesh);
      }
    } else {
      resetHoveredMesh();
    }
  };


  const handleSelectDrawing = (id, opts = {}) => {
    if (id == null) {
      setCurrentDrawingId(null);

      const { baseGrids } = opts;
      const finalizeNoDrawingLoad = () => {
        dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));
        setValidDrawing(true);
        triggerAreaCalc("loaded default drawing");
        setHasUnsavedChanges(false);
        loadingConfigRef.current = false;
      };

      if (viewer) {
        const previousView = viewer.GetCamera && viewer.GetCanvas && viewer.SetView
          ? getViewState()
          : null;

        placeholderDxfLoadedRef.current = true;
        dispatch(notificationActions.UpdateImageLoad({ imageLoad: true }));
        onUpload(generateBasicBorderDxf(), baseGrids).then(() => {
          if (previousView && Number.isFinite(previousView.worldWidth) && previousView.worldWidth > 0) {
            viewer.SetView(previousView.center, previousView.worldWidth);
            if (previousView.controls) {
              previousView.controls.target.set(previousView.center.x, previousView.center.y, 0);
              previousView.controls.update();
            }
            if (viewer.Render) viewer.Render();
            syncStageFromViewer();
          }
          finalizeNoDrawingLoad();
        }).catch((error) => {
          placeholderDxfLoadedRef.current = false;
          loadingConfigRef.current = false;
          dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));
          console.error("Failed to load placeholder DXF during config load", error);
        });
        return;
      }

      finalizeNoDrawingLoad();
      return;
    }
    setDxfScale(1);
    setCurrentDrawingId(id);
    if (threeDView) handle3dView();
    EdgeOrREST(null, 'LOAD_DRAWING', (response) => onLoadDrawing(true, response, opts), id);
    dispatch(notificationActions.UpdateImageLoad({ imageLoad: true }));
    handle3dView(false);
  };

  function onLoadDrawing(moveCamera, response = null, opts = {}) {
    return new Promise((resolve) => {
      const { baseGrids } = opts;
      if (response && response.svg) {
        //onSetSvgImage(response.svg, 1, moveCamera);
        // Pass baseGrids further so DXF parsing uses the config grids
        onUpload(response.svg, baseGrids).then(() => {
          finalize();
          resolve();
        });
      } else {
        // onSetSvgImage(null, 1, moveCamera);
        finalize();
        resolve();
      }
      function finalize() {
        setMetresPerPixelX(1);
        setMetresPerPixelY(1);
        dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));
        setValidDrawing(true);
        triggerAreaCalc("loaded drawing");
        setHasUnsavedChanges(false);
        // Config load flow done
        loadingConfigRef.current = false;
      }
    });
  }

  const generateBlankSvg = (width, height) => {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
        <!-- Background rectangle -->
        <rect x="0" y="0" width="${width}" height="${height}" fill="transparent"/>
        
        <!-- Border rectangle -->
        <rect x="0" y="0" width="${width}" height="${height}" fill="none" stroke="gray" stroke-width="3"/>

        <!-- Text above the border -->
        <text x="${width / 2}" y="10" font-family="Arial" font-size="8" fill="black" text-anchor="middle">
          Default Working Area
        </text>
      </svg>`;
  };


  //useEffect(() => {
  //  onLoadDrawing();
  //}, [viewer]);

  const deleteDrawing = (id) => {
    EdgeOrREST(null, 'DELETE_DRAWING', onDeleteDrawing, id);
    setDrawings(drawings.filter((item) => item.id !== id));
  };


  const onDeleteDrawing = (response) => {
    if (response) {
      console.log(response);
    }
  }


  const handleContextMenu = (event, i, index) => {
    event.evt.preventDefault();
    setContextMenu(true);
    setContextMenuPosition({
      left: mousePosition.x + stageRef.current.attrs.container.offsetLeft,
      top: mousePosition.y + stageRef.current.attrs.container.offsetTop,
    });
    setContextMenuPointIndex(index);
    setContextMenuMaskIndex(i);
  };

  const handleClose = () => {
    setContextMenu(false);
    setContextMenuPointIndex(null);
  };

  const handleDuplicatePoint = () => {
    if (contextMenuPointIndex !== null && contextMenuMaskIndex !== null) {
      const newPoints = [...masks[contextMenuMaskIndex].points];
      const flatPoints = [];
      newPoints.slice(0, -1).forEach(point => {
        if (point && typeof point.x === "number" && typeof point.y === "number") {
          flatPoints.push(point.x, point.y);
        } else {
          console.log("Invalid point:", point);
        }
      });

      const pointCount = flatPoints.length / 2;
      if (pointCount < 2) {
        handleClose();
        return;
      }

      const currentIndex = contextMenuPointIndex;
      const prevIndex = (currentIndex - 1 + pointCount) % pointCount;
      const nextIndex = (currentIndex + 1) % pointCount;

      const prevX = flatPoints[prevIndex * 2];
      const prevY = flatPoints[prevIndex * 2 + 1];
      const currentX = flatPoints[currentIndex * 2];
      const currentY = flatPoints[currentIndex * 2 + 1];
      const nextX = flatPoints[nextIndex * 2];
      const nextY = flatPoints[nextIndex * 2 + 1];

      const prevLength = Math.hypot(currentX - prevX, currentY - prevY);
      const nextLength = Math.hypot(nextX - currentX, nextY - currentY);
      const useNextSide = nextLength >= prevLength;

      const targetX = useNextSide ? nextX : prevX;
      const targetY = useNextSide ? nextY : prevY;
      const insertIndex = useNextSide ? currentIndex + 1 : currentIndex;

      const x = (currentX + targetX) / 2;
      const y = (currentY + targetY) / 2;

      flatPoints.splice(insertIndex * 2, 0, x, y);

      const xyPoints = [];
      for (let i = 0; i < flatPoints.length; i += 2) {
        xyPoints.push({ x: flatPoints[i], y: flatPoints[i + 1] });
      }
      if (xyPoints.length > 0) {
        xyPoints.push({ ...xyPoints[0] });
      }

      const newMask = { ...masks[contextMenuMaskIndex], points: xyPoints };
      const newMasks = [...masks];
      newMasks[contextMenuMaskIndex] = newMask;
      setMasks(newMasks);

    }
    handleClose();
  };

  const handleDeletePoint = () => {
    if (contextMenuPointIndex !== null && contextMenuMaskIndex !== null) {
      const newPoints = [...masks[contextMenuMaskIndex].points];
      const flatPoints = [];
      newPoints.slice(0, -1).forEach(point => {
        if (point && typeof point.x === "number" && typeof point.y === "number") {
          flatPoints.push(point.x, point.y);
        } else {
          console.log("Invalid point:", point);
        }
      });
      flatPoints.splice(contextMenuPointIndex * 2, 2);
      const xyPoints = [];
      for (let i = 0; i < flatPoints.length; i += 2) {
        xyPoints.push({ x: flatPoints[i], y: flatPoints[i + 1] });
      }

      if (xyPoints.length > 0) {
        xyPoints.push({ ...xyPoints[0] });
      }
      const newMask = { ...masks[contextMenuMaskIndex], points: xyPoints };
      const newMasks = [...masks];
      newMasks[contextMenuMaskIndex] = newMask;
      setMasks(newMasks);

    }
    handleClose();
  };

  const toggleMeasureMode = () => {
    setMeasureMode(!measureMode);
    setMeasureStartPoint(null);
    setMeasureDistance(0);
    setMeasureLine([]);
  };

  useEffect(() => {
    if (measureMode) {
      setCursorType('pointer');
    } else {
      setCursorType('default');
    }
  }, [measureMode]);

  useEffect(() => {
    const cursor = cursorType || 'default';
    if (planRef.current?.style) {
      planRef.current.style.cursor = cursor;
    }
    const stageContainer = stageRef.current?.container?.();
    if (stageContainer?.style) {
      stageContainer.style.cursor = cursor;
    }
    if (dxfContainerRef.current?.style) {
      dxfContainerRef.current.style.cursor = cursor;
    }
  }, [cursorType]);

  const handleSaveMark = (markData) => {
    console.log("Save mark data", markData);
    console.log("Current mark details", markDetails);
    const show = markData.show ?? markDetails.show ?? true;
    const snap = show ? (markData.snap ?? markDetails.snap ?? false) : false;
    const points = generateRingPoints(markData.x, markData.y, markData.step ?? markDetails.step, markData.rings ?? markDetails.rings);
    console.log("Generated points", points);
    setMarkDetails((prev) => ({
      ...prev,
      ...markData,
      show,
      snap,
      points
    }));

    setShowMark(show);
    if (!show) {
      setPreviewPoint(null);
      setIsInSnapRange(false);
    }
    setMarkOpen(false);
  };

  useEffect(() => {
    if (markDetails.show) {
      console.log("Regenerating ring points due to grid scale change", markDetails);
      console.log("Grid scale X:", gridScaleX, "Grid scale Y:", gridScaleY);
      const points = generateRingPoints(markDetails.x, markDetails.y, markDetails.step, markDetails.rings);
      console.log("New points", points);

      setMarkDetails((prev) => ({
        ...prev,
        points
      }));
    }
  }, [gridScaleX, gridScaleY, overlayScale]);

  const generateRingPoints = (centerX, centerY, step, rings, numPoints = 36, spacing = 2) => {
    const points = [];

    const adjustedCenterX = centerX / (gridScaleX * overlayScale);
    const adjustedCenterY = centerY / (gridScaleY * overlayScale);


    console.log("Generating ring points at", adjustedCenterX, adjustedCenterY, "step", step, "rings", rings);
    console.log("Grid scale X:", gridScaleX, "Grid scale Y:", gridScaleY, "overlayScale:", overlayScale);


    for (let i = 0; i < rings; i++) {
      const radius = step * (i + 1);
      const circumference = 2 * Math.PI * radius;
      const pointsForCurrentRing = Math.max(
        Math.floor(circumference / spacing),
        numPoints
      );

      for (let j = 0; j < pointsForCurrentRing; j++) {
        const angle = (2 * Math.PI * j) / pointsForCurrentRing;
        const px = adjustedCenterX + radius * Math.cos(angle);
        const py = adjustedCenterY + radius * Math.sin(angle);
        points.push({
          x: px,
          y: py
        });
      }

    }

    points.push({ x: adjustedCenterX, y: adjustedCenterY }); // Center point

    return points;
  };

  const handleSetMarkFromColumnCoords = ({ x, y }) => {
    const worldX = Number(x);
    const worldY = Number(y);
    if (!Number.isFinite(worldX) || !Number.isFinite(worldY)) return;

    const displayY = shouldFlipY ? (worldHeightValue - worldY) : worldY;
    const centerX = worldX * gridScaleX * overlayScale;
    const centerY = displayY * gridScaleY * overlayScale;

    const step = Number(markDetails.step) || 10;
    const rings = Number(markDetails.rings) || 15;
    const snap = markDetails.snap ?? false;
    const show = markDetails.show ?? true;
    const points = generateRingPoints(centerX, centerY, step, rings);

    setMarkDetails((prev) => ({
      ...prev,
      x: centerX,
      y: centerY,
      step,
      rings,
      snap,
      show,
      points
    }));
    setShowMark(true);
  };

  const handleMarkClose = (e) => {
    console.log("Close mark dialog", markDetails);
    setMarkOpen(false);
  }

  const handleShowContours = (e) => {
    setShowContours(!showContours);
    dispatch(roadActions.AddToCurrentState({ showContours: !showContours }));
  }

  const handle3dView = (forcedState = undefined) => {
    if (!image?.src && !viewer) {
      setSnack({
        open: true,
        message: "Please load a drawing first",
        severity: 'warning'
      })
    } else {
      set3dView(forcedState !== undefined ? forcedState : !threeDView);
    }
  }

  const handleOpenConfirm = (item, option) => {
    setConfirmOpen(true);
    setConfirmItem(item);
    setOption(option);
  }

  const handleConfirm = (e) => {
    if (option === 'Delete') {
      deleteConfig(confirmItem.id);
    } else if (option === 'Update') {
      saveConfig(e, confirmItem.id);
    } else if (option === 'Load') {
      handleLoadConfig(e, confirmItem.id)
    } else if (option === 'Export') {
      handleExportConfig(e, confirmItem.id)
    }
    handleConfirmClose();
  }
  const handleConfirmClose = () => {
    setConfirmOpen(false);
  }

  const handleChangeDefaultColumn = (e) => {
    var temp = e.target.name;
    setDefaultColumnSettingValues((prevColumn) => ({
      ...prevColumn,
      [temp]: e.target.value
    }));
  }

  const handleExportConfig = (e, id) => {
    EdgeOrREST(null, 'EXPORT_PLAN_SESSION', onExportConfig, { headers: { 'id': id } });
  }

  const handleSelectLRPS = (e) => {
    // console.log("handleImportLRS: " + e.target.files);

    for (const file of e.target.files) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        // console.log("event.target.result", event.target.result);
        console.log("Base64 File Data:", event.target.result); // Data URL format
        const fileData = {
          fileName: file.name,
          content: event.target.result.split(',').pop(),
        };

        // Update state with new file data
        setFilesData((prevFiles) => [...prevFiles, fileData]);

      };
    }
  };

  const handleImportLRPS = (e) => {
    if (!filesData || filesData.length === 0) {
      setSnack({
        open: true,
        message: "No files selected",
        severity: 'warning'
      });
    } else {
      setFileDisable(true);
      var tempName = "";
      for (const fileData of filesData) {
        console.log("fileData", fileData);
        tempName = fileData.fileName.replace(/\.[^/.]+$/, "");
        EdgeOrREST(null, 'IMPORT_PLAN_SESSION', importLRPS, ({ data: fileData.content, fileName: tempName }));
      }
    }
  }

  const importLRPS = (response) => {
    console.log("import LRPS");
    if (response && response.status == '200') {
      getAllPlanSessions();
      setSnack({
        open: true,
        message: 'Configuration import success',
        severity: 'success'
      });
      setFileDisable(false);
    } else {
      setSnack({
        open: true,
        message: "Import files failed: " + response.message,
        severity: 'error'
      });
    }
  }


  const onExportConfig = (response) => {
    if (response && response.status == '200') {
      console.log("Export Config Response", response);
      var mediaType = "data:application/octet-stream;base64,";
      var a = document.createElement('a');
      a.href = mediaType + response.data.data;
      a.download = response.data.filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setSnack({
        open: true,
        message: 'Export success',
        severity: 'success'
      });
    } else {
      setSnack({
        open: true,
        message: "Export failed",
        severity: 'error'
      });
    }
  }

  const handleExportColumnsAsCsv = () => {
    const luminIdList = state.Plan.selectedLuminaires;
    // Build a map from column id to group name
    const colIdToGroupName = {};
    columnGroups.forEach(group => {
      (group.columnIds || []).forEach(colId => {
        colIdToGroupName[colId] = group.name;
      });
    });

    const columnValues = columns.map((column, id) => {
      const { columnConfiguration, luminaireId, ...restValues } = column.values;
      return {
        name: column.name,
        groupName: colIdToGroupName[column.id] || "",
        values: {
          ...restValues,
          luminaire: luminNameList[luminIdList.indexOf(column.values.luminaireId)]
        }
      };
    });

    // Prepare columns CSV
    let columnsCsv = "";
    if (columnValues.length === 0) {
      setSnack({
        open: true,
        message: "No columns to export",
        severity: 'warning'
      });
      return;
    } else {
      columnsCsv = [
        ["Name", "Group", "x", "y", ...Object.keys(columnValues[0].values).filter(key => key !== "point")].join(","),
        ...columnValues.map(column => [
          column.name,
          column.groupName,
          column.values.point.x,
          column.values.point.y,
          ...Object.entries(column.values)
            .filter(([key]) => key !== "point")
            .map(([_, value]) => (typeof value === 'object' ? JSON.stringify(value) : value))
        ].join(","))
      ].join("\n");
    }

    const blob = new Blob([columnsCsv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'LR_Plan_columns.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSelectCsv = (e) => {
    for (const file of e.target.files) {
      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = (event) => {
        const csvContent = event.target.result;
        const rows = csvContent.split('\n').map(row => row.split(','));
        setFilesData((prevFiles) => [...prevFiles, { fileName: file.name, content: rows }]);
      };
    }
  };

  const handleImportCsv = () => {
    if (!filesData || filesData.length === 0) {
      setSnack({
        open: true,
        message: "No files selected",
        severity: 'warning'
      });
    } else {
      setFileDisable(true);
      filesData.forEach(fileData => {
        console.log("fileData", fileData);
        const rows = fileData.content;
        const headers = rows[0];
        const importedColumns = rows.slice(1).map(row => {
          const columnData = {};
          headers.forEach((header, index) => {
            if (header === "x" || header === "y") {
              columnData[header] = parseFloat(row[index]);
            } else if (header === "Name") {
              columnData.name = row[index];
            } else if (header === "Group") {
              columnData.groupName = row[index];
            } else {
              try {
                columnData[header] = JSON.parse(row[index]);
              } catch {
                columnData[header] = row[index];
              }
            }
          });
          return columnData;
        });

        // Build groupName -> [columnIds] map and columnGroups array
        const groupMap = {};
        const groupIdMap = {};
        const newColumns = importedColumns.map(col => {
          const id = uuidv4();
          let groupId = null;
          if (col.groupName) {
            if (!groupIdMap[col.groupName]) {
              groupIdMap[col.groupName] = uuidv4();
            }
            groupId = groupIdMap[col.groupName];
            if (!groupMap[groupId]) groupMap[groupId] = { name: (col.groupName || "Unnamed Group") + " (Imported)", columnIds: [] };
            groupMap[groupId].columnIds.push(id);
          }
          return {
            id,
            name: col.name || `Imported Column`,
            values: {
              point: { x: col.x, y: col.y },
              ...Object.fromEntries(
                Object.entries(col).filter(([key]) =>
                  key !== "x" && key !== "y" && key !== "name" && key !== "groupName"
                )
              )
            },
            selected: false,
            locked: false,
            color: color,
          };
        });

        // Create columnGroups array from groupMap
        const newColumnGroups = Object.entries(groupMap).map(([groupId, groupObj]) => ({
          name: groupObj.name,
          id: groupId,
          columnIds: groupObj.columnIds,
          sync: false,
          locked: false,
        }));

        setColumns(prevColumns => [...prevColumns, ...newColumns]);
        setColumnGroups(prevGroups => [...prevGroups, ...newColumnGroups]);
      });

      setSnack({
        open: true,
        message: "Columns imported successfully",
        severity: 'success'
      });
      setFileDisable(false);
      setFilesData([]);
    }
  };

  const handleAddGroupClick = () => {
    const newGroup = {
      id: uuidv4(),
      name: "New Group #" + (columnGroups.length + 1),
      columnIds: [],
      sync: false,
      locked: false,
    }
    setColumnGroups([...columnGroups, newGroup]);
  };

  const handleCapture = () => {
    // Capture both Konva stage and DxfViewer as a combined image
    const stage = stageRef.current;
    // Remove any duplicate/old DXF canvases before capturing
    if (dxfContainerRef.current) {
      const canvases = dxfContainerRef.current.querySelectorAll('canvas');
      if (canvases.length > 1) {
        // Keep only the last (most recent) canvas
        for (let i = 0; i < canvases.length - 1; i++) {
          canvases[i].parentNode.removeChild(canvases[i]);
        }
      }
    }
    const dxfCanvas = dxfContainerRef.current?.querySelector('canvas');
    // Use the viewer variable for DXF rendering if available
    let dxfImagePromise = null;

    if (viewer && viewer.renderer && viewer.renderer.domElement) {
      // Render the current DXF scene to a data URL
      dxfImagePromise = new Promise((resolve) => {
        // Ensure the renderer is up to date
        viewer.renderer.render(viewer.scene, viewer.camera);
        // Use the renderer's canvas
        const dxfCanvasEl = viewer.renderer.domElement;
        resolve(dxfCanvasEl.toDataURL('image/png'));
      });
    } else if (dxfCanvas) {
      dxfImagePromise = Promise.resolve(dxfCanvas.toDataURL('image/png'));
    }

    if (stage && dxfImagePromise) {
      // Render Konva stage to image
      const stageDataUrl = stage.toDataURL({ pixelRatio: 2 });

      dxfImagePromise.then((dxfDataUrl) => {
        // Create an offscreen canvas to combine both
        // const width = Math.max(stage.width(), dxfCanvas?.width || 0, viewer?.renderer?.domElement?.width || 0);
        // const height = Math.max(stage.height(), dxfCanvas?.height || 0, viewer?.renderer?.domElement?.height || 0);
        const offscreen = document.createElement('canvas');
        offscreen.width = stage.width();
        offscreen.height = stage.height();
        const ctx = offscreen.getContext('2d');

        // Draw DXF first (background)
        const dxfImg = new window.Image();
        dxfImg.onload = () => {
          // Only draw DXF once
          // ctx.drawImage(dxfImg, 0, 0);

          // Draw Konva stage on top
          const stageImg = new window.Image();
          stageImg.onload = () => {
            ctx.drawImage(stageImg, 0, 0, stage.width(), stage.height());

            // Trigger download
            const combinedUrl = offscreen.toDataURL('image/png');
            const link = document.createElement('a');
            link.download = 'canvas-dxf-capture.png';
            link.href = combinedUrl;
            link.click();
          };
          stageImg.src = stageDataUrl;
        };
        dxfImg.src = dxfDataUrl;
      });
    } else if (stage) {
      // Fallback: just Konva stage
      const dataURL = stage.toDataURL({ pixelRatio: 2 });
      const link = document.createElement('a');
      link.download = 'canvas-capture.png';
      link.href = dataURL;
      link.click();
    } else if (dxfCanvas) {
      // Fallback: just DXF canvas
      const dataURL = dxfCanvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = 'dxf-capture.png';
      link.href = dataURL;
      link.click();
    }
  }

  const handleAddReportCaptureArea = (event) => {
    event.preventDefault();
    var newCaptureArea = {};
    newCaptureArea.id = uuidv4();
    newCaptureArea.points = [];
    newCaptureArea.name = "#" + reportCaptureAreas.length;
    newCaptureArea.visible = true; // For the name to be visible
    // newCaptureArea.color = null;
    newCaptureArea.selected = false;
    newCaptureArea.opacity = 0.5;
    newCaptureArea.locked = false;
    newCaptureArea.scaleX = 1;
    newCaptureArea.scaleY = 1;
    newCaptureArea.rotation = 0;

    const stageWidth = stageRef.current?.attrs.width || 0;
    const stageHeight = stageRef.current?.attrs.height || 0;

    const stageScaleX = stageRef.current?.attrs.scaleX || 1;
    const stageScaleY = stageRef.current?.attrs.scaleY || 1;
    const stageX = stageRef.current?.attrs.x || 0;
    const stageY = stageRef.current?.attrs.y || 0;

    newCaptureArea.x = Math.round((stageWidth / 2 - stageX) / stageScaleX * 100) / 100;
    newCaptureArea.y = Math.round((stageHeight / 2 - stageY) / stageScaleY * 100) / 100;

    newCaptureArea.width = 50;
    newCaptureArea.height = 50;

    newCaptureArea.x -= newCaptureArea.width / 2;
    newCaptureArea.y -= newCaptureArea.height / 2;

    newCaptureArea.points = [
      { x: newCaptureArea.x, y: newCaptureArea.y },
      { x: newCaptureArea.x + newCaptureArea.width, y: newCaptureArea.y },
      { x: newCaptureArea.x + newCaptureArea.width, y: newCaptureArea.y + newCaptureArea.height },
      { x: newCaptureArea.x, y: newCaptureArea.y + newCaptureArea.height },
    ];

    let arr = [...reportCaptureAreas];
    arr.push(newCaptureArea);
    setReportCaptureAreas(arr);
  };

  const selectReportCaptureArea = (id) => {
    if (isCanvasSelectionBlocked()) {
      return;
    }
    let tempReportCaptureAreas = [...reportCaptureAreas];
    if (!multipleSelect) {
      const reportCaptureAreasIndex = tempReportCaptureAreas.findIndex(reportCaptureAreas => reportCaptureAreas.id === id);
      if (reportCaptureAreasIndex !== -1) {
        if (tempReportCaptureAreas[reportCaptureAreasIndex].selected === false) {
          tempReportCaptureAreas = tempReportCaptureAreas.map((reportCaptureArea) => ({
            ...reportCaptureArea,
            selected: reportCaptureArea.id === id ? !reportCaptureArea.selected : false,
          }));
        } else {
          const selectedCount = tempReportCaptureAreas.filter(reportCaptureAreas => reportCaptureAreas.selected).length;
          if (selectedCount > 1) {
            tempReportCaptureAreas[reportCaptureAreasIndex].selected = true;
            tempReportCaptureAreas = tempReportCaptureAreas.map((reportCaptureAreas) => ({
              ...reportCaptureAreas,
              selected: reportCaptureAreas.id === id ? true : false,
            }));
          } else {
            tempReportCaptureAreas[reportCaptureAreasIndex].selected = !tempReportCaptureAreas[reportCaptureAreasIndex].selected;
          }
        }
      }
    } else {
      const reportCaptureAreasIndex = tempReportCaptureAreas.findIndex(reportCaptureAreas => reportCaptureAreas.id === id);
      if (reportCaptureAreasIndex !== -1) {
        tempReportCaptureAreas[reportCaptureAreasIndex].selected = !tempReportCaptureAreas[reportCaptureAreasIndex].selected;
      }
    }

    const updatedReportCaptureArea = tempReportCaptureAreas.find(reportCaptureAreas => reportCaptureAreas.id === id);
    if (updatedReportCaptureArea) updatedReportCaptureArea.locked = false;

    setReportCaptureAreas(tempReportCaptureAreas);
  };


  const deleteReportCaptureArea = (id) => {
    const updatedReportCaptureAreas = reportCaptureAreas.filter(reportCaptureAreas => reportCaptureAreas.id !== id);
    setReportCaptureAreas(updatedReportCaptureAreas);
  };



  const lockReportCaptureArea = (id) => {
    const tempReportCaptureAreas = [...reportCaptureAreas];
    const reportCaptureAreaIndex = tempReportCaptureAreas.findIndex(reportCaptureArea => reportCaptureArea.id === id);
    if (reportCaptureAreaIndex !== -1) {
      if (!tempReportCaptureAreas[reportCaptureAreaIndex].locked) {
        tempReportCaptureAreas[reportCaptureAreaIndex].selected = false;
      }
      tempReportCaptureAreas[reportCaptureAreaIndex].locked = !tempReportCaptureAreas[reportCaptureAreaIndex].locked;
    }
    setReportCaptureAreas(tempReportCaptureAreas);
  };

  const updateReportCaptureArea = (e, i) => {
    var tempReportCaptureAreas = [...reportCaptureAreas];
    console.log("updateReportCaptureArea", tempReportCaptureAreas);
    console.log("e", e);
    const width = e.target.attrs.width;
    const height = e.target.attrs.height;
    const scaleX = e.target.attrs.scaleX;
    const scaleY = e.target.attrs.scaleY;
    const rotation = e.target.attrs.rotation;
    const opacity = e.target.attrs.opacity || 0.5;
    const x = e.target.attrs.x;
    const y = e.target.attrs.y;

    const rotationRadians = rotation * (Math.PI / 180);

    const originalPoints = [
      { x: x, y: y },
      { x: x + width * scaleX, y: y },
      { x: x + width * scaleX, y: y + height * scaleY },
      { x: x, y: y + height * scaleY }
    ];

    const rotatedPoints = originalPoints.map(point => {
      const translatedX = point.x - x;
      const translatedY = point.y - y;

      const rotatedX = translatedX * Math.cos(rotationRadians) - translatedY * Math.sin(rotationRadians);
      const rotatedY = translatedX * Math.sin(rotationRadians) + translatedY * Math.cos(rotationRadians);

      return { x: rotatedX + x, y: rotatedY + y };
    });

    tempReportCaptureAreas[i] = {
      ...tempReportCaptureAreas[i],
      points: rotatedPoints,
      x,
      y,
      width,
      height,
      scaleX,
      scaleY,
      rotation,
      opacity
    };

    setReportCaptureAreas(tempReportCaptureAreas);
    triggerAreaCalc("updated report capture");
  };

  //The Temp PDF Upload Function
  const handlePdfUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      const reader = new FileReader();

      reader.onload = () => {
        const base64PDF = reader.result.split(',')[1]; // Get only the base64 part

        const reportObject = {
          fileNames: file.name,
          data: base64PDF, // Assuming backend expects base64
          // Add any other required fields
        };

        EdgeOrREST(null, "UPLOAD_TEST_PDF", onUploadPDF, reportObject);
      };

      reader.readAsDataURL(file);
    } else {
      alert('Please upload a valid PDF file.');
    }
  };

  const onUploadPDF = (response) => {
    if (response.success) {
      console.log('Area calculation data:', response.data);
      // You can now update state, show results, or do something with the data
    } else {
      console.error('Failed to get area calculation:', response.error || response.message);
    }
  };

  const resetAll = () => {
    placeholderDxfLoadedRef.current = false;
    lastParsedDxfRef.current = null;
    contourGridLayerRef.current = null;
    gridTrRef.current = null;
    contourImageRef.current = null;
    contourLayerRef.current = null;
    contourShapeRef.current = null;
    planRef.current = null;
    linesLayerRef.current = null;
    layerRef.current = null;
    stageRef.current = null;
    setDxfCanvas(null);
    setLayers([]);
    setViewer(null);
    setCurrentDrawingId(null);
    setValidDrawing(false);
    setMasks([]);
    setShowMark(false);
    setShowContours(false);
    setLuminNameList([]);
    setNumberOfLuminaires(0);
    setDefaultColumnSettings([]);
    setColors([]);
    setColor(DEFAULT_COLUMN_COLOR);
    setCurrentLuminId(null);
    setCurrValueId(0);
    setDefaultColumnSettingValues(createDefaultColumnSetting());
    setColumns([]);
    setColumnGroups([{
      name: "Default Group",
      id: 0,
      columnIds: [],
      sync: false,
      locked: false,
    }]);
    setReportCaptureAreas([]);
    setVisualGrid({
      x: 0,
      y: 0,
      height: 100,
      width: 100
    });
    setGrids([{
      selected: false,
      name: "Grid #0",
      angle: 0,
      showResults: false,
      edgeStart: "False",
      id: 0,
      maskAll: "False",
      maskingLayer: "0",
      obsAngle: 0,
      obsHeight: 1.5,
      xSpacing: 1.5,
      ySpacing: 1.5,
      origin: {
        x: { start: 0, length: 25 },
        y: { start: 0, length: 25 },
        z: { start: 0, length: 0 }
      },
      maxSpacing: 1.5,
      type: "Horizontal",
      verticalGridSide: "False"
    }]);
    setStage({
      scale: 1,
      x: 0,
      y: 0,
    });
    setGridScaleX(1);
    setGridScaleY(1);
    dispatch(planActions.UpdatePlanLuminaires({
      selectedLuminaires: [],
      selectedLuminaireNames: [],
      selectedLuminaireColors: [],
      selectedLuminaireFolders: [],
    }));
    triggerAreaCalc("reset plan");
    handleConfirmResetClose();
  }

  const liveStageScale = stageRef.current?.scaleX?.() ?? stage.scale;

  return (
    <Page className={classes.root + " planStep-canvas"} title="Design" style={{}}>
      {/* toolbar */}
      <Drawer
        anchor="left"
        open={leftDrawerOpen}
        onClose={toggleLeftDrawer}
        variant='persistent'
        className={classes.drawer}
      // onContextMenu={handleContextMenu}
      >

        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
          className='planStep-left-toolbar'
        >
          <Tooltip title="Reset working area" placement="right">
            <IconButton onClick={() => setConfirmResetOpen(true)}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Undo" placement="right">
            <IconButton onClick={() => undoAction()}>
              <UndoIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Redo" placement="right">
            <IconButton onClick={() => redoAction()}>
              <RedoIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Upload area drawing" placement="right">
            <IconButton
              className={"planStep-drawing-import"}
              onClick={(e) => {
                setUploadAreaOpen(true);
                setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50)
              }}
            >
              <AddPhotoAlternate />
            </IconButton>
          </Tooltip>
          <Dialog
            open={uploadAreaOpen}
            disableEscapeKeyDown
            disableEnforceFocus
            hideBackdrop
            BackdropProps={{ open: false }}
          >
            <Box className={"planStep-drawing-file-select2"}>
              <DialogTitle>Add your area</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <Typography>
                    Upload a CAD Drawing/Image of your area
                  </Typography>
                </DialogContentText>
                <label>
                  <input accept=".dwg,.dxf" type="file" style={{ display: 'none' }}
                    onChange={(e) => handleUploadClick(e)} />
                  <Tooltip placement='top' title="Upload CAD File">
                    <IconButton color="primary" aria-label="upload cad file" component="span"
                      className={"planStep-drawing-file-select"}
                    >
                      <img src={CADConvertIcon} alt="Convert to CAD" style={{
                        width: 24,
                        height: 24
                      }} />
                    </IconButton>
                  </Tooltip>
                </label>
                <TextField
                  style={{ margin: '10px', padding: '4px' }}
                  label="Resolution (Zoom)"
                  name="resolution"
                  type="number"
                  value={dxfScaleInput}
                  variant="outlined"
                  inputProps={{ step: 0.25, min: 1, max: 4 }}
                  onChange={e => setDxfScaleInput(e.target.value)}
                  onBlur={handleDxfScaleCommit}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === 'Tab') {
                      handleDxfScaleCommit();
                    }
                  }}
                />
                <TextField
                  style={{ margin: '10px', padding: '4px' }}
                  label="Scale Factor"
                  name="scaleFactorOverride"
                  type="number"
                  value={scaleOverrideInput}
                  placeholder={originalScaleFactor.toString()}
                  variant="outlined"
                  helperText={`File Default: ${originalScaleFactor}`}
                  inputProps={{ step: 0.001, min: 0 }}
                  onChange={e => setScaleOverrideInput(e.target.value)}
                  onBlur={handleScaleOverrideCommit}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === 'Tab') {
                      handleScaleOverrideCommit();
                    }
                  }}
                />
              </DialogContent>
              <Button fullWidth onClick={(e) => { setUploadAreaOpen(false); setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50); }} color={"primary"} variant="contained">
                <Typography>Close</Typography>
              </Button>
            </Box>
          </Dialog>
          <Tooltip title="Contours" placement="right">
            <IconButton onClick={(e) => setContourSettingsOpen(true)}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Dialog
            open={contourSettingsOpen}
            disableEscapeKeyDown
            disableEnforceFocus
            hideBackdrop
            BackdropProps={{ open: false }}
          >
            <DialogTitle>Contour Settings</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Typography>
                  Set your contour values
                </Typography>
              </DialogContentText>
              <ContourValues />
              <FormControlLabel
                control={<Checkbox onClick={() => handleShowContours()} checked={showContours} />}
                label="Toggle Contours"
              />
            </DialogContent>
            <Button onClick={(e) => setContourSettingsOpen(false)} color={"primary"} variant="contained"><Typography>Close</Typography></Button>
          </Dialog>

          <IconButton
            onClick={(event) => handleAddMask(event, "circle", true)}
            onContextMenu={(event) => handleAddMask(event, "circle", false)}
          >
            <Tooltip title="Left Click - Mask In / Right Click - Mask Out" placement='right'>
              <PanoramaFishEyeIcon />
            </Tooltip>
          </IconButton>

          <IconButton
            onClick={(event) => handleAddMask(event, "rectangle", true)}
            onContextMenu={(event) => handleAddMask(event, "rectangle", false)}
          >
            <Tooltip title="Left Click - Mask In / Right Click - Mask Out" placement='right'>
              <RectangleIcon />
            </Tooltip>
          </IconButton>

          <IconButton
            disabled={maskMode}
            onClick={() => {
              setMaskMode(!maskMode);
              setIsDrawing(!isDrawing);
              setCursorType(cursorType == 'crosshair' ? 'default' : 'crosshair');
              setPolyMaskIn(true)
            }}
            onContextMenu={(e) => {
              e.preventDefault();
              setMaskMode(!maskMode);
              setIsDrawing(!isDrawing);
              setCursorType(cursorType == 'crosshair' ? 'default' : 'crosshair');
              setPolyMaskIn(false)
            }}
          >
            <Tooltip title="Left Click - Mask In / Right Click - Mask Out" placement='right'>
              <TimelineIcon />
            </Tooltip>
          </IconButton>

          <IconButton onClick={(event) => {
            setMaskMode(false);
            setCursorType('default');
            setIsDrawing(false);
          }}>
            <Tooltip title="Default Mode" placement="right">
              <PanToolIcon />
            </Tooltip>
          </IconButton>

          <IconButton onClick={toggleMeasureMode}>
            <Tooltip title="Measure" placement="right">
              <Straighten />
            </Tooltip>
          </IconButton>

          <IconButton onClick={() => setMarkOpen(true)}>
            <Tooltip title="Mark" placement="right">
              <ControlPointIcon />
            </Tooltip>
          </IconButton>

          <MarkEditor open={markOpen} onClose={handleMarkClose} stageRef={stageRef}
            saveMark={handleSaveMark} markData={markDetails}
            dxfScale={overlayScale} gridScaleX={gridScaleX} gridScaleY={gridScaleY}
          />

          <Tooltip title="3D View" placement="right">
            <IconButton onClick={(e) => handle3dView()}>
              <ViewInArIcon />
            </IconButton>
          </Tooltip>

          <ThreeDView open={threeDView} grids={grids} masks={masks} columns={columns}
            colorList={colors} luminaires={state.Plan.selectedLuminaires}
            realWidth={realWorldWidth} realHeight={realWorldHeight} image={image?.src || viewer}
            areaResults={areaResults} gridScaleX={gridScaleX} gridScaleY={gridScaleY}
            showAllMasks={showAllMasks} minResult={gridResultsMinimum} viewer={viewer}
            scaleFactor={scaleFactor} visualGrid={visualGrid}
            gridOffsetX={gridOffsetX} gridOffsetY={gridOffsetY}
          />

          {/* <IconButton>
            <Tooltip title="Capture Canvas as Image" placement="right">
              <CameraAltIcon onClick={() => handleCapture()} />
            </Tooltip>
          </IconButton> */}

          <Dialog
            open={confirmResetOpen}
            onClose={handleConfirmResetClose}
            disableEscapeKeyDown
            disableEnforceFocus
            hideBackdrop
            BackdropProps={{ open: false }}
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
          >
            <DialogTitle id="alert-dialog-title"> Reset Working Area</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to reset the working area?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => resetAll()} color="primary">
                Yes
              </Button>
              <Button onClick={handleConfirmResetClose} color="primary" autoFocus>
                No
              </Button>
            </DialogActions>
          </Dialog>

        </Box>
        <div style={{ marginTop: 'auto', textAlign: 'right' }}>
          <IconButton onClick={toggleLeftDrawer}>
            <Tooltip title="Hide Toolbar">
              <Typography>Close</Typography>
            </Tooltip>
          </IconButton>
        </div>
      </Drawer >
      {/* main drawing part */}
      <div
        ref={planRef}
        onMouseDownCapture={(e) => { handleAddColumnModeClick(e) }}
        style={{
          position: "relative",
          width: "100%", // or any constraint you want
          height: "100%", // or whatever
          overflow: "hidden",
          cursor: cursorType,
        }}
      >
        <div
          ref={dxfContainerRef}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: containerSize.width,
            height: containerSize.height,
            zIndex: 1,
          }}
        >
          {/* The DXF library will render a <canvas> here. */}
          {/* After upload, set the canvas width/height to containerSize.width/height. */}
        </div>
        <Stage
          width={containerSize.width}
          height={containerSize.height}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 5,
          }}
          onWheel={handleWheel}
          ref={stageRef}
          scaleX={stage.scale}
          scaleY={stage.scale}
          x={stage.x}
          y={stage.y}
          onMouseMove={(e) => {
            handleMouseMove(e);
            if (!isPanningRef.current) {
              handleDXFMouseMove(e);
            }
            handleMeasureMouseMove(e);
          }}
          onMouseDown={(e) => {
            handleMouseDown(e);
            handleDrawLineMouseDown(e);
            handleMeasureMouseDown(e);
          }}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}
          draggable={false}
        >
          <Layer listening={true} >
            {dxfCanvas && (
              <KonvaImage
                x={0} y={0}
                image={dxfCanvas}
                width={imagePixelWidth}
                height={imagePixelHeight}
              />
            )}
          </Layer>


          {contourImage != null && contourGridLayerRef != null && contourGridLayerRef.current != null && showContours ?
            <Layer>
              <KonvaImage
                ref={contourImageRef}
                image={contourImage}
                height={stageRef.current.attrs.height}
                width={stageRef.current.attrs.width}
                x={contourGridLayerRef.current.getAbsolutePosition().x - imageLayerRef.current.getAbsolutePosition().x}
                y={contourGridLayerRef.current.getAbsolutePosition().y - imageLayerRef.current.getAbsolutePosition().y}
              />
            </Layer>
            : null
          }

          <Layer id="gridLayer">
            <Rect ref={contourGridLayerRef} sides={10}
              x={visualGrid.x}
              y={visualGrid.y}
              width={visualGrid.width}
              height={visualGrid.height}
              fill="lightblue"
              opacity={0}
              shadowEnabled={false} draggable={false}
            />
          </Layer>

          {/* Grid layering: Grid #0 at bottom, then other grids (selected ones rendered last within grid set). */}
          {grids
            ?.filter((grid) => grid.id === 0)
            .map((grid) => (
              <CanvasGrid i={grid.id} grid={grid}
                key={grid.id}
                updateGrid={updateGrid} selectGrid={selectGrid} state={state} planRef={planRef} selected={grid.selected}
                gridScaleX={gridScaleX} gridScaleY={gridScaleY} areaResults={areaResults} showResults={grid.showResults}
                stageScale={stage.scale} dxfScale={overlayScale} minResult={gridResultsMinimum}
                flipY={shouldFlipY} worldHeight={worldHeightValue} textUnflipY={isStageYUp}
              />
            ))}

          {grids
            ?.filter((grid) => grid.id !== 0)
            .sort((a, b) => {
              if (a.selected === b.selected) return Number(a.id) - Number(b.id);
              return a.selected ? 1 : -1;
            })
            .map((grid) => (
              <CanvasGrid i={grid.id} grid={grid}
                key={grid.id}
                updateGrid={updateGrid} selectGrid={selectGrid} state={state} planRef={planRef} selected={grid.selected}
                gridScaleX={gridScaleX} gridScaleY={gridScaleY} areaResults={areaResults} showResults={grid.showResults}
                stageScale={stage.scale} dxfScale={overlayScale} minResult={gridResultsMinimum}
                flipY={shouldFlipY} worldHeight={worldHeightValue} textUnflipY={isStageYUp}
              />
            ))}

          {showContours && <ContourMapLayer
            gridValues={contourGridResults}
            gridRect={grids[0]} scale={liveStageScale}
            contourValues={contourValues}
            autoContourValues={autoContourValues}
            contourColors={contourColors}
            heatmap={heatmap}
            greyscale={greyscale}
            gridScaleX={gridScaleX}
            gridScaleY={gridScaleY}
            dxfScale={overlayScale}
            flipY={shouldFlipY}
            worldHeight={worldHeightValue}
          />}

          {/* masks */}
          {masks.map((mask, i) => {
            if (mask.type === "polygon") {
              return (
                <CustomMask
                  key={mask.id || i}
                  i={i}
                  selectMask={selectMask}
                  mask={mask}
                  maskList={masks}
                  handleContextMenu={handleContextMenu}
                  updateMask={updateMask}
                  stageScale={stage.scale}
                  dxfScale={overlayScale}
                  flipY={shouldFlipY}
                  worldHeight={worldHeightValue}
                  textUnflipY={isStageYUp}
                />
              );
            } else if (mask.type !== "polygon") {
              return (
                <Mask
                  key={mask.id || i}
                  i={i}
                  updateMask={updateMask}
                  selectMask={selectMask}
                  maskType={mask.type}
                  state={state}
                  selected={mask.selected}
                  mask={mask}
                  maskList={masks}
                  stageScale={stage.scale}
                  dxfScale={overlayScale}
                  flipY={shouldFlipY}
                  worldHeight={worldHeightValue}
                  showAllMasks={showAllMasks}
                  textUnflipY={isStageYUp}
                />
              );
            }

            console.warn(`No corresponding poly for mask at index ${i}:`, mask);
            return null;
          })}

          {/* Columns/masts are always above grids and masks. */}
          <Layer ref={layerRef}>
            {columns?.map((column, i) => (
              <ColumnHandler
                key={column.id}
                column={column}
                i={i}
                values={column.values}
                doAreaCalc={doAreaCalc}
                updateColumn={updateColumn}
                selectColumn={selectColumn}
                state={state}
                planRef={planRef}
                selected={column.selected}
                locked={isColumnGroupLocked(column.id)}
                gridScaleX={gridScaleX}
                gridScaleY={gridScaleY}
                color={column.color}
                onRotate={updateRotate}
                // synGroup={column.synGroup}
                // onGroupRotate={updateGroupRotate}
                // onDrop={updateDrop}
                dxfScale={overlayScale}
                flipY={shouldFlipY}
                worldHeight={worldHeightValue}
                stageYUp={isStageYUp}
                name={column.name}
                id={column.id}
                stageScale={liveStageScale}
                focusColumn={focusColumn}
                lanterns={column.values.lanterns}
                mountingType={column.values.mountingType}
                isMast={column.isMast}
                positionAngle={column.values.positionAngle}
                colorList={colors}
                luminaires={state.Plan.selectedLuminaires}
                updateLanternRotation={updateLanternRotation}
                updateLanternBeamEndpoint={updateLanternBeamEndpoint}
                updateLanterns={updateLanterns}
                polarInfo={polarInfo}
                fetchPolarInfo={fetchPolarInfo}
              />
            ))}
          </Layer>

          {reportCaptureAreas?.map((reportCapture, i) => {
            return (
              <ReportCapture
                key={reportCapture.id || i}
                i={i}
                selectReportCapture={selectReportCaptureArea}
                reportCapture={reportCapture}
                updateReportCapture={updateReportCaptureArea}
                stageScale={stage.scale}
                selected={reportCapture.selected}
                state={state}
              />
            );
          })}


          <Layer ref={linesLayerRef}>
            {lines?.map((line, i) => (
              <React.Fragment key={i}>
                <Line
                  points={line.points}
                  stroke="black"
                  strokeWidth={Math.max(0.01, 0.12 / stage.scale)}
                  opacity={0.5}
                  lineCap="round"
                  lineJoin="round"
                  globalCompositeOperation={
                    // line.tool === 'eraser' ? 'destination-out' : 'source-over'
                    "source-over"
                  }
                />
                {maskMode && isDrawing && i === lines.length - 1 && Array.isArray(line.points) && line.points.length >= 2 && (
                  <>
                    {(() => {
                      const closeThreshold = getPolygonCloseThreshold();
                      return (
                        <Circle
                          x={line.points[0]}
                          y={line.points[1]}
                          radius={closeThreshold}
                          fillEnabled={false}
                          stroke="black"
                          strokeWidth={Math.max(0.01, 0.12 / stage.scale)}
                          opacity={0.35}
                          listening={false}
                        />
                      );
                    })()}
                    <Circle
                      x={line.points[0]}
                      y={line.points[1]}
                      radius={Math.max(0.01, 0.08 / stage.scale)}
                      fill="black"
                      listening={false}
                    />
                  </>
                )}
              </React.Fragment>
            ))}
          </Layer>


          <Layer>
            {measureLine.length > 0 && (
              <Line
                points={measureLine}
                stroke="black"
                strokeWidth={Math.max(0.05, 1 / liveStageScale)}
                dash={[Math.max(0.2, 6 / liveStageScale), Math.max(0.1, 3 / liveStageScale)]}
              />
            )}
          </Layer>

          {showMark && markDetails ? (
            <Mark markDetails={markDetails} saveMark={handleSaveMark} dxfScale={overlayScale}
              gridScaleX={gridScaleX} gridScaleY={gridScaleY} stageScale={liveStageScale} />
          ) : null}

          {showMark && markDetails?.show && previewPoint && markDetails.snap && cursorType === "crosshair" && !maskMode && (
            <Layer>
              <Circle
                x={previewPoint.x * gridScaleX * overlayScale}
                y={previewPoint.y * gridScaleY * overlayScale}
                radius={Math.max(0.3, 4 / liveStageScale)}
                fill="rgba(65, 65, 65, 0.5)"
                stroke="gray"
                strokeWidth={Math.max(0.06, 1 / liveStageScale)}
                listening={false}
              />
            </Layer>
          )}
        </Stage>

        <Menu
          keepMounted
          open={contextMenu}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={
            contextMenuPosition
          }
        >
          <MenuItem onClick={handleDuplicatePoint}>Duplicate</MenuItem>
          <MenuItem onClick={handleDeletePoint}>Delete</MenuItem>
        </Menu>

      </div>
      {/* Right hand column */}
      <Grid
      // onContextMenu={handleContextMenu}
      >
        <Dialog
          open={addLuminOpen}
          disableEscapeKeyDown
          disableEnforceFocus
          hideBackdrop
          BackdropProps={{ open: false }}
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
        >
          <Box width={"600px"} className={"planStep-column-type2"}>
            <DialogTitle>Add Column Type</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <TextField
                  style={{ margin: '10px' }}
                  onChange={(e) => setLuminName(e.target.value)}
                  type="text"
                  value={luminName}
                  variant="outlined"
                  label="Custom Column Type Name"
                  autoFocus
                />
                <LuminCard index={numberOfLuminaires} page={"plan"} />
              </DialogContentText>
            </DialogContent>
            <div style={{ textAlign: "right", margin: 10 }}>
              <Button
                style={{ margin: '10px' }}
                onClick={(e) => handleAddLumin(e)}
                color={"primary"}
                variant="contained">
                <Typography>Add</Typography>
              </Button>
              <Button
                style={{ margin: '10px' }}
                onClick={(e) => handleAddLuminClose(e)}
                color={"primary"}
                variant="contained">
                <Typography>Cancel</Typography>
              </Button>
            </div>
          </Box>
        </Dialog>
        <Dialog
          open={luminInfoOpen}
          disableEscapeKeyDown
          disableEnforceFocus
          hideBackdrop
          BackdropProps={{ open: false }}
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
        >
          <DialogTitle>Column Type Info</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <PhotometricInformation index={infoLumin} />
            </DialogContentText>
          </DialogContent>
          <div style={{ textAlign: "right", margin: 10 }}>
            <Button
              onClick={toggleLuminInfoOpen}
              color={"primary"}
              variant="contained">
              <Typography>Close</Typography>
            </Button>
          </div>
        </Dialog>
        <Dialog
          open={luminSettingOpen}
          disableEscapeKeyDown
          disableEnforceFocus
          hideBackdrop
          BackdropProps={{ open: false }}
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
        >
          <DialogTitle>Column Type Setting</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <TextField
                style={{ margin: '10px' }}
                onChange={(e) => setLuminName(e.target.value)}
                type="text"
                value={luminName}
                variant="outlined"
                label="Custom Column Type Name"
                autoFocus
              />
              <Typography>Default Setting for Columns</Typography>
              <TextField
                label="Dim (%)"
                value={defaultColumnSettingValues?.dimFactor}
                onChange={(e) => handleChangeDefaultColumn(e)}
                style={{ margin: '10px' }}
                variant="outlined"
                type="number"
                name="dimFactor"
              />
              <TextField
                label="Height (m)"
                value={defaultColumnSettingValues?.height}
                onChange={(e) => handleChangeDefaultColumn(e)}
                style={{ margin: '10px' }}
                variant="outlined"
                type="number"
                name="height"
              />
              <TextField
                label="Maintenance Factor"
                value={defaultColumnSettingValues?.maintenanceFactor}
                onChange={(e) => handleChangeDefaultColumn(e)}
                style={{ margin: '10px' }}
                variant="outlined"
                type="number"
                name="maintenanceFactor"
              />
              <TextField
                label="Outreach (m)"
                value={defaultColumnSettingValues?.outreach}
                onChange={(e) => handleChangeDefaultColumn(e)}
                style={{ margin: '10px' }}
                variant="outlined"
                type="number"
                name="outreach"
              />
              <TextField
                label="Cant (°)"
                value={defaultColumnSettingValues?.cant}
                onChange={(e) => handleChangeDefaultColumn(e)}
                style={{ margin: '10px' }}
                variant="outlined"
                type="number"
                name="cant"
              />
              <TextField
                label="Tilt (°)"
                value={defaultColumnSettingValues?.tilt}
                onChange={(e) => handleChangeDefaultColumn(e)}
                style={{ margin: '10px' }}
                variant="outlined"
                type="number"
                name="tilt"
              />
              <Typography>Color</Typography>
              <HexColorPicker color={color} onChange={(e) => setColor(e)} />
              Selected Color: {color}
            </DialogContentText>
          </DialogContent>
          <div style={{ textAlign: "right", margin: 10 }}>
            <Button
              onClick={(e) => handleSaveLuminSetting(e)}
              color={"primary"}
              variant="contained">
              <Typography>Save</Typography>
            </Button>
            <Button
              onClick={(e) => handleAddSettingClose(e)}
              color={"primary"}
              variant="contained">
              <Typography>Close</Typography>
            </Button>
          </div>
        </Dialog>
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={toggleRightDrawer}
          variant='persistent'
          className={classes.drawer}
        >
          <Box
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '350px', height: '100%' }}
            className='planStep-right-toolbar'
          >

            <Accordion
              expanded={columnTypeOpen}
              onChange={() => setColumnTypeOpen(!columnTypeOpen)}
              style={{
                border: "1px solid rgba(0, 0, 0, .225)",
                boxShadow: "none",
                "&:not(:last-child)": {
                  borderBottom: 0,
                },
                "&:before": {
                  display: "none",
                }
              }}
              className={"planStep-column-type"}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Column Type</Typography>
              </AccordionSummary>
              <AccordionDetails style={{ display: 'flex', flexDirection: 'column', backgroundColor: "white", padding: 0 }}>
                {luminNameList == [] ? <></> : luminNameList?.map((luminName, id) => (
                  <List>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Tooltip title={luminName}>
                            <Typography
                              noWrap
                              sx={{
                                maxWidth: "150px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "block",
                              }}
                              style={{ userSelect: 'none' }}
                            >
                              {luminName && luminName.length > 17 ? `${luminName.slice(0, 16)}...` : luminName}
                            </Typography>
                          </Tooltip>
                        }
                        style={{ color: colors[id] }}
                      />
                      <ListItemSecondaryAction>
                        <Tooltip title="Add column">
                          <IconButton edge="end" aria-label="Add column" onClick={(e) => handleAddColumnClick(e, id)}>
                            <AddIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Setting">
                          <IconButton edge="end" aria-label="Setting" onClick={(e) => handleLuminSettingOpen(e, id)}>
                            <SettingsIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Info">
                          <IconButton edge="end" aria-label="Info" onClick={(e) => handleGetInfo(e, id)}>
                            <InfoIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton edge="end" aria-label="delete" onClick={(e) => handleDeleteLumin(e, id)}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                ))}
                <Tooltip title="Add Column Type" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <IconButton onClick={(e) => toggleLuminOpen()} style={{ padding: 5 }}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={columnsOpen}
              onChange={() => setColumnsOpen(!columnsOpen)}
              className={"planStep-column"}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
              >
                <Typography>Column</Typography>
              </AccordionSummary>
              <TextField
                fullWidth
                variant="standard"
                placeholder={"Search Columns..."}
                size="small"
                value={columnSearchTerm}
                onChange={handleColumnSearchChange}
                sx={{
                  "& fieldset": { border: "none" },
                  "& .MuiInput-underline:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:hover:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:after": { borderBottom: "2px solid black" },
                }}
                style={{
                  margin: "12px auto",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
              />
              <AccordionDetails style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '5px', padding: '5px' }}>
                <input
                  disabled={fileDisable}
                  type="file"
                  id="contained-button-file"
                  onChange={(e) => handleSelectCsv(e)}
                  multiple
                  className={classes.input}
                  accept=".csv"
                />
                <Button
                  color="primary"
                  variant="contained"
                  component="span"
                  onClick={() => {
                    handleImportCsv();
                  }}
                  className="MuiButton-textPrimary">
                  Import
                </Button>

                <Tooltip title="Export Columns as csv">
                  <Button onClick={handleExportColumnsAsCsv} color="primary" variant="contained" >
                    <Typography>Export Columns</Typography>
                  </Button>
                </Tooltip>
                <ColumnEditor deleteColumn={deleteColumn} selectColumn={selectColumn} columnList={columns} columns={filteredColumns} setColumns={handleSetColumns} setColumnsUiOnly={setColumns} focusColumn={focusColumn}
                  scale={gridScaleX} columnGroups={columnGroups} dxfScale={overlayScale} setSnack={setSnack} stageYUp={isStageYUp}
                  setColumnGroups={setColumnGroups} doAreaCalc={doAreaCalc} setMarkFromColumnCoords={handleSetMarkFromColumnCoords} />
                <IconButton onClick={handleAddGroupClick} fullWidth style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: 0, marginTop: '5px' }}>
                  <Tooltip title="Add Group" placement="top">
                    <AddIcon />
                  </Tooltip>
                </IconButton>
              </AccordionDetails>
            </Accordion>



            <Accordion
              expanded={gridsOpen}
              onChange={() => setGridsOpen(!gridsOpen)}
              className='planStep-grids'
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography>Grid</Typography>
              </AccordionSummary>

              <div style={{ margin: '10px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <TextField
                  style={{ width: '280px', marginBottom: '10px' }}
                  label="Standard"
                  name="calcStandard"
                  onChange={(e) => onStandardChange(e)}
                  select
                  SelectProps={{ native: true }}
                  value={selectedStandard}
                  variant="outlined"
                  inputProps={{
                    style: {
                      height: '20px',
                      padding: '5px',
                      textAlign: 'left'
                    }
                  }}
                >
                  {dropbox.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </TextField>

                <div style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <TextField
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                      setNewGridWidth(value);
                    }}
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                      const val = e.target.value;
                      e.target.value = '';
                      e.target.value = val;
                    }}
                    type="text"
                    value={newGridWidth}
                    variant="outlined"
                    label="Width"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      maxLength: 4,
                      style: { height: '20px', padding: '5px', textAlign: 'center' }
                    }}
                    style={{ width: '100px' }}
                  />

                  <TextField
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                      setNewGridHeight(value);
                    }}
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                      const val = e.target.value;
                      e.target.value = '';
                      e.target.value = val;
                    }}
                    type="text"
                    value={newGridHeight}
                    variant="outlined"
                    label="Height"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      maxLength: 4,
                      style: { height: '20px', padding: '5px', textAlign: 'center' }
                    }}
                    style={{ width: '100px' }}
                  />

                  <Tooltip title="Add grid">
                    <IconButton disabled={grids[0].id != 0} onClick={(e) => handleAddGrid(e)}>
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>


              <TextField
                fullWidth
                variant="standard"
                placeholder={"Search Grids..."}
                size="small"
                value={gridSearchTerm}
                onChange={handleGridSearchChange}
                sx={{
                  "& fieldset": { border: "none" },
                  "& .MuiInput-underline:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:hover:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:after": { borderBottom: "2px solid black" },
                }}
                style={{
                  margin: "8px auto",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
              />

              <AccordionDetails style={{ padding: '5px' }} className='planStep-grid-list'>
                <GridEditor
                  deleteGrid={deleteGrid}
                  selectGrid={selectGrid}
                  lockGrid={lockGrid}
                  grids={filteredGrids}
                  gridResults={areaResults}
                  updateGrid={updateGrid}
                  updateGridOnSave={updateGridOnSave}
                  updateGridResults={updateGridResults}
                  setSnack={setSnack}
                  setGridResultsMinimum={setGridResultsMinimum}
                />

              </AccordionDetails>
            </Accordion>



            <Accordion
              expanded={masksOpen}
              onChange={() => setMasksOpen(!masksOpen)}
              className={"planStep-masks"}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4a-content"
                id="panel4a-header"
              >
                <Typography>Mask</Typography>
              </AccordionSummary>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px' }}>
                <div style={{ display: 'flex', gap: '8px' }}>

                </div>

                {/* <Tooltip title="Drag and drop to reorder, Bottom is the highest layer" placement="top-start">
                  <InfoOutlinedIcon />
                </Tooltip> */}
              </div>

              <TextField
                fullWidth
                variant="standard"
                placeholder={"Search Masks..."}
                size="small"
                value={maskSearchTerm}
                onChange={handleMaskSearchChange}
                sx={{
                  "& fieldset": { border: "none" },
                  "& .MuiInput-underline:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:hover:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:after": { borderBottom: "2px solid black" },
                }}
                style={{
                  margin: "12px auto",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
              />

              <AccordionDetails style={{ padding: '5px' }}>
                <MaskEditor
                  deleteMask={deleteMask}
                  selectMask={selectMask}
                  updateMaskOrder={updateMaskOrder}
                  updateMask={updateMaskFields}
                  lockMask={lockMask}
                  masks={filteredMasks}
                  maskList={masks}
                />
              </AccordionDetails>
              <IconButton
                onClick={(event) => handleAddMask(event, "circle", true)}
                onContextMenu={(event) => handleAddMask(event, "circle", false)}
              >
                <Tooltip title="Left Click - Mask In / Right Click - Mask Out" placement='top'>
                  <PanoramaFishEyeIcon />
                </Tooltip>
              </IconButton>

              <IconButton
                onClick={(event) => handleAddMask(event, "rectangle", true)}
                onContextMenu={(event) => handleAddMask(event, "rectangle", false)}
              >
                <Tooltip title="Left Click - Mask In / Right Click - Mask Out" placement='top'>
                  <RectangleIcon />
                </Tooltip>
              </IconButton>

              <IconButton
                disabled={maskMode}
                onClick={() => {
                  setMaskMode(!maskMode);
                  setIsDrawing(!isDrawing);
                  setCursorType(cursorType == 'crosshair' ? 'default' : 'crosshair');
                  setPolyMaskIn(true)
                }}
                onContextMenu={(e) => {
                  e.preventDefault();
                  setMaskMode(!maskMode);
                  setIsDrawing(!isDrawing);
                  setCursorType(cursorType == 'crosshair' ? 'default' : 'crosshair');
                  setPolyMaskIn(false)
                }}
              >
                <Tooltip title="Left Click - Mask In / Right Click - Mask Out" placement='top'>
                  <TimelineIcon />
                </Tooltip>
              </IconButton>

              <IconButton onClick={() => { setShowAllMasks(!showAllMasks); }}>
                <Tooltip title={showAllMasks ? "Hide All Masks" : "Show All Masks"} placement='top'>
                  {showAllMasks ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </Tooltip>
              </IconButton>

            </Accordion>

            <Accordion
              expanded={saveConfigOpen}
              onChange={() => setSaveConfigOpen(!saveConfigOpen)}
              className={"planStep-save-config"}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel6a-content"
                id="panel6a-header"
              >
                <Typography>Saved Configurations</Typography>
              </AccordionSummary>
              <TextField
                style={{ margin: '10px' }}
                onChange={(e) => setConfigName(e.target.value)}
                type="text"
                value={configName}
                variant="outlined"
                label="Configuration Name"
                autoFocus
              />
              <Tooltip title="Save Current Config">
                <Button disabled={savingConfig} onClick={(e) => saveConfig(e, 0)} color="primary" variant="contained" style={{ margin: '20px' }}>
                  <Typography>Save</Typography>
                </Button>
              </Tooltip>
              <Typography
                variant="caption"
                color="textSecondary"
                style={{
                  marginLeft: '10px',
                  fontSize: '0.7rem',
                  whiteSpace: 'nowrap',
                  cursor: 'default',
                }}
              >
                {currentDrawingId && drawings ? `Using Drawing file: ${drawings?.find(drawing => drawing.id === currentDrawingId)?.name}` : ''}
              </Typography>
              <input
                disabled={fileDisable}
                type="file"
                id="contained-button-file"
                onChange={(e) => handleSelectLRPS(e)}
                multiple
                className={classes.input}
                accept=".LRPS"
                style={{
                  marginLeft: '10px',
                }}
              />
              <Button
                color="primary"
                variant="contained"
                component="span"
                onClick={() => {
                  handleImportLRPS();
                }}
                className="MuiButton-textPrimary">
                Import
              </Button>

              <AccordionDetails style={{ padding: '5px' }}>
                <TableContainer>
                  <Table style={{ width: "100%" }} size="small">
                    {!savedConfigs ? <></> :
                      <TableHead>
                        <TableRow>
                          <TableCell>Name</TableCell>
                          <TableCell>Export</TableCell>
                          <TableCell>Update</TableCell>
                          <TableCell>Delete</TableCell>
                        </TableRow>
                      </TableHead>
                    }
                    <TableBody>
                      <Draggable>
                        <Dialog
                          open={confirmOpen}
                          onClose={handleConfirmClose}
                          disableEscapeKeyDown
                          disableEnforceFocus
                          hideBackdrop
                          BackdropProps={{ open: false }}
                          PaperProps={{ style: { width: '350px' } }}
                          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
                        >
                          <DialogTitle id="alert-dialog-title"> {option} Configuration</DialogTitle>
                          <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                              Are you sure you want to {option} configuration {confirmItem?.description} ?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={(e) => handleConfirm(e)} color="primary">
                              Yes
                            </Button>
                            <Button onClick={handleConfirmClose} color="primary" autoFocus>
                              No
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Draggable>
                      {savedConfigs?.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell
                            onClick={() => handleOpenConfirm(item, 'Load')}
                          >
                            <Tooltip title={new Date(item.timestamp).toLocaleString()}>
                              <Typography
                                style={{
                                  cursor: 'pointer',
                                  color: '#000000',
                                  transition: 'color 0.2s ease',
                                  maxWidth: "150px",
                                }}
                                sx={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                  maxWidth: "150px",
                                }}
                                onMouseEnter={(e) => (e.target.style.color = '#007BFF')}
                                onMouseLeave={(e) => (e.target.style.color = '#000000')}
                              >
                                {item.description}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Tooltip title="Export">
                              <IconButton edge="end" aria-label="Export" onClick={() => handleOpenConfirm(item, 'Export')}>
                                <GetAppIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <IconButton onClick={() => handleOpenConfirm(item, 'Update')} color="primary">
                              <UpdateIcon />
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            <Tooltip title="Delete">
                              <IconButton edge="end" aria-label="delete" onClick={() => handleOpenConfirm(item, 'Delete')}
                                disabled={autoSaveConfigId === item.id}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
              <Dialog open={showLoadLatestDialog} onClose={() => handleLoadLatestConfig(false)}>
                <DialogTitle>Load Latest Configuration?</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Do you want to load the latest saved configuration: <b>{latestConfig?.description}</b>?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => handleLoadLatestConfig(true)} color="primary">Yes</Button>
                  <Button onClick={() => handleLoadLatestConfig(false)} color="primary" autoFocus>No</Button>
                </DialogActions>
              </Dialog>
              <Dialog open={templateEditorOpen} onClose={() => toggleTemplateEditor()} fullWidth maxWidth="md">
                <TemplateEditor selectedTemplate={selectedTemplate} reportElements={templateElements}
                  onClose={toggleTemplateEditor} handleSaveTemplate={handleSaveTemplate}
                />
              </Dialog>
            </Accordion>


            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel7a-content" id="panel7a-header">
                <Typography>Drawing Files</Typography>
              </AccordionSummary>

              <TextField
                fullWidth
                variant="standard"
                placeholder={"Search Drawings..."}
                size="small"
                value={drawingFileSearchTerm}
                onChange={handleDrawingFileSearchChange}
                sx={{
                  "& fieldset": { border: "none" },
                  "& .MuiInput-underline:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:hover:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:after": { borderBottom: "2px solid black" },
                }}
                style={{
                  margin: "12px auto",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
              />

              <Typography onClick={handleFileSort} variant="body2" align="center" style={{ margin: "10px 0", fontWeight: "bold", userSelect: "none", cursor: "pointer" }}>
                Sorting by: {getFileSortLabel()}
              </Typography>

              <AccordionDetails>
                <TableContainer style={{ overflowX: "hidden" }}>
                  <Table style={{ width: "100%" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          onClick={handleFileSort}
                          style={{ cursor: "pointer" }}
                        >
                          Name
                        </TableCell>
                        <TableCell>Update</TableCell>
                        <TableCell>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedDrawingFiles?.map((drawing, index) => (
                        <TableRow key={index}>
                          <TableCell style={{ cursor: "pointer", color: "#000000", transition: "color 0.2s ease" }}>
                            <div>
                              <Tooltip title={drawing.name} placement="top">
                                <Typography
                                  variant="body1"
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.9rem',
                                  }}
                                  onClick={() => handleSelectDrawing(drawing.id)}

                                  onMouseEnter={(e) => (e.target.style.color = '#007BFF')}
                                  onMouseLeave={(e) => (e.target.style.color = '#000000')}
                                >
                                  {drawing.name && drawing.name.length > 18 ? `${drawing.name.slice(0, 15)}...` : drawing.name}
                                </Typography>
                              </Tooltip>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                style={{
                                  fontSize: '0.7rem',
                                  whiteSpace: 'nowrap',
                                  cursor: 'default',
                                }}
                              >
                                Uploaded: {new Date(drawing.createDate).toLocaleDateString('en-GB')}
                              </Typography>
                            </div>
                          </TableCell>
                          <TableCell>
                            <IconButton onClick={() => handleUpdateClick(drawing.id)} color="primary">
                              <UpdateIcon />
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            <IconButton onClick={() => deleteDrawing(drawing.id)} color="inherit">
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={reportOpen}
              onChange={() => setReportOpen(!reportOpen)}
              className={"planStep-reports"}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4a-content"
                id="panel4a-header"
              >
                <Typography>Report</Typography>
              </AccordionSummary>

              <ReportActions
                handleAddReportCaptureArea={handleAddReportCaptureArea}
                //Report
                stageRef={stageRef}
                reportCaptureAreas={reportCaptureAreas}
                setReportCaptureAreas={setReportCaptureAreas}
                masks={masks}
                setMasks={setMasks}
                realWorldWidth={realWorldWidth}
                imagePixelWidth={imagePixelWidth}
                realWorldHeight={realWorldHeight}
                imagePixelHeight={imagePixelHeight}
                setSnack={setSnack}
                onTemplateChange={handleTemplateChange}
                selectedTemplate={selectedTemplate}
                grids={grids}
                areaGridResults={areaGridResults}
                areaResults={areaResults}
                columns={columns}
                gridScaleX={gridScaleX}
                gridScaleY={gridScaleY}
                dxfContainerRef={dxfContainerRef}
                dxfScale={overlayScale}
                dxfViewer={viewer}
                syncStageFromViewer={syncStageFromViewer}
                toggleTemplateEditor={toggleTemplateEditor}
                deleteTemplate={deleteTemplate}
                createTemplate={handleCreateTemplate}
                setTemplates={setTemplates}
                templates={templates}
              />

              <AccordionDetails>
                <ReportCaptureEditor
                  deleteReportCaptureArea={deleteReportCaptureArea}
                  selectReportCaptureArea={selectReportCaptureArea}
                  setReportCaptureAreas={setReportCaptureAreas}
                  lockReportCaptureArea={lockReportCaptureArea}
                  reportCaptureAreas={reportCaptureAreas}
                  selectedTemplate={selectedTemplate}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel7a-content" id="panel7a-header">
                <Typography>Drawing Layers</Typography>
              </AccordionSummary>

              <TextField
                fullWidth
                variant="standard"
                placeholder={"Search Layers..."}
                size="small"
                value={layerSearchTerm}
                onChange={handleLayerSearchChange}
                sx={{
                  "& fieldset": { border: "none" },
                  "& .MuiInput-underline:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:hover:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:after": { borderBottom: "2px solid black" },
                }}
                style={{
                  margin: "12px auto",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
              />

              <Typography onClick={handleSort} variant="body2" align="center" style={{ margin: "10px 0", fontWeight: "bold", userSelect: "none", cursor: "pointer" }}>
                Sorting by: {getSortLabel()}
              </Typography>
              <AccordionDetails>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                  {/* Toggle all layers - centered and above */}
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
                    <Checkbox
                      size="small"
                      color="primary"
                      checked={layers.length > 0 && layers.every(l => l.visible)}
                      indeterminate={layers.some(l => l.visible) && !layers.every(l => l.visible)}
                      onChange={e => {
                        const checked = e.target.checked;
                        setAllLayersVisible(checked);
                        toggleLayer("all", checked);
                      }}
                      id="toggle-all-layers"
                    />
                    <label htmlFor="toggle-all-layers" style={{ alignSelf: 'center', fontSize: 14, cursor: 'pointer' }}>
                      {layers.length > 0 && layers.every(l => l.visible) ? "Disable All Layers" : "Enable All Layers"}
                    </label>
                  </div>

                  {/* List of individual layers */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {layers
                      .filter(layer => layer.name.toLowerCase().includes(layerSearchTerm.toLowerCase()))
                      .sort((a, b) => {
                        switch (sortState) {
                          case "nameAsc": return a.name.localeCompare(b.name);
                          case "nameDesc": return b.name.localeCompare(a.name);
                          case "selectedAsc": return (a.visible === b.visible) ? 0 : a.visible ? -1 : 1;
                          case "selectedDesc": return (a.visible === b.visible) ? 0 : a.visible ? 1 : -1;
                          default: return 0;
                        }
                      })
                      .map(layer => (
                        <div
                          key={layer.name}
                          style={{ display: 'flex', alignItems: 'center', paddingLeft: 0 }}
                          onMouseEnter={() => highlightLayer(layer.name)}
                          onMouseLeave={() => resetHighlight(layer.name)}
                        >
                          <Checkbox
                            size="small"
                            color='primary'
                            checked={layer.visible}
                            onChange={() => toggleLayer(layer.name)}
                            id={`layer-checkbox-${layer.name}`}
                          />
                          <label htmlFor={`layer-checkbox-${layer.name}`} style={{ fontSize: 14, cursor: 'pointer' }}>
                            {layer.name}
                          </label>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </AccordionDetails>

            </Accordion>

            <div style={{ marginTop: 'auto', padding: '16px', textAlign: 'right' }}>
              <IconButton onClick={toggleRightDrawer}>
                <Typography>Close</Typography>
              </IconButton>
            </div>
          </Box>
        </Drawer>
        <div
          style={{
            position: 'fixed', // <-- or use flexbox as parent
            left: 0,
            right: 0,
            bottom: 0,
            height: '48px', // whatever height fits your design
            background: '#fff',
            borderTop: '1px solid #eee',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 24px',
            fontSize: '16px',
            boxSizing: 'border-box',
          }}
        >
          <IconButton onClick={toggleLeftDrawer}>
            {/* <ArrowForwardIosIcon style={{ display: 'flex', textAlign: 'right' }} /> */}
            <Typography>Tools</Typography>
          </IconButton>
          {hoverLayer && showTooltip && (
            <div
              style={{
                position: 'absolute',
                top: mousePosition.y + 8,
                left: mousePosition.x + 8,
                background: 'rgba(255,255,255,0.9)',
                padding: '2px 6px',
                border: '1px solid #333',
                borderRadius: 4,
                pointerEvents: 'none',
                zIndex: 20,
                fontSize: 12,
                color: '#000',
              }}
            >
              {hoverLayer}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
            X: {(mouseCoords.x / overlayScale).toFixed(2)} Y: {(mouseCoords.y / overlayScale).toFixed(2)} {measureMode && measureStartPoint ? `Distance: ${measureDistance.toFixed(2)} m` : ''}&nbsp;
            {(stageRef.current?.scaleX?.() || stage.scale) && (
              <span>
                Zoom:&nbsp;
                {isEditingScale ? (
                  <input
                    ref={scaleInputRef}
                    id="scaleInput"
                    type="text"
                    value={scaleInput}
                    onChange={handleScaleChange}
                    onBlur={handleScaleBlur}
                    onKeyPress={handleKeyPress}
                    style={{ width: '80px', textAlign: 'center' }}
                  />
                ) : (
                  <span onClick={handleTextClick} style={{ cursor: 'pointer' }}>
                    {((stageRef.current?.scaleX?.() ?? stage.scale) / 1.5).toFixed(2)}
                  </span>
                )}
              </span>
            )}
          </div>

          <IconButton onClick={toggleRightDrawer}>
            {/* <ArrowBackIosIcon style={{ display: 'flex', textAlign: 'left', alignItems: 'left', }} /> */}
            <Typography>Details</Typography>
          </IconButton>
        </div>
      </Grid >
      <Notification onClose={handleSnackClose} open={snack.open} severity={snack.severity} message={snack.message} action={snack.action} ></Notification>
      {/* <Loading open={isLoading} type={"backdrop"} text={"Loading Image"} /> */}
    </Page >
  );
}



